export const HamburgerIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="41"
            height="40"
            viewBox="0 0 41 40"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.1673 23.9974H29.834C30.5673 23.9974 31.1673 23.3974 31.1673 22.6641C31.1673 21.9307 30.5673 21.3307 29.834 21.3307H11.1673C10.434 21.3307 9.83398 21.9307 9.83398 22.6641C9.83398 23.3974 10.434 23.9974 11.1673 23.9974ZM11.1673 29.3307H29.834C30.5673 29.3307 31.1673 28.7307 31.1673 27.9974C31.1673 27.2641 30.5673 26.6641 29.834 26.6641H11.1673C10.434 26.6641 9.83398 27.2641 9.83398 27.9974C9.83398 28.7307 10.434 29.3307 11.1673 29.3307ZM11.1673 18.6641H29.834C30.5673 18.6641 31.1673 18.0641 31.1673 17.3307C31.1673 16.5974 30.5673 15.9974 29.834 15.9974H11.1673C10.434 15.9974 9.83398 16.5974 9.83398 17.3307C9.83398 18.0641 10.434 18.6641 11.1673 18.6641ZM9.83398 11.9974C9.83398 12.7307 10.434 13.3307 11.1673 13.3307H29.834C30.5673 13.3307 31.1673 12.7307 31.1673 11.9974C31.1673 11.2641 30.5673 10.6641 29.834 10.6641H11.1673C10.434 10.6641 9.83398 11.2641 9.83398 11.9974Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const TrophyIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                d="M9.25 26.25V23.75H14.25V19.875C13.2292 19.6458 12.3177 19.2135 11.5156 18.5781C10.7135 17.9427 10.125 17.1458 9.75 16.1875C8.1875 16 6.88021 15.3177 5.82812 14.1406C4.77604 12.9635 4.25 11.5833 4.25 10V8.75C4.25 8.0625 4.49479 7.47396 4.98438 6.98438C5.47396 6.49479 6.0625 6.25 6.75 6.25H9.25V3.75H21.75V6.25H24.25C24.9375 6.25 25.526 6.49479 26.0156 6.98438C26.5052 7.47396 26.75 8.0625 26.75 8.75V10C26.75 11.5833 26.224 12.9635 25.1719 14.1406C24.1198 15.3177 22.8125 16 21.25 16.1875C20.875 17.1458 20.2865 17.9427 19.4844 18.5781C18.6823 19.2135 17.7708 19.6458 16.75 19.875V23.75H21.75V26.25H9.25ZM9.25 13.5V8.75H6.75V10C6.75 10.7917 6.97917 11.5052 7.4375 12.1406C7.89583 12.776 8.5 13.2292 9.25 13.5ZM15.5 17.5C16.5417 17.5 17.4271 17.1354 18.1562 16.4062C18.8854 15.6771 19.25 14.7917 19.25 13.75V6.25H11.75V13.75C11.75 14.7917 12.1146 15.6771 12.8438 16.4062C13.5729 17.1354 14.4583 17.5 15.5 17.5ZM21.75 13.5C22.5 13.2292 23.1042 12.776 23.5625 12.1406C24.0208 11.5052 24.25 10.7917 24.25 10V8.75H21.75V13.5Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const FitnessIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6525 17.4425L24.3725 16.7225C24.7625 16.3325 24.7625 15.7025 24.3725 15.3125L24.3525 15.2925C24.1657 15.1052 23.912 15 23.6475 15C23.383 15 23.1293 15.1052 22.9425 15.2925L20.0825 18.1525L11.5125 9.5825L14.3725 6.7225C14.7625 6.3325 14.7625 5.7025 14.3725 5.3125L14.3525 5.2925C14.1657 5.10525 13.912 5.00001 13.6475 5.00001C13.383 5.00001 13.1293 5.10525 12.9425 5.2925L12.2225 6.0125L11.5025 5.2925C11.1125 4.9025 10.4725 4.9025 10.0825 5.2925L8.6525 6.7225L7.9325 6.0025C7.5425 5.6125 6.8925 5.6125 6.5025 6.0025C6.1125 6.3925 6.1125 7.0425 6.5025 7.4325L7.2225 8.1525L5.7925 9.5825C5.4025 9.9725 5.4025 10.6025 5.7925 10.9925L6.5125 11.7125L5.7925 12.4425C5.4025 12.8325 5.4025 13.4625 5.7925 13.8525L5.8125 13.8725C6.2025 14.2625 6.8325 14.2625 7.2225 13.8725L10.0825 11.0125L18.6525 19.5825L15.7925 22.4425C15.4025 22.8325 15.4025 23.4625 15.7925 23.8525L15.8125 23.8725C16.2025 24.2625 16.8325 24.2625 17.2225 23.8725L17.9425 23.1525L18.6625 23.8725C19.0525 24.2625 19.6825 24.2625 20.0725 23.8725L21.5025 22.4425L22.2225 23.1625C22.6125 23.5525 23.2625 23.5525 23.6525 23.1625C24.0425 22.7725 24.0425 22.1225 23.6525 21.7325L22.9325 21.0125L24.3725 19.5825C24.7625 19.1925 24.7625 18.5625 24.3725 18.1725L23.6525 17.4425Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const AccountBalanceIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5 15.2425V19.2425C8.5 20.0725 9.17 20.7425 10 20.7425C10.83 20.7425 11.5 20.0725 11.5 19.2425V15.2425C11.5 14.4125 10.83 13.7425 10 13.7425C9.17 13.7425 8.5 14.4125 8.5 15.2425ZM14.5 15.2425V19.2425C14.5 20.0725 15.17 20.7425 16 20.7425C16.83 20.7425 17.5 20.0725 17.5 19.2425V15.2425C17.5 14.4125 16.83 13.7425 16 13.7425C15.17 13.7425 14.5 14.4125 14.5 15.2425ZM8 25.7425H24C24.83 25.7425 25.5 25.0725 25.5 24.2425C25.5 23.4125 24.83 22.7425 24 22.7425H8C7.17 22.7425 6.5 23.4125 6.5 24.2425C6.5 25.0725 7.17 25.7425 8 25.7425ZM20.5 15.2425V19.2425C20.5 20.0725 21.17 20.7425 22 20.7425C22.83 20.7425 23.5 20.0725 23.5 19.2425V15.2425C23.5 14.4125 22.83 13.7425 22 13.7425C21.17 13.7425 20.5 14.4125 20.5 15.2425ZM15.07 5.2325L7.17 9.3925C6.76 9.6025 6.5 10.0325 6.5 10.4925C6.5 11.1825 7.06 11.7425 7.75 11.7425H24.26C24.94 11.7425 25.5 11.1825 25.5 10.4925C25.5 10.0325 25.24 9.6025 24.83 9.3925L16.93 5.2325C16.35 4.9225 15.65 4.9225 15.07 5.2325Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const SocialDomainIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5 10V8C15.5 6.9 14.6 6 13.5 6H7.5C6.4 6 5.5 6.9 5.5 8V22C5.5 23.1 6.4 24 7.5 24H23.5C24.6 24 25.5 23.1 25.5 22V12C25.5 10.9 24.6 10 23.5 10H15.5ZM9.5 22H7.5V20H9.5V22ZM9.5 18H7.5V16H9.5V18ZM9.5 14H7.5V12H9.5V14ZM9.5 10H7.5V8H9.5V10ZM13.5 22H11.5V20H13.5V22ZM13.5 18H11.5V16H13.5V18ZM13.5 14H11.5V12H13.5V14ZM13.5 10H11.5V8H13.5V10ZM22.5 22H15.5V20H17.5V18H15.5V16H17.5V14H15.5V12H22.5C23.05 12 23.5 12.45 23.5 13V21C23.5 21.55 23.05 22 22.5 22ZM21.5 14H19.5V16H21.5V14ZM21.5 18H19.5V20H21.5V18Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const DateRangeIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.5 7H21.5V6C21.5 5.45 21.05 5 20.5 5C19.95 5 19.5 5.45 19.5 6V7H11.5V6C11.5 5.45 11.05 5 10.5 5C9.95 5 9.5 5.45 9.5 6V7H8.5C7.39 7 6.51 7.9 6.51 9L6.5 23C6.5 24.1 7.39 25 8.5 25H22.5C23.6 25 24.5 24.1 24.5 23V9C24.5 7.9 23.6 7 22.5 7ZM22.5 22C22.5 22.55 22.05 23 21.5 23H9.5C8.95 23 8.5 22.55 8.5 22V12H22.5V22ZM10.5 14H12.5V16H10.5V14ZM14.5 14H16.5V16H14.5V14ZM18.5 14H20.5V16H18.5V14Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const DirectionRunIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.9202 8C19.0202 8 19.9202 7.1 19.9202 6C19.9202 4.9 19.0202 4 17.9202 4C16.8202 4 15.9202 4.9 15.9202 6C15.9202 7.1 16.8202 8 17.9202 8ZM14.7502 20L15.3202 17.5L17.4202 19.5V24.5C17.4202 25.05 17.8702 25.5 18.4202 25.5C18.9702 25.5 19.4202 25.05 19.4202 24.5V18.86C19.4202 18.31 19.2002 17.79 18.8002 17.41L17.3202 16L17.9202 13C18.9902 14.24 20.5402 15.13 22.2802 15.41C22.8802 15.5 23.4202 15.02 23.4202 14.41C23.4202 13.92 23.0602 13.51 22.5702 13.43C21.0502 13.18 19.7902 12.28 19.1202 11.1L18.1202 9.5C17.7202 8.9 17.1202 8.5 16.4202 8.5C16.1202 8.5 15.9202 8.6 15.6202 8.6L11.6402 10.28C10.9002 10.6 10.4202 11.32 10.4202 12.13V14.5C10.4202 15.05 10.8702 15.5 11.4202 15.5C11.9702 15.5 12.4202 15.05 12.4202 14.5V12.1L14.2202 11.4L12.6202 19.5L8.70022 18.7C8.16022 18.59 7.63022 18.94 7.52022 19.48V19.52C7.41022 20.06 7.76022 20.59 8.30022 20.7L12.4102 21.52C13.4702 21.73 14.5102 21.06 14.7502 20Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const LayerIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.4825 21.54C16.1225 21.82 15.6125 21.82 15.2525 21.54L9.1025 16.76C8.74402 16.48 8.24098 16.48 7.8825 16.76C7.3725 17.16 7.3725 17.93 7.8825 18.33L14.6425 23.59C15.3625 24.15 16.3725 24.15 17.1025 23.59L23.8625 18.33C24.3725 17.93 24.3725 17.16 23.8625 16.76L23.8525 16.75C23.494 16.47 22.991 16.47 22.6325 16.75L16.4825 21.54ZM17.1125 18.52L23.8725 13.26C24.3825 12.86 24.3825 12.08 23.8725 11.68L17.1125 6.42C16.3925 5.86 15.3825 5.86 14.6525 6.42L7.8925 11.69C7.3825 12.09 7.3825 12.87 7.8925 13.27L14.6525 18.53C15.3725 19.09 16.3925 19.09 17.1125 18.52Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const MonetizationIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5 5C9.98 5 5.5 9.48 5.5 15C5.5 20.52 9.98 25 15.5 25C21.02 25 25.5 20.52 25.5 15C25.5 9.48 21.02 5 15.5 5ZM16.91 21.09V21.67C16.91 22.4 16.31 23 15.58 23H15.57C14.84 23 14.24 22.4 14.24 21.67V21.07C12.91 20.79 11.73 20.06 11.23 18.83C11 18.28 11.43 17.67 12.03 17.67H12.27C12.64 17.67 12.94 17.92 13.08 18.27C13.37 19.02 14.13 19.54 15.59 19.54C17.55 19.54 17.99 18.56 17.99 17.95C17.99 17.12 17.55 16.34 15.32 15.81C12.84 15.21 11.14 14.19 11.14 12.14C11.14 10.42 12.53 9.3 14.25 8.93V8.33C14.25 7.6 14.85 7 15.58 7H15.59C16.32 7 16.92 7.6 16.92 8.33V8.95C18.3 9.29 19.17 10.15 19.55 11.21C19.75 11.76 19.33 12.34 18.74 12.34H18.48C18.11 12.34 17.81 12.08 17.71 11.72C17.48 10.96 16.85 10.47 15.59 10.47C14.09 10.47 13.19 11.15 13.19 12.11C13.19 12.95 13.84 13.5 15.86 14.02C17.88 14.54 20.04 15.41 20.04 17.93C20.02 19.76 18.65 20.76 16.91 21.09Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const SocialPeopleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.5 14C21.16 14 22.49 12.66 22.49 11C22.49 9.34 21.16 8 19.5 8C17.84 8 16.5 9.34 16.5 11C16.5 12.66 17.84 14 19.5 14ZM11.5 14C13.16 14 14.49 12.66 14.49 11C14.49 9.34 13.16 8 11.5 8C9.84 8 8.5 9.34 8.5 11C8.5 12.66 9.84 14 11.5 14ZM11.5 16C9.17 16 4.5 17.17 4.5 19.5V21C4.5 21.55 4.95 22 5.5 22H17.5C18.05 22 18.5 21.55 18.5 21V19.5C18.5 17.17 13.83 16 11.5 16ZM19.5 16C19.21 16 18.88 16.02 18.53 16.05C18.55 16.06 18.56 16.08 18.57 16.09C19.71 16.92 20.5 18.03 20.5 19.5V21C20.5 21.35 20.43 21.69 20.32 22H25.5C26.05 22 26.5 21.55 26.5 21V19.5C26.5 17.17 21.83 16 19.5 16Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const PermContactCalendarIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.5 7H21.5V6C21.5 5.45 21.05 5 20.5 5C19.95 5 19.5 5.45 19.5 6V7H11.5V6C11.5 5.45 11.05 5 10.5 5C9.95 5 9.5 5.45 9.5 6V7H8.5C7.39 7 6.5 7.9 6.5 9V23C6.5 24.1 7.4 25 8.5 25H22.5C23.6 25 24.5 24.1 24.5 23V9C24.5 7.9 23.6 7 22.5 7ZM15.5 10C17.16 10 18.5 11.34 18.5 13C18.5 14.66 17.16 16 15.5 16C13.84 16 12.5 14.66 12.5 13C12.5 11.34 13.84 10 15.5 10ZM21.5 22H9.5V21C9.5 19 13.5 17.9 15.5 17.9C17.5 17.9 21.5 19 21.5 21V22Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const EnlargePlusIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.8004 12.7984H12.8004V16.7984C12.8004 17.2384 12.4404 17.5984 12.0004 17.5984C11.5604 17.5984 11.2004 17.2384 11.2004 16.7984V12.7984H7.20039C6.76039 12.7984 6.40039 12.4384 6.40039 11.9984C6.40039 11.5584 6.76039 11.1984 7.20039 11.1984H11.2004V7.19844C11.2004 6.75844 11.5604 6.39844 12.0004 6.39844C12.4404 6.39844 12.8004 6.75844 12.8004 7.19844V11.1984H16.8004C17.2404 11.1984 17.6004 11.5584 17.6004 11.9984C17.6004 12.4384 17.2404 12.7984 16.8004 12.7984Z"
                fill="currentColor"
            />
        </svg>
    )
}
export const MinimizeMinusIcon = () => {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.999219 0.203125H8.99922C9.43922 0.203125 9.79922 0.563125 9.79922 1.00313C9.79922 1.44313 9.43922 1.80313 8.99922 1.80313H0.999219C0.559219 1.80313 0.199219 1.44313 0.199219 1.00313C0.199219 0.563125 0.559219 0.203125 0.999219 0.203125Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const RecentActorsIcon = () => {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.5 9V21C24.5 21.55 24.95 22 25.5 22C26.05 22 26.5 21.55 26.5 21V9C26.5 8.45 26.05 8 25.5 8C24.95 8 24.5 8.45 24.5 9ZM21.5 22C22.05 22 22.5 21.55 22.5 21V9C22.5 8.45 22.05 8 21.5 8C20.95 8 20.5 8.45 20.5 9V21C20.5 21.55 20.95 22 21.5 22ZM17.5 8H5.5C4.95 8 4.5 8.45 4.5 9V21C4.5 21.55 4.95 22 5.5 22H17.5C18.05 22 18.5 21.55 18.5 21V9C18.5 8.45 18.05 8 17.5 8ZM11.5 10.75C12.74 10.75 13.75 11.76 13.75 13C13.75 14.24 12.74 15.25 11.5 15.25C10.26 15.25 9.25 14.24 9.25 13C9.25 11.76 10.26 10.75 11.5 10.75ZM16 20H7V19.25C7 17.75 10 17 11.5 17C13 17 16 17.75 16 19.25V20Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const BodySystemIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                d="M10.375 22.5L12.75 11.125L10.5 12V15H8V10.375L14.3125 7.71875C14.6042 7.59375 14.9115 7.51562 15.2344 7.48438C15.5573 7.45312 15.8646 7.48958 16.1562 7.59375C16.4479 7.69792 16.724 7.84375 16.9844 8.03125C17.2448 8.21875 17.4583 8.45833 17.625 8.75L18.875 10.75C19.4583 11.6875 20.224 12.4219 21.1719 12.9531C22.1198 13.4844 23.1458 13.75 24.25 13.75V16.25C22.7917 16.25 21.4844 15.9583 20.3281 15.375C19.1719 14.7917 18.1875 14.0417 17.375 13.125L16.625 15L19.25 17.5V22.5H16.75V18.6875L14.3125 16.4375L13 22.5H10.375ZM17.375 6.875C16.6875 6.875 16.099 6.63021 15.6094 6.14062C15.1198 5.65104 14.875 5.0625 14.875 4.375C14.875 3.6875 15.1198 3.09896 15.6094 2.60938C16.099 2.11979 16.6875 1.875 17.375 1.875C18.0625 1.875 18.651 2.11979 19.1406 2.60938C19.6302 3.09896 19.875 3.6875 19.875 4.375C19.875 5.0625 19.6302 5.65104 19.1406 6.14062C18.651 6.63021 18.0625 6.875 17.375 6.875ZM15.5 27.5C13.7708 27.5 12.1458 27.1719 10.625 26.5156C9.10417 25.8594 7.78125 24.9688 6.65625 23.8438C5.53125 22.7188 4.64062 21.3958 3.98438 19.875C3.32812 18.3542 3 16.7292 3 15C3 12.5208 3.64062 10.2917 4.92188 8.3125C6.20312 6.33333 7.875 4.83333 9.9375 3.8125L11.0625 6.03125C9.41667 6.84375 8.07812 8.04688 7.04688 9.64062C6.01562 11.2344 5.5 13.0208 5.5 15C5.5 17.7917 6.46875 20.1562 8.40625 22.0938C10.3438 24.0312 12.7083 25 15.5 25C18.2917 25 20.6562 24.0312 22.5938 22.0938C24.5312 20.1562 25.5 17.7917 25.5 15H28C28 16.7292 27.6719 18.3542 27.0156 19.875C26.3594 21.3958 25.4688 22.7188 24.3438 23.8438C23.2188 24.9688 21.8958 25.8594 20.375 26.5156C18.8542 27.1719 17.2292 27.5 15.5 27.5Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const SettingsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.6593 15.98C22.6993 15.66 22.7293 15.34 22.7293 15C22.7293 14.66 22.6993 14.34 22.6593 14.02L24.7693 12.37C24.9593 12.22 25.0093 11.95 24.8893 11.73L22.8893 8.27C22.7693 8.05 22.4993 7.97 22.2793 8.05L19.7893 9.05C19.2693 8.65 18.7093 8.32 18.0993 8.07L17.7193 5.42C17.6893 5.18 17.4793 5 17.2293 5H13.2293C12.9793 5 12.7693 5.18 12.7393 5.42L12.3593 8.07C11.7493 8.32 11.1893 8.66 10.6693 9.05L8.17933 8.05C7.94933 7.96 7.68933 8.05 7.56933 8.27L5.56933 11.73C5.43933 11.95 5.49933 12.22 5.68933 12.37L7.79933 14.02C7.75933 14.34 7.72933 14.67 7.72933 15C7.72933 15.33 7.75933 15.66 7.79933 15.98L5.68933 17.63C5.49933 17.78 5.44933 18.05 5.56933 18.27L7.56933 21.73C7.68933 21.95 7.95933 22.03 8.17933 21.95L10.6693 20.95C11.1893 21.35 11.7493 21.68 12.3593 21.93L12.7393 24.58C12.7693 24.82 12.9793 25 13.2293 25H17.2293C17.4793 25 17.6893 24.82 17.7193 24.58L18.0993 21.93C18.7093 21.68 19.2693 21.34 19.7893 20.95L22.2793 21.95C22.5093 22.04 22.7693 21.95 22.8893 21.73L24.8893 18.27C25.0093 18.05 24.9593 17.78 24.7693 17.63L22.6593 15.98ZM15.2293 18.5C13.2993 18.5 11.7293 16.93 11.7293 15C11.7293 13.07 13.2993 11.5 15.2293 11.5C17.1593 11.5 18.7293 13.07 18.7293 15C18.7293 16.93 17.1593 18.5 15.2293 18.5Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const StyleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.73493 21.9L8.07493 22.46V13.43L5.64493 19.29C5.23493 20.31 5.72493 21.48 6.73493 21.9ZM26.2349 18.2L21.2749 6.23C20.9649 5.48 20.2349 5.02 19.4649 5C19.2049 5 18.9349 5.04 18.6749 5.15L11.3049 8.2C10.5549 8.51 10.0949 9.23 10.0749 10C10.0649 10.27 10.1149 10.54 10.2249 10.8L15.1849 22.77C15.4949 23.53 16.2349 23.99 17.0149 24C17.2749 24 17.5349 23.95 17.7849 23.85L25.1449 20.8C26.1649 20.38 26.6549 19.21 26.2349 18.2ZM12.0849 11C11.5349 11 11.0849 10.55 11.0849 10C11.0849 9.45 11.5349 9 12.0849 9C12.6349 9 13.0849 9.45 13.0849 10C13.0849 10.55 12.6349 11 12.0849 11ZM10.0849 22C10.0849 23.1 10.9849 24 12.0849 24H13.5349L10.0849 15.66V22Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const ArtTrackIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.5 16H18.5C17.95 16 17.5 15.55 17.5 15C17.5 14.45 17.95 14 18.5 14H24.5C25.05 14 25.5 14.45 25.5 15C25.5 15.55 25.05 16 24.5 16ZM24.5 10H18.5C17.95 10 17.5 10.45 17.5 11C17.5 11.55 17.95 12 18.5 12H24.5C25.05 12 25.5 11.55 25.5 11C25.5 10.45 25.05 10 24.5 10ZM18.5 20H24.5C25.05 20 25.5 19.55 25.5 19C25.5 18.45 25.05 18 24.5 18H18.5C17.95 18 17.5 18.45 17.5 19C17.5 19.55 17.95 20 18.5 20ZM15.5 12V18C15.5 19.1 14.6 20 13.5 20H7.5C6.4 20 5.5 19.1 5.5 18V12C5.5 10.9 6.4 10 7.5 10H13.5C14.6 10 15.5 10.9 15.5 12ZM13.4 17.2L12.14 15.52C11.94 15.26 11.55 15.25 11.34 15.51L10 17.26L9.15 16.23C8.95 15.98 8.57 15.99 8.37 16.24L7.63 17.19C7.37 17.52 7.61 18 8.02 18H13C13.41 18 13.65 17.53 13.4 17.2Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const EventNoteIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.5 14H11.5C10.95 14 10.5 14.45 10.5 15C10.5 15.55 10.95 16 11.5 16H19.5C20.05 16 20.5 15.55 20.5 15C20.5 14.45 20.05 14 19.5 14ZM22.5 7H21.5V6C21.5 5.45 21.05 5 20.5 5C19.95 5 19.5 5.45 19.5 6V7H11.5V6C11.5 5.45 11.05 5 10.5 5C9.95 5 9.5 5.45 9.5 6V7H8.5C7.39 7 6.5 7.9 6.5 9V23C6.5 24.1 7.39 25 8.5 25H22.5C23.6 25 24.5 24.1 24.5 23V9C24.5 7.9 23.6 7 22.5 7ZM21.5 23H9.5C8.95 23 8.5 22.55 8.5 22V12H22.5V22C22.5 22.55 22.05 23 21.5 23ZM16.5 18H11.5C10.95 18 10.5 18.45 10.5 19C10.5 19.55 10.95 20 11.5 20H16.5C17.05 20 17.5 19.55 17.5 19C17.5 18.45 17.05 18 16.5 18Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const PanoramaIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.5 21V9C26.5 7.9 25.6 7 24.5 7H6.5C5.4 7 4.5 7.9 4.5 9V21C4.5 22.1 5.4 23 6.5 23H24.5C25.6 23 26.5 22.1 26.5 21ZM12.4 15.98L14.5 18.51L17.6 14.52C17.8 14.26 18.2 14.26 18.4 14.53L21.91 19.21C22.16 19.54 21.92 20.01 21.51 20.01H9.52C9.1 20.01 8.87 19.53 9.13 19.2L11.62 16C11.81 15.74 12.19 15.73 12.4 15.98Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const FolderIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.09 7.59C13.71 7.21 13.2 7 12.67 7H7.5C6.4 7 5.51 7.9 5.51 9L5.5 21C5.5 22.1 6.4 23 7.5 23H23.5C24.6 23 25.5 22.1 25.5 21V11C25.5 9.9 24.6 9 23.5 9H15.5L14.09 7.59Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const AccountCircle = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 5C9.48 5 5 9.48 5 15C5 20.52 9.48 25 15 25C20.52 25 25 20.52 25 15C25 9.48 20.52 5 15 5ZM15 8C16.66 8 18 9.34 18 11C18 12.66 16.66 14 15 14C13.34 14 12 12.66 12 11C12 9.34 13.34 8 15 8ZM15 22.2C12.5 22.2 10.29 20.92 9 18.98C9.03 16.99 13 15.9 15 15.9C16.99 15.9 20.97 16.99 21 18.98C19.71 20.92 17.5 22.2 15 22.2Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const FileCopyIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 4H8C6.9 4 6 4.9 6 6V19C6 19.55 6.45 20 7 20C7.55 20 8 19.55 8 19V7C8 6.45 8.45 6 9 6H19C19.55 6 20 5.55 20 5C20 4.45 19.55 4 19 4ZM19.59 8.59L24.42 13.42C24.79 13.79 25 14.3 25 14.83V24C25 25.1 24.1 26 23 26H11.99C10.89 26 10 25.1 10 24L10.01 10C10.01 8.9 10.9 8 12 8H18.17C18.7 8 19.21 8.21 19.59 8.59ZM19 15H23.5L18 9.5V14C18 14.55 18.45 15 19 15Z"
                fill="#4F5480"
            />
        </svg>
    )
}

export const HistoryIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.5515 6.00349C11.4615 5.86349 7.29153 9.95349 7.29153 15.0035H5.50153C5.05153 15.0035 4.83153 15.5435 5.15153 15.8535L7.94153 18.6535C8.14153 18.8535 8.45153 18.8535 8.65153 18.6535L11.4415 15.8535C11.7515 15.5435 11.5315 15.0035 11.0815 15.0035H9.29153C9.29153 11.1035 12.4715 7.95349 16.3915 8.00349C20.1115 8.05349 23.2415 11.1835 23.2915 14.9035C23.3415 18.8135 20.1915 22.0035 16.2915 22.0035C14.6815 22.0035 13.1915 21.4535 12.0115 20.5235C11.6115 20.2135 11.0515 20.2435 10.6915 20.6035C10.2715 21.0235 10.3015 21.7335 10.7715 22.0935C12.2915 23.2935 14.2015 24.0035 16.2915 24.0035C21.3415 24.0035 25.4315 19.8335 25.2915 14.7435C25.1615 10.0535 21.2415 6.13349 16.5515 6.00349ZM16.0415 11.0035C15.6315 11.0035 15.2915 11.3435 15.2915 11.7535V15.4335C15.2915 15.7835 15.4815 16.1135 15.7815 16.2935L18.9015 18.1435C19.2615 18.3535 19.7215 18.2335 19.9315 17.8835C20.1415 17.5235 20.0215 17.0635 19.6715 16.8535L16.7915 15.1435V11.7435C16.7915 11.3435 16.4515 11.0035 16.0415 11.0035Z"
                fill="#9194AF"
            />
        </svg>
    )
}
export const ChatBubbleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23 5H7C5.9 5 5 5.9 5 7V25L9 21H23C24.1 21 25 20.1 25 19V7C25 5.9 24.1 5 23 5Z"
                fill="#9194AF"
            />
        </svg>
    )
}

export const AccountBoxIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 8V22C6 23.1 6.89 24 8 24H22C23.1 24 24 23.1 24 22V8C24 6.9 23.1 6 22 6H8C6.89 6 6 6.9 6 8ZM18 12C18 13.66 16.66 15 15 15C13.34 15 12 13.66 12 12C12 10.34 13.34 9 15 9C16.66 9 18 10.34 18 12ZM9 20C9 18 13 16.9 15 16.9C17 16.9 21 18 21 20V21H9V20Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const PencilIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.59961 19.0999V21.9372C5.59961 22.1985 5.80494 22.4039 6.06628 22.4039H8.90361C9.02494 22.4039 9.14628 22.3572 9.23028 22.2639L19.4223 12.0812L15.9223 8.58122L5.73961 18.7639C5.64628 18.8572 5.59961 18.9692 5.59961 19.0999ZM22.1289 9.37455C22.4929 9.01055 22.4929 8.42255 22.1289 8.05855L19.9449 5.87455C19.7706 5.69978 19.5338 5.60156 19.2869 5.60156C19.0401 5.60156 18.8033 5.69978 18.6289 5.87455L16.9209 7.58255L20.4209 11.0825L22.1289 9.37455Z"
                fill="white"
            />
        </svg>
    )
}

export const InputIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 6H6C4.9 6 4 6.9 4 8V10.99C4 11.54 4.45 11.99 5 11.99C5.55 11.99 6 11.54 6 10.99V8.98C6 8.43 6.45 7.98 7 7.98H23C23.55 7.98 24 8.43 24 8.98V21.01C24 21.56 23.55 22.01 23 22.01H7C6.45 22.01 6 21.56 6 21.01V18.99C6 18.44 5.55 17.99 5 17.99C4.45 17.99 4 18.44 4 18.99V22C4 23.09 4.89 23.98 5.98 23.98H24C25.1 23.98 26 23.08 26 21.98V8C26 6.9 25.1 6 24 6ZM14.85 18.14L17.64 15.35C17.84 15.15 17.84 14.84 17.64 14.64L14.85 11.85C14.54 11.53 14 11.75 14 12.2V13.99H5C4.45 13.99 4 14.44 4 14.99C4 15.54 4.45 15.99 5 15.99H14V17.78C14 18.23 14.54 18.45 14.85 18.14Z"
                fill="#E62E2E"
            />
        </svg>
    )
}

export const PageViewIcon = () => {
    return (
        <path
            width="30"
            stroke="none"
            height="30"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5 12C13.12 12 12 13.12 12 14.5C12 15.88 13.12 17 14.5 17C15.88 17 17 15.88 17 14.5C17 13.12 15.88 12 14.5 12ZM23 7H7C5.9 7 5 7.9 5 9V21C5 22.1 5.9 23 7 23H23C24.1 23 25 22.1 25 21V9C25 7.9 24.1 7 23 7ZM19.08 20.5L16.88 18.3C15.98 18.88 14.85 19.14 13.66 18.92C11.78 18.57 10.28 16.99 10.04 15.09C9.66 12.08 12.22 9.57 15.25 10.05C17.13 10.35 18.64 11.89 18.95 13.76C19.14 14.92 18.87 15.99 18.31 16.88L20.51 19.07C20.9 19.46 20.9 20.1 20.51 20.49C20.11 20.89 19.47 20.89 19.08 20.5Z"
            fill="#C3CAD9"
        />
    )
}

export const VerifiedUserIcon = () => {
    return (
        <path
            stroke="none"
            width="28"
            height="28"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2436 3.89537L6.71028 6.79804C6.03828 7.09671 5.59961 7.76871 5.59961 8.50604V12.8927C5.59961 18.0727 9.18361 22.9167 13.9996 24.0927C18.8156 22.9167 22.3996 18.0727 22.3996 12.8927V8.50604C22.3996 7.76871 21.9609 7.09671 21.2889 6.79804L14.7556 3.89537C14.2796 3.68071 13.7196 3.68071 13.2436 3.89537ZM11.4703 17.83L9.05294 15.4127C8.87817 15.2383 8.77996 15.0016 8.77996 14.7547C8.77996 14.5078 8.87817 14.2711 9.05294 14.0967C9.41694 13.7327 10.0049 13.7327 10.3689 14.0967L12.1329 15.8514L17.6209 10.3634C17.9849 9.99937 18.5729 9.99937 18.9369 10.3634C19.3009 10.7274 19.3009 11.3154 18.9369 11.6794L12.7863 17.83C12.4316 18.194 11.8343 18.194 11.4703 17.83Z"
            fill="white"
            fillOpacity="0.6"
        />
    )
}

export const ShortTextIcon = () => {
    return (
        <path
            width="28"
            height="28"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.46654 11.2031H20.5332C21.0465 11.2031 21.4665 11.6231 21.4665 12.1365C21.4665 12.6498 21.0465 13.0698 20.5332 13.0698H7.46654C6.9532 13.0698 6.5332 12.6498 6.5332 12.1365C6.5332 11.6231 6.9532 11.2031 7.46654 11.2031ZM7.46654 14.9365H14.9332C15.4465 14.9365 15.8665 15.3565 15.8665 15.8698C15.8665 16.3831 15.4465 16.8031 14.9332 16.8031H7.46654C6.9532 16.8031 6.5332 16.3831 6.5332 15.8698C6.5332 15.3565 6.9532 14.9365 7.46654 14.9365Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const SearchIcon = () => {
    return (
        <path
            width="40"
            height="40"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#C3CAD9"
            d="M18.5006 17.0006H17.7106L17.4306 16.7306C18.6306 15.3306 19.2506 13.4206 18.9106 11.3906C18.4406 8.61063 16.1206 6.39063 13.3206 6.05063C9.09063 5.53063 5.53063 9.09063 6.05063 13.3206C6.39063 16.1206 8.61063 18.4406 11.3906 18.9106C13.4206 19.2506 15.3306 18.6306 16.7306 17.4306L17.0006 17.7106V18.5006L21.2506 22.7506C21.6606 23.1606 22.3306 23.1606 22.7406 22.7506C23.1506 22.3406 23.1506 21.6706 22.7406 21.2606L18.5006 17.0006ZM12.5006 17.0006C10.0106 17.0006 8.00063 14.9906 8.00063 12.5006C8.00063 10.0106 10.0106 8.00063 12.5006 8.00063C14.9906 8.00063 17.0006 10.0106 17.0006 12.5006C17.0006 14.9906 14.9906 17.0006 12.5006 17.0006Z"
            stroke="none"
        />
    )
}

export const FilterAltIcon = () => {
    return (
        <path
            width="30"
            height="30"
            d="M14.0026 23C13.72 23 13.4831 22.9042 13.2919 22.7125C13.1007 22.5208 13.0051 22.2833 13.0051 22V16L7.22002 8.6C6.97066 8.26667 6.93326 7.91667 7.10781 7.55C7.28236 7.18333 7.58575 7 8.01797 7H21.982C22.4143 7 22.7176 7.18333 22.8922 7.55C23.0667 7.91667 23.0293 8.26667 22.78 8.6L16.9949 16V22C16.9949 22.2833 16.8993 22.5208 16.7081 22.7125C16.5169 22.9042 16.28 23 15.9974 23H14.0026ZM15 15.3L19.9373 9H10.0627L15 15.3Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const AssignmentIcon = () => {
    return (
        <path
            width="30"
            height="30"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.5329 6.53073H16.6316C16.2396 5.44806 15.2129 4.66406 13.9996 4.66406C12.7863 4.66406 11.7596 5.44806 11.3676 6.53073H7.46628C6.43961 6.53073 5.59961 7.37073 5.59961 8.3974V21.4641C5.59961 22.4907 6.43961 23.3307 7.46628 23.3307H20.5329C21.5596 23.3307 22.3996 22.4907 22.3996 21.4641V8.3974C22.3996 7.37073 21.5596 6.53073 20.5329 6.53073ZM13.9996 6.53073C14.5129 6.53073 14.9329 6.95073 14.9329 7.46406C14.9329 7.9774 14.5129 8.3974 13.9996 8.3974C13.4863 8.3974 13.0663 7.9774 13.0663 7.46406C13.0663 6.95073 13.4863 6.53073 13.9996 6.53073ZM13.9996 10.2641C15.5489 10.2641 16.7996 11.5147 16.7996 13.0641C16.7996 14.6134 15.5489 15.8641 13.9996 15.8641C12.4503 15.8641 11.1996 14.6134 11.1996 13.0641C11.1996 11.5147 12.4503 10.2641 13.9996 10.2641ZM19.5996 21.4641H8.39961V20.1574C8.39961 18.2907 12.1329 17.2641 13.9996 17.2641C15.8663 17.2641 19.5996 18.2907 19.5996 20.1574V21.4641Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const LocationOnIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 30" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 5C11.13 5 8 8.13 8 12C8 16.17 12.42 21.92 14.24 24.11C14.64 24.59 15.37 24.59 15.77 24.11C17.58 21.92 22 16.17 22 12C22 8.13 18.87 5 15 5ZM15 14.5C13.62 14.5 12.5 13.38 12.5 12C12.5 10.62 13.62 9.5 15 9.5C16.38 9.5 17.5 10.62 17.5 12C17.5 13.38 16.38 14.5 15 14.5Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const AddCircleIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9993 4.66406C8.84735 4.66406 4.66602 8.8454 4.66602 13.9974C4.66602 19.1494 8.84735 23.3307 13.9993 23.3307C19.1514 23.3307 23.3327 19.1494 23.3327 13.9974C23.3327 8.8454 19.1514 4.66406 13.9993 4.66406ZM17.7327 14.9307H14.9327V17.7307C14.9327 18.2441 14.5127 18.6641 13.9993 18.6641C13.486 18.6641 13.066 18.2441 13.066 17.7307V14.9307H10.266C9.75268 14.9307 9.33268 14.5107 9.33268 13.9974C9.33268 13.4841 9.75268 13.0641 10.266 13.0641H13.066V10.2641C13.066 9.75073 13.486 9.33073 13.9993 9.33073C14.5127 9.33073 14.9327 9.75073 14.9327 10.2641V13.0641H17.7327C18.246 13.0641 18.666 13.4841 18.666 13.9974C18.666 14.5107 18.246 14.9307 17.7327 14.9307Z"
            fill="white"
            stroke="none"
            fillOpacity="0.6"
        />
    )
}
export const FilledAddCircleIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9993 4.66797C8.84735 4.66797 4.66602 8.8493 4.66602 14.0013C4.66602 19.1533 8.84735 23.3346 13.9993 23.3346C19.1514 23.3346 23.3327 19.1533 23.3327 14.0013C23.3327 8.8493 19.1514 4.66797 13.9993 4.66797ZM17.7327 14.9346H14.9327V17.7346C14.9327 18.248 14.5127 18.668 13.9993 18.668C13.486 18.668 13.066 18.248 13.066 17.7346V14.9346H10.266C9.75268 14.9346 9.33268 14.5146 9.33268 14.0013C9.33268 13.488 9.75268 13.068 10.266 13.068H13.066V10.268C13.066 9.75464 13.486 9.33464 13.9993 9.33464C14.5127 9.33464 14.9327 9.75464 14.9327 10.268V13.068H17.7327C18.246 13.068 18.666 13.488 18.666 14.0013C18.666 14.5146 18.246 14.9346 17.7327 14.9346Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const ArchiveIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.54 8.23L22.15 6.55C21.88 6.21 21.47 6 21 6H9C8.53 6 8.12 6.21 7.84 6.55L6.46 8.23C6.17 8.57 6 9.02 6 9.5V22C6 23.1 6.9 24 8 24H22C23.1 24 24 23.1 24 22V9.5C24 9.02 23.83 8.57 23.54 8.23ZM14.65 20.15L9.5 15H13V13H17V15H20.5L15.35 20.15C15.16 20.34 14.84 20.34 14.65 20.15ZM8.12 8L8.93 7H20.93L21.87 8H8.12Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const CheckCircleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.4993 5.16797C9.34735 5.16797 5.16602 9.3493 5.16602 14.5013C5.16602 19.6533 9.34735 23.8346 14.4993 23.8346C19.6514 23.8346 23.8327 19.6533 23.8327 14.5013C23.8327 9.3493 19.6514 5.16797 14.4993 5.16797ZM11.97 18.5053L8.61935 15.1546C8.44458 14.9803 8.34636 14.7435 8.34636 14.4966C8.34636 14.2498 8.44458 14.013 8.61935 13.8386C8.98335 13.4746 9.57135 13.4746 9.93535 13.8386L12.6327 16.5266L19.054 10.1053C19.418 9.7413 20.006 9.7413 20.37 10.1053C20.734 10.4693 20.734 11.0573 20.37 11.4213L13.286 18.5053C12.9313 18.8693 12.334 18.8693 11.97 18.5053Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const MapsCategoryIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.15 5.48L9.43 11.56C9.02 12.22 9.5 13.08 10.28 13.08H17.71C18.49 13.08 18.97 12.22 18.56 11.56L14.85 5.48C14.46 4.84 13.54 4.84 13.15 5.48ZM19.5 15.08C17.8923 15.08 16.4067 15.9377 15.6029 17.33C14.799 18.7223 14.799 20.4377 15.6029 21.83C16.4067 23.2223 17.8923 24.08 19.5 24.08C21.1077 24.08 22.5933 23.2223 23.3971 21.83C24.201 20.4377 24.201 18.7223 23.3971 17.33C22.5933 15.9377 21.1077 15.08 19.5 15.08ZM6 23.58H12C12.55 23.58 13 23.13 13 22.58V16.58C13 16.03 12.55 15.58 12 15.58H6C5.45 15.58 5 16.03 5 16.58V22.58C5 23.13 5.45 23.58 6 23.58Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const AddIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.8004 12.7984H12.8004V16.7984C12.8004 17.2384 12.4404 17.5984 12.0004 17.5984C11.5604 17.5984 11.2004 17.2384 11.2004 16.7984V12.7984H7.20039C6.76039 12.7984 6.40039 12.4384 6.40039 11.9984C6.40039 11.5584 6.76039 11.1984 7.20039 11.1984H11.2004V7.19844C11.2004 6.75844 11.5604 6.39844 12.0004 6.39844C12.4404 6.39844 12.8004 6.75844 12.8004 7.19844V11.1984H16.8004C17.2404 11.1984 17.6004 11.5584 17.6004 11.9984C17.6004 12.4384 17.2404 12.7984 16.8004 12.7984Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const FlashOnIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.83398 6.5349V14.9349C9.83398 15.4482 10.254 15.8682 10.7673 15.8682H12.634V22.5416C12.634 23.0176 13.2593 23.1856 13.502 22.7749L18.346 14.4682C18.71 13.8429 18.262 13.0682 17.5433 13.0682H15.434L17.758 6.86156C17.9913 6.2549 17.5433 5.60156 16.89 5.60156H10.7673C10.254 5.60156 9.83398 6.02156 9.83398 6.5349Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const FlashOffIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.3222 14.4682C19.6862 13.8429 19.2382 13.0682 18.5195 13.0682H16.7742L18.9022 15.1962L19.3222 14.4682ZM19.4715 6.9549C19.7795 6.32956 19.3315 5.60156 18.6315 5.60156H11.7435C11.2302 5.60156 10.8102 6.02156 10.8102 6.5349V7.10423L16.5315 12.8256L19.4715 6.9549ZM21.4875 20.4229L8.1222 7.05756C7.94783 6.88279 7.71109 6.78458 7.4642 6.78458C7.21732 6.78458 6.98058 6.88279 6.8062 7.05756C6.4422 7.42156 6.4422 8.00956 6.8062 8.37356L10.8102 12.3869V14.9349C10.8102 15.4482 11.2302 15.8682 11.7435 15.8682H13.6102V22.5416C13.6102 23.0176 14.2355 23.1856 14.4782 22.7749L16.9515 18.5282L20.1622 21.7389C20.5262 22.1029 21.1142 22.1029 21.4782 21.7389C21.8515 21.3749 21.8515 20.7869 21.4875 20.4229Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const BrightnessIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="41"
            viewBox="0 0 40 41"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9185 7.56644C16.7452 6.77977 13.6785 7.20644 11.0785 8.41977C10.6119 8.6331 10.5319 9.2731 10.9452 9.56644C14.4119 11.9664 16.6785 15.9664 16.6785 20.4998C16.6785 25.0331 14.4119 29.0331 10.9452 31.4331C10.5185 31.7264 10.5985 32.3664 11.0652 32.5798C12.7719 33.3798 14.6785 33.8331 16.6785 33.8331C24.7452 33.8331 31.1452 26.6598 29.8385 18.3664C29.0252 13.1398 25.0519 8.81977 19.9185 7.56644Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const BrightnessIconFilled = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="41"
            viewBox="0 0 30 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.06732 5.1187L6.54732 4.5987C6.02732 4.0787 5.18732 4.09203 4.68065 4.5987L4.66732 4.61203C4.14732 5.13203 4.14732 5.97203 4.66732 6.4787L5.18732 6.9987C5.70732 7.5187 6.53398 7.5187 7.05398 6.9987L7.06732 6.98536C7.58732 6.4787 7.58732 5.62536 7.06732 5.1187ZM3.01398 13.5987H1.65398C0.920651 13.5987 0.333984 14.1854 0.333984 14.9187V14.932C0.333984 15.6654 0.920651 16.252 1.65398 16.252H3.00065C3.74732 16.2654 4.33398 15.6787 4.33398 14.9454V14.932C4.33398 14.1854 3.74732 13.5987 3.01398 13.5987ZM15.014 0.332031H15.0007C14.254 0.332031 13.6673 0.918698 13.6673 1.65203V2.93203C13.6673 3.66536 14.254 4.25203 14.9873 4.25203H15.0007C15.7473 4.26536 16.334 3.6787 16.334 2.94536V1.65203C16.334 0.918698 15.7473 0.332031 15.014 0.332031ZM25.334 4.61203C24.814 4.09203 23.974 4.09203 23.454 4.5987L22.934 5.1187C22.414 5.6387 22.414 6.4787 22.934 6.98536L22.9473 6.9987C23.4673 7.5187 24.3073 7.5187 24.814 6.9987L25.334 6.4787C25.854 5.9587 25.854 5.13203 25.334 4.61203ZM22.9207 24.7454L23.4407 25.2654C23.9607 25.7854 24.8007 25.7854 25.3207 25.2654C25.8407 24.7454 25.8407 23.9054 25.3207 23.3854L24.8007 22.8654C24.2807 22.3454 23.4407 22.3587 22.934 22.8654C22.4007 23.3987 22.4007 24.2254 22.9207 24.7454ZM25.6673 14.9187V14.932C25.6673 15.6654 26.254 16.252 26.9873 16.252H28.334C29.0673 16.252 29.654 15.6654 29.654 14.932V14.9187C29.654 14.1854 29.0673 13.5987 28.334 13.5987H26.9873C26.254 13.5987 25.6673 14.1854 25.6673 14.9187ZM15.0007 6.93203C10.5873 6.93203 7.00065 10.5187 7.00065 14.932C7.00065 19.3454 10.5873 22.932 15.0007 22.932C19.414 22.932 23.0007 19.3454 23.0007 14.932C23.0007 10.5187 19.414 6.93203 15.0007 6.93203ZM14.9873 29.532H15.0007C15.734 29.532 16.3207 28.9454 16.3207 28.212V26.932C16.3207 26.1987 15.734 25.612 15.0007 25.612H14.9873C14.254 25.612 13.6673 26.1987 13.6673 26.932V28.212C13.6673 28.9454 14.254 29.532 14.9873 29.532ZM4.66732 25.252C5.18732 25.772 6.02732 25.772 6.54732 25.252L7.06732 24.732C7.58732 24.212 7.57398 23.372 7.06732 22.8654L7.05398 22.852C6.80488 22.6024 6.46667 22.4621 6.11398 22.4621C5.76129 22.4621 5.42309 22.6024 5.17398 22.852L4.65398 23.372C4.14732 23.9054 4.14732 24.732 4.66732 25.252Z"
                fill="#2CAAE2"
            />
        </svg>
    )
}

export const NotificationIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="41"
            viewBox="0 0 40 41"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.4493 33.168C20.916 33.168 22.116 31.968 22.116 30.5013H16.7826C16.7826 31.968 17.9693 33.168 19.4493 33.168ZM27.4493 25.168V18.5013C27.4493 14.408 25.2626 10.9813 21.4493 10.0746V9.16797C21.4493 8.0613 20.556 7.16797 19.4493 7.16797C18.3426 7.16797 17.4493 8.0613 17.4493 9.16797V10.0746C13.6226 10.9813 11.4493 14.3946 11.4493 18.5013V25.168L9.72929 26.888C8.88929 27.728 9.47595 29.168 10.6626 29.168H28.2226C29.4093 29.168 30.0093 27.728 29.1693 26.888L27.4493 25.168Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const TrendingUpIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="31"
            viewBox="0 0 30 31"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.4325 10.35L20.8725 11.79L15.9925 16.67L12.7025 13.38C12.5157 13.1927 12.262 13.0875 11.9975 13.0875C11.733 13.0875 11.4793 13.1927 11.2925 13.38L5.2925 19.39C4.9025 19.78 4.9025 20.41 5.2925 20.8C5.6825 21.19 6.3125 21.19 6.7025 20.8L11.9925 15.5L15.2825 18.79C15.6725 19.18 16.3025 19.18 16.6925 18.79L22.2825 13.21L23.7225 14.65C24.0325 14.96 24.5725 14.74 24.5725 14.3V10C24.5825 9.72 24.3625 9.5 24.0825 9.5H19.7925C19.3425 9.5 19.1225 10.04 19.4325 10.35Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const GavelIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="31"
            viewBox="0 0 30 31"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 23.6738H16C16.55 23.6738 17 24.1238 17 24.6738C17 25.2238 16.55 25.6738 16 25.6738H6C5.45 25.6738 5 25.2238 5 24.6738C5 24.1238 5.45 23.6738 6 23.6738ZM9.24 10.7438L12.07 7.91376L24.8 20.6438C25.58 21.4238 25.58 22.6938 24.8 23.4738C24.02 24.2538 22.75 24.2538 21.97 23.4738L9.24 10.7438ZM17.73 5.08376L20.56 7.91376C21.34 8.69376 21.34 9.96376 20.56 10.7438L19.14 12.1638L13.49 6.50376L14.9 5.09376C15.68 4.30376 16.95 4.30376 17.73 5.08376ZM7.83 12.1538L13.49 17.8138L12.08 19.2238C11.3 20.0038 10.03 20.0038 9.25 19.2238L6.42 16.3938C5.64 15.6138 5.64 14.3438 6.42 13.5638L7.83 12.1538Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const PeopleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.7324 13.5648C19.2818 13.5648 20.5231 12.3142 20.5231 10.7648C20.5231 9.21551 19.2818 7.96484 17.7324 7.96484C16.1831 7.96484 14.9324 9.21551 14.9324 10.7648C14.9324 12.3142 16.1831 13.5648 17.7324 13.5648ZM10.2658 13.5648C11.8151 13.5648 13.0564 12.3142 13.0564 10.7648C13.0564 9.21551 11.8151 7.96484 10.2658 7.96484C8.71642 7.96484 7.46576 9.21551 7.46576 10.7648C7.46576 12.3142 8.71642 13.5648 10.2658 13.5648ZM10.2658 15.4315C8.09109 15.4315 3.73242 16.5235 3.73242 18.6982V20.0982C3.73242 20.6115 4.15242 21.0315 4.66576 21.0315H15.8658C16.3791 21.0315 16.7991 20.6115 16.7991 20.0982V18.6982C16.7991 16.5235 12.4404 15.4315 10.2658 15.4315ZM17.7324 15.4315C17.4618 15.4315 17.1538 15.4502 16.8271 15.4782C16.8458 15.4875 16.8551 15.5062 16.8644 15.5155C17.9284 16.2902 18.6658 17.3262 18.6658 18.6982V20.0982C18.6658 20.4248 18.6004 20.7422 18.4978 21.0315H23.3324C23.8458 21.0315 24.2658 20.6115 24.2658 20.0982V18.6982C24.2658 16.5235 19.9071 15.4315 17.7324 15.4315Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const DownloadIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.7841 12.1352H17.3001V7.46849C17.3001 6.95516 16.8801 6.53516 16.3668 6.53516H12.6335C12.1201 6.53516 11.7001 6.95516 11.7001 7.46849V12.1352H10.2161C9.38546 12.1352 8.96546 13.1432 9.55346 13.7312L13.8375 18.0152C14.2015 18.3792 14.7895 18.3792 15.1535 18.0152L19.4375 13.7312C20.0255 13.1432 19.6148 12.1352 18.7841 12.1352ZM7.9668 21.4685C7.9668 21.9818 8.3868 22.4018 8.90013 22.4018H20.1001C20.6135 22.4018 21.0335 21.9818 21.0335 21.4685C21.0335 20.9552 20.6135 20.5352 20.1001 20.5352H8.90013C8.3868 20.5352 7.9668 20.9552 7.9668 21.4685Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const FormatListNumberIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.6996 9.33516H22.8996C23.4129 9.33516 23.8329 8.91516 23.8329 8.40182C23.8329 7.88849 23.4129 7.46849 22.8996 7.46849H11.6996C11.1863 7.46849 10.7663 7.88849 10.7663 8.40182C10.7663 8.91516 11.1863 9.33516 11.6996 9.33516ZM22.8996 18.6685H11.6996C11.1863 18.6685 10.7663 19.0885 10.7663 19.6018C10.7663 20.1152 11.1863 20.5352 11.6996 20.5352H22.8996C23.4129 20.5352 23.8329 20.1152 23.8329 19.6018C23.8329 19.0885 23.4129 18.6685 22.8996 18.6685ZM22.8996 13.0685H11.6996C11.1863 13.0685 10.7663 13.4885 10.7663 14.0018C10.7663 14.5152 11.1863 14.9352 11.6996 14.9352H22.8996C23.4129 14.9352 23.8329 14.5152 23.8329 14.0018C23.8329 13.4885 23.4129 13.0685 22.8996 13.0685ZM8.43294 17.7352H6.56628C6.30494 17.7352 6.09961 17.9405 6.09961 18.2018C6.09961 18.4632 6.30494 18.6685 6.56628 18.6685H7.96628V19.1352H7.49961C7.23828 19.1352 7.03294 19.3405 7.03294 19.6018C7.03294 19.8632 7.23828 20.0685 7.49961 20.0685H7.96628V20.5352H6.56628C6.30494 20.5352 6.09961 20.7405 6.09961 21.0018C6.09961 21.2632 6.30494 21.4685 6.56628 21.4685H8.43294C8.69428 21.4685 8.89961 21.2632 8.89961 21.0018V18.2018C8.89961 17.9405 8.69428 17.7352 8.43294 17.7352ZM6.56628 7.46849H7.03294V9.80182C7.03294 10.0632 7.23828 10.2685 7.49961 10.2685C7.76094 10.2685 7.96628 10.0632 7.96628 9.80182V7.00182C7.96628 6.74049 7.76094 6.53516 7.49961 6.53516H6.56628C6.30494 6.53516 6.09961 6.74049 6.09961 7.00182C6.09961 7.26316 6.30494 7.46849 6.56628 7.46849ZM8.43294 12.1352H6.56628C6.30494 12.1352 6.09961 12.3405 6.09961 12.6018C6.09961 12.8632 6.30494 13.0685 6.56628 13.0685H7.77961L6.21161 14.8978C6.13694 14.9818 6.09961 15.0938 6.09961 15.1965V15.4018C6.09961 15.6632 6.30494 15.8685 6.56628 15.8685H8.43294C8.69428 15.8685 8.89961 15.6632 8.89961 15.4018C8.89961 15.1405 8.69428 14.9352 8.43294 14.9352H7.21961L8.78761 13.1058C8.86228 13.0218 8.89961 12.9098 8.89961 12.8072V12.6018C8.89961 12.3405 8.69428 12.1352 8.43294 12.1352Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const VisibilityOffIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.9991 8.9919C16.5751 8.9919 18.6658 11.0826 18.6658 13.6586C18.6658 14.1346 18.5724 14.5919 18.4418 15.0212L21.2978 17.8772C22.5951 16.7292 23.6218 15.2919 24.2658 13.6492C22.6511 9.56123 18.6658 6.65856 13.9991 6.65856C12.8138 6.65856 11.6751 6.84523 10.6018 7.19056L12.6271 9.2159C13.0658 9.08523 13.5231 8.9919 13.9991 8.9919ZM5.32842 5.87456C4.96442 6.23856 4.96442 6.82656 5.32842 7.19056L7.16709 9.02923C5.65509 10.2332 4.45109 11.8199 3.73242 13.6586C5.34709 17.7559 9.33242 20.6586 13.9991 20.6586C15.4178 20.6586 16.7711 20.3786 18.0218 19.8932L20.5604 22.4319C20.9244 22.7959 21.5124 22.7959 21.8764 22.4319C22.2404 22.0679 22.2404 21.4799 21.8764 21.1159L6.65376 5.87456C6.28976 5.51056 5.69242 5.51056 5.32842 5.87456ZM13.9991 18.3252C11.4231 18.3252 9.33242 16.2346 9.33242 13.6586C9.33242 12.9399 9.50042 12.2586 9.78976 11.6612L11.2551 13.1266C11.2271 13.2946 11.1991 13.4719 11.1991 13.6586C11.1991 15.2079 12.4498 16.4586 13.9991 16.4586C14.1858 16.4586 14.3538 16.4306 14.5311 16.3932L15.9964 17.8586C15.3898 18.1572 14.7178 18.3252 13.9991 18.3252ZM16.7711 13.3506C16.6311 12.0439 15.6044 11.0266 14.3071 10.8866L16.7711 13.3506Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const MinimizeIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 14H20C20.55 14 21 14.45 21 15C21 15.55 20.55 16 20 16H10C9.45 16 9 15.55 9 15C9 14.45 9.45 14 10 14Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const SubtitlesIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="31"
            viewBox="0 0 30 31"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23 7.5H7C5.9 7.5 5 8.4 5 9.5V21.5C5 22.6 5.9 23.5 7 23.5H23C24.1 23.5 25 22.6 25 21.5V9.5C25 8.4 24.1 7.5 23 7.5ZM8 15.5H10C10.55 15.5 11 15.95 11 16.5C11 17.05 10.55 17.5 10 17.5H8C7.45 17.5 7 17.05 7 16.5C7 15.95 7.45 15.5 8 15.5ZM16 21.5H8C7.45 21.5 7 21.05 7 20.5C7 19.95 7.45 19.5 8 19.5H16C16.55 19.5 17 19.95 17 20.5C17 21.05 16.55 21.5 16 21.5ZM22 21.5H20C19.45 21.5 19 21.05 19 20.5C19 19.95 19.45 19.5 20 19.5H22C22.55 19.5 23 19.95 23 20.5C23 21.05 22.55 21.5 22 21.5ZM22 17.5H14C13.45 17.5 13 17.05 13 16.5C13 15.95 13.45 15.5 14 15.5H22C22.55 15.5 23 15.95 23 16.5C23 17.05 22.55 17.5 22 17.5Z"
                fill="#2CAAE2"
            />
        </svg>
    )
}

export const ExitToAppIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.3703 18.5036C13.7343 18.8676 14.3223 18.8676 14.6863 18.5036L18.0369 15.1529C18.4009 14.7889 18.4009 14.2009 18.0369 13.8369L14.6863 10.4863C14.5119 10.3115 14.2752 10.2133 14.0283 10.2133C13.7814 10.2133 13.5447 10.3115 13.3703 10.4863C13.0063 10.8503 13.0063 11.4383 13.3703 11.8023L15.1249 13.5663H7.03294C6.51961 13.5663 6.09961 13.9863 6.09961 14.4996C6.09961 15.0129 6.51961 15.4329 7.03294 15.4329H15.1249L13.3703 17.1876C13.0063 17.5516 13.0156 18.1489 13.3703 18.5036ZM21.0329 6.09961H7.96628C6.93028 6.09961 6.09961 6.93961 6.09961 7.96628V10.7663C6.09961 11.2796 6.51961 11.6996 7.03294 11.6996C7.54628 11.6996 7.96628 11.2796 7.96628 10.7663V8.89961C7.96628 8.38628 8.38628 7.96628 8.89961 7.96628H20.0996C20.6129 7.96628 21.0329 8.38628 21.0329 8.89961V20.0996C21.0329 20.6129 20.6129 21.0329 20.0996 21.0329H8.89961C8.38628 21.0329 7.96628 20.6129 7.96628 20.0996V18.2329C7.96628 17.7196 7.54628 17.2996 7.03294 17.2996C6.51961 17.2996 6.09961 17.7196 6.09961 18.2329V21.0329C6.09961 22.0596 6.93961 22.8996 7.96628 22.8996H21.0329C22.0596 22.8996 22.8996 22.0596 22.8996 21.0329V7.96628C22.8996 6.93961 22.0596 6.09961 21.0329 6.09961Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const SlowMotionVideoIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.784 11.284V18.284C12.784 18.694 13.254 18.934 13.584 18.684L18.254 15.184C18.524 14.984 18.524 14.584 18.254 14.384L13.584 10.884C13.254 10.634 12.784 10.874 12.784 11.284ZM13.784 6.01404C13.784 5.37404 13.194 4.88404 12.574 5.02404C11.454 5.28404 10.394 5.72404 9.45404 6.32404C8.92404 6.66404 8.84404 7.42404 9.29404 7.87404C9.61404 8.19404 10.124 8.27404 10.504 8.03404C11.274 7.54404 12.124 7.18404 13.044 6.98404C13.484 6.88404 13.784 6.47404 13.784 6.01404ZM7.88404 9.29404C7.42404 8.84404 6.67404 8.91404 6.33404 9.45404C5.73404 10.394 5.29404 11.454 5.03404 12.574C4.89404 13.194 5.37404 13.784 6.01404 13.784C6.46404 13.784 6.88404 13.484 6.97404 13.044C7.17404 12.134 7.54404 11.274 8.02404 10.514C8.28404 10.124 8.20404 9.61404 7.88404 9.29404ZM6.01404 15.784C5.37404 15.784 4.88404 16.374 5.02404 16.994C5.28404 18.114 5.72404 19.164 6.32404 20.114C6.66404 20.654 7.42404 20.724 7.87404 20.274C8.19404 19.954 8.27404 19.444 8.02404 19.064C7.53404 18.304 7.17404 17.454 6.97404 16.534C6.88404 16.084 6.47404 15.784 6.01404 15.784ZM9.45404 23.234C10.404 23.834 11.454 24.274 12.574 24.534C13.194 24.674 13.784 24.184 13.784 23.554C13.784 23.104 13.484 22.684 13.044 22.594C12.134 22.394 11.274 22.024 10.514 21.544C10.124 21.304 9.62404 21.374 9.30404 21.704C8.84404 22.144 8.91404 22.894 9.45404 23.234ZM24.784 14.784C24.784 19.514 21.484 23.494 17.054 24.524C16.434 24.674 15.834 24.184 15.834 23.544C15.834 23.084 16.144 22.684 16.584 22.574C20.134 21.754 22.784 18.574 22.784 14.784C22.784 10.994 20.134 7.81404 16.584 6.99404C16.144 6.89404 15.834 6.48404 15.834 6.02404C15.834 5.38404 16.434 4.89404 17.054 5.04404C21.484 6.07404 24.784 10.054 24.784 14.784Z"
                fill="#2CAAE2"
            />
        </svg>
    )
}

export const CheckIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.1725 19.1625L8.7025 15.6925C8.51567 15.5052 8.26202 15.4 7.9975 15.4C7.73298 15.4 7.47933 15.5052 7.2925 15.6925C6.9025 16.0825 6.9025 16.7125 7.2925 17.1025L11.4725 21.2825C11.8625 21.6725 12.4925 21.6725 12.8825 21.2825L23.4625 10.7025C23.8525 10.3125 23.8525 9.68249 23.4625 9.29249C23.2757 9.10523 23.022 9 22.7575 9C22.493 9 22.2393 9.10523 22.0525 9.29249L12.1725 19.1625Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const PhoneIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.723 17.0329L18.3524 16.7623C17.783 16.6969 17.223 16.8929 16.8217 17.2943L15.1044 19.0116C12.463 17.6676 10.2977 15.5116 8.9537 12.8609L10.6804 11.1343C11.0817 10.7329 11.2777 10.1729 11.2124 9.60361L10.9417 7.25161C10.8297 6.30894 10.0364 5.59961 9.08437 5.59961H7.4697C6.41504 5.59961 5.5377 6.47694 5.60304 7.53161C6.0977 15.5023 12.4724 21.8676 20.4337 22.3623C21.4884 22.4276 22.3657 21.5503 22.3657 20.4956V18.8809C22.375 17.9383 21.6657 17.1449 20.723 17.0329Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const PersonAddIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 15C20.21 15 22 13.21 22 11C22 8.79 20.21 7 18 7C15.79 7 14 8.79 14 11C14 13.21 15.79 15 18 15ZM9 13V11C9 10.45 8.55 10 8 10C7.45 10 7 10.45 7 11V13H5C4.45 13 4 13.45 4 14C4 14.55 4.45 15 5 15H7V17C7 17.55 7.45 18 8 18C8.55 18 9 17.55 9 17V15H11C11.55 15 12 14.55 12 14C12 13.45 11.55 13 11 13H9ZM18 17C15.33 17 10 18.34 10 21V22C10 22.55 10.45 23 11 23H25C25.55 23 26 22.55 26 22V21C26 18.34 20.67 17 18 17Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const PersonIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 15C17.21 15 19 13.21 19 11C19 8.79 17.21 7 15 7C12.79 7 11 8.79 11 11C11 13.21 12.79 15 15 15ZM15 17C12.33 17 7 18.34 7 21V22C7 22.55 7.45 23 8 23H22C22.55 23 23 22.55 23 22V21C23 18.34 17.67 17 15 17Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const HighlightOffIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.89 11.7L15 13.59L13.11 11.7C12.9232 11.5127 12.6695 11.4075 12.405 11.4075C12.1405 11.4075 11.8868 11.5127 11.7 11.7C11.31 12.09 11.31 12.72 11.7 13.11L13.59 15L11.7 16.89C11.31 17.28 11.31 17.91 11.7 18.3C12.09 18.69 12.72 18.69 13.11 18.3L15 16.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L16.41 15L18.3 13.11C18.69 12.72 18.69 12.09 18.3 11.7C17.91 11.32 17.27 11.32 16.89 11.7ZM15 5C9.47 5 5 9.47 5 15C5 20.53 9.47 25 15 25C20.53 25 25 20.53 25 15C25 9.47 20.53 5 15 5ZM15 23C10.59 23 7 19.41 7 15C7 10.59 10.59 7 15 7C19.41 7 23 10.59 23 15C23 19.41 19.41 23 15 23Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const BubbleChartIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2 14.2C9.05675 14.2 8.00034 14.8099 7.42872 15.8C6.85709 16.7901 6.85709 18.0099 7.42872 19C8.00034 19.9901 9.05675 20.6 10.2 20.6C11.3432 20.6 12.3997 19.9901 12.9713 19C13.5429 18.0099 13.5429 16.7901 12.9713 15.8C12.3997 14.8099 11.3432 14.2 10.2 14.2ZM17.8 19C16.6954 19 15.8 19.8954 15.8 21C15.8 22.1046 16.6954 23 17.8 23C18.9046 23 19.8 22.1046 19.8 21C19.8 19.8954 18.9046 19 17.8 19ZM18.2 7C15.549 7 13.4 9.14903 13.4 11.8C13.4 14.451 15.549 16.6 18.2 16.6C20.851 16.6 23 14.451 23 11.8C23 9.14903 20.851 7 18.2 7Z"
                fill="#2CAAE2"
            />
        </svg>
    )
}

export const SendIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.47268 22.2924L22.7593 15.3111C23.5154 14.9844 23.5154 13.9204 22.7593 13.5938L6.47268 6.61242C5.85668 6.34176 5.17535 6.79909 5.17535 7.46176L5.16602 11.7644C5.16602 12.2311 5.51135 12.6324 5.97802 12.6884L19.166 14.4524L5.97802 16.2071C5.51135 16.2724 5.16602 16.6738 5.16602 17.1404L5.17535 21.4431C5.17535 22.1058 5.85668 22.5631 6.47268 22.2924Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const DragIndicatorIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="36"
            viewBox="0 0 30 36"
            fill="none"
        >
            <g filter="url(#filter0_d_1130_68825)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 22C14 23.1 13.1 24 12 24C10.9 24 10 23.1 10 22C10 20.9 10.9 20 12 20C13.1 20 14 20.9 14 22ZM12 14C10.9 14 10 14.9 10 16C10 17.1 10.9 18 12 18C13.1 18 14 17.1 14 16C14 14.9 13.1 14 12 14ZM12 8C10.9 8 10 8.9 10 10C10 11.1 10.9 12 12 12C13.1 12 14 11.1 14 10C14 8.9 13.1 8 12 8ZM18 12C19.1 12 20 11.1 20 10C20 8.9 19.1 8 18 8C16.9 8 16 8.9 16 10C16 11.1 16.9 12 18 12ZM18 14C16.9 14 16 14.9 16 16C16 17.1 16.9 18 18 18C19.1 18 20 17.1 20 16C20 14.9 19.1 14 18 14ZM18 20C16.9 20 16 20.9 16 22C16 23.1 16.9 24 18 24C19.1 24 20 23.1 20 22C20 20.9 19.1 20 18 20Z"
                    fill="#C3CAD9"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_1130_68825"
                    x="-10"
                    y="-7"
                    width="50"
                    height="50"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.14902 0 0 0 0 0.2 0 0 0 0 0.301961 0 0 0 0.03 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1130_68825"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1130_68825"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    )
}

export const CallMissedIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.4303 9.98732L13.9996 16.418L8.78228 11.2007H12.1329C12.6463 11.2007 13.0663 10.7807 13.0663 10.2673C13.0663 9.75398 12.6463 9.33398 12.1329 9.33398H6.53294C6.01961 9.33398 5.59961 9.75398 5.59961 10.2673V15.8673C5.59961 16.3807 6.01961 16.8007 6.53294 16.8007C7.04628 16.8007 7.46628 16.3807 7.46628 15.8673V12.5167L13.3369 18.3873C13.7009 18.7513 14.2889 18.7513 14.6529 18.3873L21.7369 11.3033C22.1009 10.9393 22.1009 10.3513 21.7369 9.98732C21.3823 9.63265 20.7849 9.63265 20.4303 9.98732Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const AppsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 11H11V7H7V11ZM13 23H17V19H13V23ZM7 23H11V19H7V23ZM7 17H11V13H7V17ZM13 17H17V13H13V17ZM19 7V11H23V7H19ZM13 11H17V7H13V11ZM19 17H23V13H19V17ZM19 23H23V19H19V23Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const ClockIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.99 5C9.47 5 5 9.48 5 15C5 20.52 9.47 25 14.99 25C20.52 25 25 20.52 25 15C25 9.48 20.52 5 14.99 5ZM15 23C10.58 23 7 19.42 7 15C7 10.58 10.58 7 15 7C19.42 7 23 10.58 23 15C23 19.42 19.42 23 15 23ZM14.78 10H14.72C14.32 10 14 10.32 14 10.72V15.44C14 15.79 14.18 16.12 14.49 16.3L18.64 18.79C18.98 18.99 19.42 18.89 19.62 18.55C19.83 18.21 19.72 17.76 19.37 17.56L15.5 15.26V10.72C15.5 10.32 15.18 10 14.78 10Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const CancelPresentationIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.8991 5.59998H6.09909C5.07242 5.59998 4.23242 6.43998 4.23242 7.46664V20.5333C4.23242 21.56 5.07242 22.4 6.09909 22.4H22.8991C23.9258 22.4 24.7658 21.56 24.7658 20.5333V7.46664C24.7658 6.43998 23.9258 5.59998 22.8991 5.59998ZM22.8991 19.6C22.8991 20.1133 22.4791 20.5333 21.9658 20.5333H7.03242C6.51909 20.5333 6.09909 20.1133 6.09909 19.6V8.39998C6.09909 7.88664 6.51909 7.46664 7.03242 7.46664H21.9658C22.4791 7.46664 22.8991 7.88664 22.8991 8.39998V19.6ZM17.5698 10.92C17.3954 10.7452 17.1586 10.647 16.9118 10.647C16.6649 10.647 16.4281 10.7452 16.2538 10.92L14.4991 12.684L12.7351 10.92C12.5607 10.7452 12.324 10.647 12.0771 10.647C11.8302 10.647 11.5935 10.7452 11.4191 10.92C11.0551 11.284 11.0551 11.872 11.4191 12.236L13.1831 14L11.4191 15.764C11.0551 16.128 11.0551 16.716 11.4191 17.08C11.7831 17.444 12.3711 17.444 12.7351 17.08L14.4991 15.316L16.2631 17.08C16.6271 17.444 17.2151 17.444 17.5791 17.08C17.9431 16.716 17.9431 16.128 17.5791 15.764L15.8151 14L17.5791 12.236C17.9338 11.8813 17.9338 11.284 17.5698 10.92Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const AssignementReturnIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.5329 7.03329H16.6316C16.2396 5.95063 15.2129 5.16663 13.9996 5.16663C12.7863 5.16663 11.7596 5.95063 11.3676 7.03329H7.46628C6.43961 7.03329 5.59961 7.87329 5.59961 8.89996V21.9666C5.59961 22.9933 6.43961 23.8333 7.46628 23.8333H20.5329C21.5596 23.8333 22.3996 22.9933 22.3996 21.9666V8.89996C22.3996 7.87329 21.5596 7.03329 20.5329 7.03329ZM13.9996 7.03329C14.5129 7.03329 14.9329 7.45329 14.9329 7.96663C14.9329 8.47996 14.5129 8.89996 13.9996 8.89996C13.4863 8.89996 13.0663 8.47996 13.0663 7.96663C13.0663 7.45329 13.4863 7.03329 13.9996 7.03329ZM17.7329 18.2333H13.9996V21.0333L9.65961 16.6933C9.47294 16.5066 9.47294 16.2173 9.65961 16.0306L13.9996 11.7V14.5H17.7329V18.2333Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const MedalsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
        >
            <path
                d="M14.0007 23.8335C15.459 23.8335 16.6986 23.3231 17.7194 22.3022C18.7402 21.2814 19.2507 20.0418 19.2507 18.5835C19.2507 17.1252 18.7402 15.8856 17.7194 14.8647C16.6986 13.8439 15.459 13.3335 14.0007 13.3335C12.5423 13.3335 11.3027 13.8439 10.2819 14.8647C9.26107 15.8856 8.75065 17.1252 8.75065 18.5835C8.75065 20.0418 9.26107 21.2814 10.2819 22.3022C11.3027 23.3231 12.5423 23.8335 14.0007 23.8335ZM10.5882 11.8168C10.977 11.6029 11.3902 11.4328 11.8277 11.3064C12.2652 11.18 12.7076 11.0974 13.1548 11.0585L10.209 5.16683H7.29232L10.5882 11.8168ZM17.4131 11.8168L20.7381 5.16683H17.7923L15.3132 10.1252L15.8673 11.2335C16.1395 11.3113 16.402 11.3939 16.6548 11.4814C16.9076 11.5689 17.1604 11.6807 17.4131 11.8168ZM7.46732 22.4335C7.13676 21.8696 6.87912 21.262 6.6944 20.6106C6.50968 19.9592 6.41732 19.2835 6.41732 18.5835C6.41732 17.8835 6.50968 17.2078 6.6944 16.5564C6.87912 15.905 7.13676 15.2974 7.46732 14.7335C6.65065 15.0057 5.97982 15.487 5.45482 16.1772C4.92982 16.8675 4.66732 17.6696 4.66732 18.5835C4.66732 19.4974 4.92982 20.2995 5.45482 20.9897C5.97982 21.68 6.65065 22.1613 7.46732 22.4335ZM20.534 22.4335C21.3507 22.1613 22.0215 21.68 22.5465 20.9897C23.0715 20.2995 23.334 19.4974 23.334 18.5835C23.334 17.6696 23.0715 16.8675 22.5465 16.1772C22.0215 15.487 21.3507 15.0057 20.534 14.7335C20.8645 15.2974 21.1222 15.905 21.3069 16.5564C21.4916 17.2078 21.584 17.8835 21.584 18.5835C21.584 19.2835 21.4916 19.9592 21.3069 20.6106C21.1222 21.262 20.8645 21.8696 20.534 22.4335ZM14.0007 26.1668C13.2229 26.1668 12.4791 26.055 11.7694 25.8314C11.0597 25.6078 10.4034 25.3015 9.80065 24.9127C9.62565 24.9515 9.45065 24.9759 9.27565 24.9856C9.10065 24.9953 8.91593 25.0002 8.72148 25.0002C6.95204 25.0002 5.4451 24.3779 4.20065 23.1335C2.95621 21.889 2.33398 20.3821 2.33398 18.6127C2.33398 16.921 2.89787 15.4724 4.02565 14.2668C5.15343 13.0613 6.54371 12.3904 8.19648 12.2543L3.50065 2.8335H11.6673L14.0007 7.50016L16.334 2.8335H24.5007L19.834 12.196C21.4868 12.3516 22.8722 13.0321 23.9902 14.2377C25.1083 15.4432 25.6673 16.8918 25.6673 18.5835C25.6673 20.3724 25.0451 21.889 23.8006 23.1335C22.5562 24.3779 21.0395 25.0002 19.2507 25.0002C19.0756 25.0002 18.8958 24.9953 18.7111 24.9856C18.5263 24.9759 18.3465 24.9515 18.1715 24.9127C17.5687 25.3015 16.9173 25.6078 16.2173 25.8314C15.5173 26.055 14.7784 26.1668 14.0007 26.1668ZM11.8423 21.7918L12.659 19.1377L10.5007 17.5918H13.1548L14.0007 14.7918L14.8465 17.5918H17.5007L15.3423 19.1377L16.159 21.7918L14.0007 20.1585L11.8423 21.7918Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const MedalIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                d="M7.5 28.75V18.4688L3.4375 11.875L9.21875 2.5H20.7812L26.5625 11.875L22.5 18.4688V28.75L15 26.25L7.5 28.75ZM10 25.2812L15 23.625L20 25.2812V21.25H10V25.2812ZM10.625 5L6.375 11.875L10.625 18.75H19.375L23.625 11.875L19.375 5H10.625ZM13.6875 16.9688L9.25 12.5625L11.0312 10.7812L13.6875 13.4375L18.9688 8.125L20.75 9.875L13.6875 16.9688Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const SortIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.66602 21H11.666C12.216 21 12.666 20.55 12.666 20C12.666 19.45 12.216 19 11.666 19H7.66602C7.11602 19 6.66602 19.45 6.66602 20C6.66602 20.55 7.11602 21 7.66602 21ZM6.66602 10C6.66602 10.55 7.11602 11 7.66602 11H23.666C24.216 11 24.666 10.55 24.666 10C24.666 9.45 24.216 9 23.666 9H7.66602C7.11602 9 6.66602 9.45 6.66602 10ZM7.66602 16H17.666C18.216 16 18.666 15.55 18.666 15C18.666 14.45 18.216 14 17.666 14H7.66602C7.11602 14 6.66602 14.45 6.66602 15C6.66602 15.55 7.11602 16 7.66602 16Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const WebIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23 7H7C5.9 7 5.01 7.9 5.01 9L5 21C5 22.1 5.9 23 7 23H23C24.1 23 25 22.1 25 21V9C25 7.9 24.1 7 23 7ZM7 12H17.5V15.5H7V12ZM7 17.5H17.5V21H8C7.45 21 7 20.55 7 20V17.5ZM22 21H19.5V12H23V20C23 20.55 22.55 21 22 21Z"
                fill="#2CAAE2"
            />
        </svg>
    )
}

export const BottomSheetIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                d="M6.25 26.25C5.5625 26.25 4.97396 26.0052 4.48438 25.5156C3.99479 25.026 3.75 24.4375 3.75 23.75V6.25C3.75 5.5625 3.99479 4.97396 4.48438 4.48438C4.97396 3.99479 5.5625 3.75 6.25 3.75H23.75C24.4375 3.75 25.026 3.99479 25.5156 4.48438C26.0052 4.97396 26.25 5.5625 26.25 6.25V23.75C26.25 24.4375 26.0052 25.026 25.5156 25.5156C25.026 26.0052 24.4375 26.25 23.75 26.25H6.25ZM6.25 15H23.75V6.25H6.25V15ZM6.25 17.5V23.75H23.75V17.5H6.25Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const SupervisedUserCircleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 5C9.48 5 5 9.48 5 15C5 20.52 9.48 25 15 25C20.52 25 25 20.52 25 15C25 9.48 20.52 5 15 5ZM18.61 11.34C19.68 11.34 20.54 12.2 20.54 13.27C20.54 14.34 19.68 15.2 18.61 15.2C17.54 15.2 16.68 14.34 16.68 13.27C16.67 12.2 17.54 11.34 18.61 11.34ZM12.61 9.76C13.91 9.76 14.97 10.82 14.97 12.12C14.97 13.42 13.91 14.48 12.61 14.48C11.31 14.48 10.25 13.42 10.25 12.12C10.25 10.81 11.3 9.76 12.61 9.76ZM12.61 18.89V22.64C10.21 21.89 8.31 20.04 7.47 17.68C8.52 16.56 11.14 15.99 12.61 15.99C13.14 15.99 13.81 16.07 14.51 16.21C12.87 17.08 12.61 18.23 12.61 18.89ZM15 23C14.73 23 14.47 22.99 14.21 22.96V18.89C14.21 17.47 17.15 16.76 18.61 16.76C19.68 16.76 21.53 17.15 22.45 17.91C21.28 20.88 18.39 23 15 23Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const ContactSupportIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5 5C10.81 5 7 8.81 7 13.5C7 18.19 10.81 22 15.5 22H16V25C20.86 22.66 24 18 24 13.5C24 8.81 20.19 5 15.5 5ZM16.5 19.5H14.5V17.5H16.5V19.5ZM16.9 14.72C16.89 14.73 16.88 14.75 16.87 14.77C16.82 14.85 16.77 14.93 16.73 15.01C16.71 15.04 16.7 15.08 16.69 15.12C16.66 15.19 16.63 15.26 16.61 15.33C16.54 15.54 16.51 15.76 16.51 16.01H14.5C14.5 15.5 14.58 15.07 14.7 14.71C14.7 14.7 14.7 14.69 14.71 14.68C14.72 14.64 14.75 14.62 14.76 14.58C14.82 14.42 14.89 14.28 14.98 14.14C15.01 14.09 15.05 14.04 15.08 13.99C15.11 13.95 15.13 13.9 15.16 13.87L15.17 13.88C16.01 12.78 17.38 12.44 17.49 11.2C17.58 10.22 16.88 9.27 15.92 9.07C14.88 8.85 13.94 9.46 13.62 10.35C13.48 10.71 13.15 11 12.74 11H12.54C11.94 11 11.5 10.41 11.67 9.83C12.22 8.01 14.04 6.74 16.1 7.04C17.79 7.29 19.14 8.68 19.43 10.37C19.87 12.81 17.8 13.4 16.9 14.72Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const PublishIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            stroke="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.9668 7.96654C7.9668 8.47987 8.3868 8.89987 8.90013 8.89987H20.1001C20.6135 8.89987 21.0335 8.47987 21.0335 7.96654C21.0335 7.4532 20.6135 7.0332 20.1001 7.0332H8.90013C8.3868 7.0332 7.9668 7.4532 7.9668 7.96654ZM10.2161 16.3665H11.7001V21.0332C11.7001 21.5465 12.1201 21.9665 12.6335 21.9665H16.3668C16.8801 21.9665 17.3001 21.5465 17.3001 21.0332V16.3665H18.7841C19.6148 16.3665 20.0348 15.3585 19.4468 14.7705L15.1628 10.4865C14.9884 10.3118 14.7517 10.2136 14.5048 10.2136C14.2579 10.2136 14.0212 10.3118 13.8468 10.4865L9.5628 14.7705C8.9748 15.3585 9.38546 16.3665 10.2161 16.3665Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const SaveIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.2169 6.15028C18.8623 5.79561 18.3863 5.59961 17.8916 5.59961H7.46628C6.43028 5.59961 5.59961 6.43961 5.59961 7.46628V20.5329C5.59961 21.5596 6.43961 22.3996 7.46628 22.3996H20.5329C21.5596 22.3996 22.3996 21.5596 22.3996 20.5329V10.1076C22.3996 9.61294 22.2036 9.13694 21.8489 8.79161L19.2169 6.15028ZM13.9996 20.5329C12.4503 20.5329 11.1996 19.2823 11.1996 17.7329C11.1996 16.1836 12.4503 14.9329 13.9996 14.9329C15.5489 14.9329 16.7996 16.1836 16.7996 17.7329C16.7996 19.2823 15.5489 20.5329 13.9996 20.5329ZM14.9329 11.1996H9.33294C8.30628 11.1996 7.46628 10.3596 7.46628 9.33294C7.46628 8.30628 8.30628 7.46628 9.33294 7.46628H14.9329C15.9596 7.46628 16.7996 8.30628 16.7996 9.33294C16.7996 10.3596 15.9596 11.1996 14.9329 11.1996Z"
                stroke="none"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const DragHandleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.334 12H8.33398C7.78398 12 7.33398 12.45 7.33398 13C7.33398 13.55 7.78398 14 8.33398 14H22.334C22.884 14 23.334 13.55 23.334 13C23.334 12.45 22.884 12 22.334 12ZM8.33398 18H22.334C22.884 18 23.334 17.55 23.334 17C23.334 16.45 22.884 16 22.334 16H8.33398C7.78398 16 7.33398 16.45 7.33398 17C7.33398 17.55 7.78398 18 8.33398 18Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const NewReleasesIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0875 14.5515L23.2275 12.4315L23.4875 9.62149C23.5375 9.12149 23.1975 8.66149 22.7175 8.55149L19.9575 7.92149L18.5175 5.49149C18.2575 5.06149 17.7275 4.88149 17.2675 5.08149L14.6675 6.21149L12.0775 5.10149C11.6175 4.90149 11.0775 5.08149 10.8275 5.51149L9.3775 7.93149L6.6275 8.55149C6.1375 8.66149 5.7975 9.11149 5.8475 9.62149L6.1075 12.4215L4.2475 14.5515C3.9175 14.9315 3.9175 15.4915 4.2475 15.8715L6.1075 17.9915L5.8475 20.8115C5.7975 21.3115 6.1375 21.7715 6.6175 21.8815L9.3775 22.5115L10.8175 24.9315C11.0775 25.3615 11.6075 25.5415 12.0775 25.3415L14.6675 24.2115L17.2575 25.3215C17.7175 25.5215 18.2575 25.3415 18.5075 24.9115L19.9475 22.4815L22.7075 21.8515C23.1975 21.7415 23.5275 21.2815 23.4775 20.7815L23.2175 17.9715L25.0775 15.8515C25.4175 15.4915 25.4175 14.9315 25.0875 14.5515ZM15.6675 20.2115H13.6675V18.2115H15.6675V20.2115ZM14.6675 16.2115C14.1175 16.2115 13.6675 15.7615 13.6675 15.2115V11.2115C13.6675 10.6615 14.1175 10.2115 14.6675 10.2115C15.2175 10.2115 15.6675 10.6615 15.6675 11.2115V15.2115C15.6675 15.7615 15.2175 16.2115 14.6675 16.2115Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const ViewColumnIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.668 22H17.668C18.218 22 18.668 21.55 18.668 21V10C18.668 9.45 18.218 9 17.668 9H14.668C14.118 9 13.668 9.45 13.668 10V21C13.668 21.55 14.118 22 14.668 22ZM8.66797 22H11.668C12.218 22 12.668 21.55 12.668 21V10C12.668 9.45 12.218 9 11.668 9H8.66797C8.11797 9 7.66797 9.45 7.66797 10V21C7.66797 21.55 8.11797 22 8.66797 22ZM19.668 10V21C19.668 21.55 20.118 22 20.668 22H23.668C24.218 22 24.668 21.55 24.668 21V10C24.668 9.45 24.218 9 23.668 9H20.668C20.118 9 19.668 9.45 19.668 10Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const PhotoLibraryIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.334 19V7C25.334 5.9 24.434 5 23.334 5H11.334C10.234 5 9.33398 5.9 9.33398 7V19C9.33398 20.1 10.234 21 11.334 21H23.334C24.434 21 25.334 20.1 25.334 19ZM14.734 15.53L16.364 17.71L18.944 14.49C19.144 14.24 19.524 14.24 19.724 14.49L22.684 18.19C22.944 18.52 22.714 19 22.294 19H12.334C11.924 19 11.684 18.53 11.934 18.2L13.934 15.53C14.134 15.27 14.534 15.27 14.734 15.53ZM5.33398 10V23C5.33398 24.1 6.23398 25 7.33398 25H20.334C20.884 25 21.334 24.55 21.334 24C21.334 23.45 20.884 23 20.334 23H8.33398C7.78398 23 7.33398 22.55 7.33398 22V10C7.33398 9.45 6.88398 9 6.33398 9C5.78398 9 5.33398 9.45 5.33398 10Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}
export const VideoLibraryIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 9C5.45 9 5 9.45 5 10V23C5 24.1 5.9 25 7 25H20C20.55 25 21 24.55 21 24C21 23.45 20.55 23 20 23H8C7.45 23 7 22.55 7 22V10C7 9.45 6.55 9 6 9ZM23 5H11C9.9 5 9 5.9 9 7V19C9 20.1 9.9 21 11 21H23C24.1 21 25 20.1 25 19V7C25 5.9 24.1 5 23 5ZM15 17.5V8.5L20.47 12.6C20.74 12.8 20.74 13.2 20.47 13.4L15 17.5Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}
export const PermMediaIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.66797 9C4.11797 9 3.66797 9.45 3.66797 10V14H3.67797L3.66797 23C3.66797 24.1 4.56797 25 5.66797 25H22.668C23.218 25 23.668 24.55 23.668 24C23.668 23.45 23.218 23 22.668 23H6.66797C6.11797 23 5.66797 22.55 5.66797 22V10C5.66797 9.45 5.21797 9 4.66797 9ZM25.668 7H17.668L16.258 5.59C15.878 5.21 15.368 5 14.838 5H9.66797C8.56797 5 7.67797 5.9 7.67797 7L7.66797 19C7.66797 20.1 8.56797 21 9.66797 21H25.668C26.768 21 27.668 20.1 27.668 19V9C27.668 7.9 26.768 7 25.668 7ZM11.268 17.2L14.778 12.52C14.978 12.26 15.368 12.25 15.578 12.51L18.678 16.5L20.778 13.97C20.978 13.72 21.358 13.73 21.558 13.98L24.048 17.18C24.308 17.51 24.068 17.99 23.658 17.99H11.668C11.258 18 11.018 17.53 11.268 17.2Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const TextFieldsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.33398 9.5C6.33398 10.33 7.00398 11 7.83398 11H11.334V21.5C11.334 22.33 12.004 23 12.834 23C13.664 23 14.334 22.33 14.334 21.5V11H17.834C18.664 11 19.334 10.33 19.334 9.5C19.334 8.67 18.664 8 17.834 8H7.83398C7.00398 8 6.33398 8.67 6.33398 9.5ZM23.834 13H17.834C17.004 13 16.334 13.67 16.334 14.5C16.334 15.33 17.004 16 17.834 16H19.334V21.5C19.334 22.33 20.004 23 20.834 23C21.664 23 22.334 22.33 22.334 21.5V16H23.834C24.664 16 25.334 15.33 25.334 14.5C25.334 13.67 24.664 13 23.834 13Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const RadioButtonCheckedIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="30"
            viewBox="0 0 31 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.334 5C9.81398 5 5.33398 9.48 5.33398 15C5.33398 20.52 9.81398 25 15.334 25C20.854 25 25.334 20.52 25.334 15C25.334 9.48 20.854 5 15.334 5ZM15.334 23C10.914 23 7.33398 19.42 7.33398 15C7.33398 10.58 10.914 7 15.334 7C19.754 7 23.334 10.58 23.334 15C23.334 19.42 19.754 23 15.334 23ZM15.334 10C12.5726 10 10.334 12.2386 10.334 15C10.334 17.7614 12.5726 20 15.334 20C18.0954 20 20.334 17.7614 20.334 15C20.334 12.2386 18.0954 10 15.334 10Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const AttachmentIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.2539 19.5H9.67393C7.58393 19.5 5.72393 17.97 5.52393 15.89C5.29393 13.51 7.16393 11.5 9.50393 11.5H21.8639C23.1739 11.5 24.3639 12.44 24.4939 13.74C24.6439 15.24 23.4739 16.5 22.0039 16.5H11.5039C10.9539 16.5 10.5039 16.05 10.5039 15.5C10.5039 14.95 10.9539 14.5 11.5039 14.5H20.2539C20.6639 14.5 21.0039 14.16 21.0039 13.75C21.0039 13.34 20.6639 13 20.2539 13H11.6439C10.3339 13 9.14393 13.94 9.01393 15.24C8.86393 16.74 10.0339 18 11.5039 18H21.8339C23.9239 18 25.7839 16.47 25.9839 14.39C26.2139 12 24.3439 10 22.0039 10H9.73393C6.86393 10 4.29393 12.1 4.02393 14.96C3.72393 18.25 6.28393 21 9.50393 21H20.2539C20.6639 21 21.0039 20.66 21.0039 20.25C21.0039 19.84 20.6639 19.5 20.2539 19.5Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const VideoCamIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.6663 12.6004V9.33372C18.6663 8.82039 18.2463 8.40039 17.7329 8.40039H6.53294C6.01961 8.40039 5.59961 8.82039 5.59961 9.33372V18.6671C5.59961 19.1804 6.01961 19.6004 6.53294 19.6004H17.7329C18.2463 19.6004 18.6663 19.1804 18.6663 18.6671V15.4004L20.8036 17.5377C21.3916 18.1257 22.3996 17.7057 22.3996 16.8751V11.1164C22.3996 10.2857 21.3916 9.86572 20.8036 10.4537L18.6663 12.6004Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const MarkUnreadMailboxIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23 10H13V15C13 15.55 12.55 16 12 16C11.45 16 11 15.55 11 15V8H16C16.55 8 17 7.55 17 7V5C17 4.45 16.55 4 16 4H10C9.45 4 9 4.45 9 5V10H7C5.9 10 5 10.9 5 12V24C5 25.1 5.9 26 7 26H23C24.1 26 25 25.1 25 24V12C25 10.9 24.1 10 23 10Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const PinIcon = () => {
    return (
        <path
            width={30}
            height={30}
            stroke="none"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 0C3.13 0 0 3.13 0 7C0 11.17 4.42 16.92 6.24 19.11C6.64 19.59 7.37 19.59 7.77 19.11C9.58 16.92 14 11.17 14 7C14 3.13 10.87 0 7 0ZM7 9.5C5.62 9.5 4.5 8.38 4.5 7C4.5 5.62 5.62 4.5 7 4.5C8.38 4.5 9.5 5.62 9.5 7C9.5 8.38 8.38 9.5 7 9.5Z"
            fill="#C3CAD9"
        />
    )
}

export const PhotoIcon = () => {
    return (
        <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.9993 12.1349C12.453 12.1349 11.1993 13.3885 11.1993 14.9349C11.1993 16.4813 12.453 17.7349 13.9993 17.7349C15.5457 17.7349 16.7993 16.4813 16.7993 14.9349C16.7993 13.3885 15.5457 12.1349 13.9993 12.1349ZM21.466 7.46823H18.5073L17.35 6.20823C17.0047 5.82556 16.5007 5.60156 15.978 5.60156H12.0207C11.498 5.60156 10.994 5.82556 10.6393 6.20823L9.49135 7.46823H6.53268C5.50602 7.46823 4.66602 8.30823 4.66602 9.3349V20.5349C4.66602 21.5616 5.50602 22.4016 6.53268 22.4016H21.466C22.4927 22.4016 23.3327 21.5616 23.3327 20.5349V9.3349C23.3327 8.30823 22.4927 7.46823 21.466 7.46823ZM13.9993 19.6016C11.4233 19.6016 9.33268 17.5109 9.33268 14.9349C9.33268 12.3589 11.4233 10.2682 13.9993 10.2682C16.5753 10.2682 18.666 12.3589 18.666 14.9349C18.666 17.5109 16.5753 19.6016 13.9993 19.6016Z"
                fill="white"
            />
        </svg>
    )
}

export const xMark = (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.0675 12.1832C13.1256 12.2412 13.1717 12.3102 13.2031 12.386C13.2345 12.4619 13.2507 12.5432 13.2507 12.6253C13.2507 12.7075 13.2345 12.7888 13.2031 12.8647C13.1717 12.9405 13.1256 13.0095 13.0675 13.0675C13.0095 13.1256 12.9405 13.1717 12.8647 13.2031C12.7888 13.2345 12.7075 13.2507 12.6253 13.2507C12.5432 13.2507 12.4619 13.2345 12.386 13.2031C12.3102 13.1717 12.2412 13.1256 12.1832 13.0675L7.00035 7.88394L1.81753 13.0675C1.70026 13.1848 1.5412 13.2507 1.37535 13.2507C1.2095 13.2507 1.05044 13.1848 0.93316 13.0675C0.815885 12.9503 0.75 12.7912 0.75 12.6253C0.75 12.4595 0.815885 12.3004 0.93316 12.1832L6.11675 7.00035L0.93316 1.81753C0.815885 1.70026 0.75 1.5412 0.75 1.37535C0.75 1.2095 0.815885 1.05044 0.93316 0.93316C1.05044 0.815885 1.2095 0.75 1.37535 0.75C1.5412 0.75 1.70026 0.815885 1.81753 0.93316L7.00035 6.11675L12.1832 0.93316C12.3004 0.815885 12.4595 0.75 12.6253 0.75C12.7912 0.75 12.9503 0.815885 13.0675 0.93316C13.1848 1.05044 13.2507 1.2095 13.2507 1.37535C13.2507 1.5412 13.1848 1.70026 13.0675 1.81753L7.88394 7.00035L13.0675 12.1832Z"
            fill="#E62E2E"
        />
    </svg>
)

export const checkMark = (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.9425 6.06754L7.94254 16.0675C7.88449 16.1256 7.81556 16.1717 7.73969 16.2032C7.66381 16.2347 7.58248 16.2508 7.50035 16.2508C7.41821 16.2508 7.33688 16.2347 7.26101 16.2032C7.18514 16.1717 7.11621 16.1256 7.05816 16.0675L2.68316 11.6925C2.56588 11.5753 2.5 11.4162 2.5 11.2503C2.5 11.0845 2.56588 10.9254 2.68316 10.8082C2.80044 10.6909 2.9595 10.625 3.12535 10.625C3.2912 10.625 3.45026 10.6909 3.56753 10.8082L7.50035 14.7418L17.0582 5.18316C17.1754 5.06588 17.3345 5 17.5003 5C17.6662 5 17.8253 5.06588 17.9425 5.18316C18.0598 5.30044 18.1257 5.4595 18.1257 5.62535C18.1257 5.7912 18.0598 5.95026 17.9425 6.06754Z"
            fill="#13BF24"
        />
    </svg>
)
export const ArrowDownIcon =
    'M1.35641 0.880478C0.866407 1.37048 0.866407 2.16048 1.35641 2.65048L9.66641 10.9605C10.0564 11.3505 10.6864 11.3505 11.0764 10.9605L19.3864 2.65048C19.8764 2.16048 19.8764 1.37048 19.3864 0.880478C18.8964 0.390478 18.1064 0.390478 17.6164 0.880478L10.3664 8.12048L3.11641 0.870478C2.63641 0.390478 1.83641 0.390478 1.35641 0.880478Z'
export const TrophyIconPath =
    'M9.25 26.25V23.75H14.25V19.875C13.2292 19.6458 12.3177 19.2135 11.5156 18.5781C10.7135 17.9427 10.125 17.1458 9.75 16.1875C8.1875 16 6.88021 15.3177 5.82812 14.1406C4.77604 12.9635 4.25 11.5833 4.25 10V8.75C4.25 8.0625 4.49479 7.47396 4.98438 6.98438C5.47396 6.49479 6.0625 6.25 6.75 6.25H9.25V3.75H21.75V6.25H24.25C24.9375 6.25 25.526 6.49479 26.0156 6.98438C26.5052 7.47396 26.75 8.0625 26.75 8.75V10C26.75 11.5833 26.224 12.9635 25.1719 14.1406C24.1198 15.3177 22.8125 16 21.25 16.1875C20.875 17.1458 20.2865 17.9427 19.4844 18.5781C18.6823 19.2135 17.7708 19.6458 16.75 19.875V23.75H21.75V26.25H9.25ZM9.25 13.5V8.75H6.75V10C6.75 10.7917 6.97917 11.5052 7.4375 12.1406C7.89583 12.776 8.5 13.2292 9.25 13.5ZM15.5 17.5C16.5417 17.5 17.4271 17.1354 18.1562 16.4062C18.8854 15.6771 19.25 14.7917 19.25 13.75V6.25H11.75V13.75C11.75 14.7917 12.1146 15.6771 12.8438 16.4062C13.5729 17.1354 14.4583 17.5 15.5 17.5ZM21.75 13.5C22.5 13.2292 23.1042 12.776 23.5625 12.1406C24.0208 11.5052 24.25 10.7917 24.25 10V8.75H21.75V13.5Z'
export const FitnessIconPath =
    'M23.6525 17.4425L24.3725 16.7225C24.7625 16.3325 24.7625 15.7025 24.3725 15.3125L24.3525 15.2925C24.1657 15.1052 23.912 15 23.6475 15C23.383 15 23.1293 15.1052 22.9425 15.2925L20.0825 18.1525L11.5125 9.5825L14.3725 6.7225C14.7625 6.3325 14.7625 5.7025 14.3725 5.3125L14.3525 5.2925C14.1657 5.10525 13.912 5.00001 13.6475 5.00001C13.383 5.00001 13.1293 5.10525 12.9425 5.2925L12.2225 6.0125L11.5025 5.2925C11.1125 4.9025 10.4725 4.9025 10.0825 5.2925L8.6525 6.7225L7.9325 6.0025C7.5425 5.6125 6.8925 5.6125 6.5025 6.0025C6.1125 6.3925 6.1125 7.0425 6.5025 7.4325L7.2225 8.1525L5.7925 9.5825C5.4025 9.9725 5.4025 10.6025 5.7925 10.9925L6.5125 11.7125L5.7925 12.4425C5.4025 12.8325 5.4025 13.4625 5.7925 13.8525L5.8125 13.8725C6.2025 14.2625 6.8325 14.2625 7.2225 13.8725L10.0825 11.0125L18.6525 19.5825L15.7925 22.4425C15.4025 22.8325 15.4025 23.4625 15.7925 23.8525L15.8125 23.8725C16.2025 24.2625 16.8325 24.2625 17.2225 23.8725L17.9425 23.1525L18.6625 23.8725C19.0525 24.2625 19.6825 24.2625 20.0725 23.8725L21.5025 22.4425L22.2225 23.1625C22.6125 23.5525 23.2625 23.5525 23.6525 23.1625C24.0425 22.7725 24.0425 22.1225 23.6525 21.7325L22.9325 21.0125L24.3725 19.5825C24.7625 19.1925 24.7625 18.5625 24.3725 18.1725L23.6525 17.4425Z'
export const AccountBalanceIconPath =
    'M8.5 15.2425V19.2425C8.5 20.0725 9.17 20.7425 10 20.7425C10.83 20.7425 11.5 20.0725 11.5 19.2425V15.2425C11.5 14.4125 10.83 13.7425 10 13.7425C9.17 13.7425 8.5 14.4125 8.5 15.2425ZM14.5 15.2425V19.2425C14.5 20.0725 15.17 20.7425 16 20.7425C16.83 20.7425 17.5 20.0725 17.5 19.2425V15.2425C17.5 14.4125 16.83 13.7425 16 13.7425C15.17 13.7425 14.5 14.4125 14.5 15.2425ZM8 25.7425H24C24.83 25.7425 25.5 25.0725 25.5 24.2425C25.5 23.4125 24.83 22.7425 24 22.7425H8C7.17 22.7425 6.5 23.4125 6.5 24.2425C6.5 25.0725 7.17 25.7425 8 25.7425ZM20.5 15.2425V19.2425C20.5 20.0725 21.17 20.7425 22 20.7425C22.83 20.7425 23.5 20.0725 23.5 19.2425V15.2425C23.5 14.4125 22.83 13.7425 22 13.7425C21.17 13.7425 20.5 14.4125 20.5 15.2425ZM15.07 5.2325L7.17 9.3925C6.76 9.6025 6.5 10.0325 6.5 10.4925C6.5 11.1825 7.06 11.7425 7.75 11.7425H24.26C24.94 11.7425 25.5 11.1825 25.5 10.4925C25.5 10.0325 25.24 9.6025 24.83 9.3925L16.93 5.2325C16.35 4.9225 15.65 4.9225 15.07 5.2325Z'
export const SocialIconPath =
    'M15.5 10V8C15.5 6.9 14.6 6 13.5 6H7.5C6.4 6 5.5 6.9 5.5 8V22C5.5 23.1 6.4 24 7.5 24H23.5C24.6 24 25.5 23.1 25.5 22V12C25.5 10.9 24.6 10 23.5 10H15.5ZM9.5 22H7.5V20H9.5V22ZM9.5 18H7.5V16H9.5V18ZM9.5 14H7.5V12H9.5V14ZM9.5 10H7.5V8H9.5V10ZM13.5 22H11.5V20H13.5V22ZM13.5 18H11.5V16H13.5V18ZM13.5 14H11.5V12H13.5V14ZM13.5 10H11.5V8H13.5V10ZM22.5 22H15.5V20H17.5V18H15.5V16H17.5V14H15.5V12H22.5C23.05 12 23.5 12.45 23.5 13V21C23.5 21.55 23.05 22 22.5 22ZM21.5 14H19.5V16H21.5V14ZM21.5 18H19.5V20H21.5V18Z'
export const DateRangeIconPath =
    'M22.5 7H21.5V6C21.5 5.45 21.05 5 20.5 5C19.95 5 19.5 5.45 19.5 6V7H11.5V6C11.5 5.45 11.05 5 10.5 5C9.95 5 9.5 5.45 9.5 6V7H8.5C7.39 7 6.51 7.9 6.51 9L6.5 23C6.5 24.1 7.39 25 8.5 25H22.5C23.6 25 24.5 24.1 24.5 23V9C24.5 7.9 23.6 7 22.5 7ZM22.5 22C22.5 22.55 22.05 23 21.5 23H9.5C8.95 23 8.5 22.55 8.5 22V12H22.5V22ZM10.5 14H12.5V16H10.5V14ZM14.5 14H16.5V16H14.5V14ZM18.5 14H20.5V16H18.5V14Z'
export const DirectionRunIconPath =
    'M17.9202 8C19.0202 8 19.9202 7.1 19.9202 6C19.9202 4.9 19.0202 4 17.9202 4C16.8202 4 15.9202 4.9 15.9202 6C15.9202 7.1 16.8202 8 17.9202 8ZM14.7502 20L15.3202 17.5L17.4202 19.5V24.5C17.4202 25.05 17.8702 25.5 18.4202 25.5C18.9702 25.5 19.4202 25.05 19.4202 24.5V18.86C19.4202 18.31 19.2002 17.79 18.8002 17.41L17.3202 16L17.9202 13C18.9902 14.24 20.5402 15.13 22.2802 15.41C22.8802 15.5 23.4202 15.02 23.4202 14.41C23.4202 13.92 23.0602 13.51 22.5702 13.43C21.0502 13.18 19.7902 12.28 19.1202 11.1L18.1202 9.5C17.7202 8.9 17.1202 8.5 16.4202 8.5C16.1202 8.5 15.9202 8.6 15.6202 8.6L11.6402 10.28C10.9002 10.6 10.4202 11.32 10.4202 12.13V14.5C10.4202 15.05 10.8702 15.5 11.4202 15.5C11.9702 15.5 12.4202 15.05 12.4202 14.5V12.1L14.2202 11.4L12.6202 19.5L8.70022 18.7C8.16022 18.59 7.63022 18.94 7.52022 19.48V19.52C7.41022 20.06 7.76022 20.59 8.30022 20.7L12.4102 21.52C13.4702 21.73 14.5102 21.06 14.7502 20Z'
export const LayersIconPath =
    'M16.4825 21.54C16.1225 21.82 15.6125 21.82 15.2525 21.54L9.1025 16.76C8.74402 16.48 8.24098 16.48 7.8825 16.76C7.3725 17.16 7.3725 17.93 7.8825 18.33L14.6425 23.59C15.3625 24.15 16.3725 24.15 17.1025 23.59L23.8625 18.33C24.3725 17.93 24.3725 17.16 23.8625 16.76L23.8525 16.75C23.494 16.47 22.991 16.47 22.6325 16.75L16.4825 21.54ZM17.1125 18.52L23.8725 13.26C24.3825 12.86 24.3825 12.08 23.8725 11.68L17.1125 6.42C16.3925 5.86 15.3825 5.86 14.6525 6.42L7.8925 11.69C7.3825 12.09 7.3825 12.87 7.8925 13.27L14.6525 18.53C15.3725 19.09 16.3925 19.09 17.1125 18.52Z'
export const MonetizationOnIconPath =
    'M15.5 5C9.98 5 5.5 9.48 5.5 15C5.5 20.52 9.98 25 15.5 25C21.02 25 25.5 20.52 25.5 15C25.5 9.48 21.02 5 15.5 5ZM16.91 21.09V21.67C16.91 22.4 16.31 23 15.58 23H15.57C14.84 23 14.24 22.4 14.24 21.67V21.07C12.91 20.79 11.73 20.06 11.23 18.83C11 18.28 11.43 17.67 12.03 17.67H12.27C12.64 17.67 12.94 17.92 13.08 18.27C13.37 19.02 14.13 19.54 15.59 19.54C17.55 19.54 17.99 18.56 17.99 17.95C17.99 17.12 17.55 16.34 15.32 15.81C12.84 15.21 11.14 14.19 11.14 12.14C11.14 10.42 12.53 9.3 14.25 8.93V8.33C14.25 7.6 14.85 7 15.58 7H15.59C16.32 7 16.92 7.6 16.92 8.33V8.95C18.3 9.29 19.17 10.15 19.55 11.21C19.75 11.76 19.33 12.34 18.74 12.34H18.48C18.11 12.34 17.81 12.08 17.71 11.72C17.48 10.96 16.85 10.47 15.59 10.47C14.09 10.47 13.19 11.15 13.19 12.11C13.19 12.95 13.84 13.5 15.86 14.02C17.88 14.54 20.04 15.41 20.04 17.93C20.02 19.76 18.65 20.76 16.91 21.09Z'
export const SocialPeopleIconPath =
    'M19.5 14C21.16 14 22.49 12.66 22.49 11C22.49 9.34 21.16 8 19.5 8C17.84 8 16.5 9.34 16.5 11C16.5 12.66 17.84 14 19.5 14ZM11.5 14C13.16 14 14.49 12.66 14.49 11C14.49 9.34 13.16 8 11.5 8C9.84 8 8.5 9.34 8.5 11C8.5 12.66 9.84 14 11.5 14ZM11.5 16C9.17 16 4.5 17.17 4.5 19.5V21C4.5 21.55 4.95 22 5.5 22H17.5C18.05 22 18.5 21.55 18.5 21V19.5C18.5 17.17 13.83 16 11.5 16ZM19.5 16C19.21 16 18.88 16.02 18.53 16.05C18.55 16.06 18.56 16.08 18.57 16.09C19.71 16.92 20.5 18.03 20.5 19.5V21C20.5 21.35 20.43 21.69 20.32 22H25.5C26.05 22 26.5 21.55 26.5 21V19.5C26.5 17.17 21.83 16 19.5 16Z'
export const PermContactCalendarIconPath =
    'M22.5 7H21.5V6C21.5 5.45 21.05 5 20.5 5C19.95 5 19.5 5.45 19.5 6V7H11.5V6C11.5 5.45 11.05 5 10.5 5C9.95 5 9.5 5.45 9.5 6V7H8.5C7.39 7 6.5 7.9 6.5 9V23C6.5 24.1 7.4 25 8.5 25H22.5C23.6 25 24.5 24.1 24.5 23V9C24.5 7.9 23.6 7 22.5 7ZM15.5 10C17.16 10 18.5 11.34 18.5 13C18.5 14.66 17.16 16 15.5 16C13.84 16 12.5 14.66 12.5 13C12.5 11.34 13.84 10 15.5 10ZM21.5 22H9.5V21C9.5 19 13.5 17.9 15.5 17.9C17.5 17.9 21.5 19 21.5 21V22Z'
export const RecentActorsIconPath =
    'M24.5 9V21C24.5 21.55 24.95 22 25.5 22C26.05 22 26.5 21.55 26.5 21V9C26.5 8.45 26.05 8 25.5 8C24.95 8 24.5 8.45 24.5 9ZM21.5 22C22.05 22 22.5 21.55 22.5 21V9C22.5 8.45 22.05 8 21.5 8C20.95 8 20.5 8.45 20.5 9V21C20.5 21.55 20.95 22 21.5 22ZM17.5 8H5.5C4.95 8 4.5 8.45 4.5 9V21C4.5 21.55 4.95 22 5.5 22H17.5C18.05 22 18.5 21.55 18.5 21V9C18.5 8.45 18.05 8 17.5 8ZM11.5 10.75C12.74 10.75 13.75 11.76 13.75 13C13.75 14.24 12.74 15.25 11.5 15.25C10.26 15.25 9.25 14.24 9.25 13C9.25 11.76 10.26 10.75 11.5 10.75ZM16 20H7V19.25C7 17.75 10 17 11.5 17C13 17 16 17.75 16 19.25V20Z'
export const BodySystemIconPath =
    'M7.9 18L9.8 8.9L8 9.6V12H6V8.3L11.05 6.175C11.2833 6.075 11.5292 6.0125 11.7875 5.9875C12.0458 5.9625 12.2917 5.99167 12.525 6.075C12.7583 6.15833 12.9792 6.275 13.1875 6.425C13.3958 6.575 13.5667 6.76667 13.7 7L14.7 8.6C15.1667 9.35 15.7792 9.9375 16.5375 10.3625C17.2958 10.7875 18.1167 11 19 11V13C17.8333 13 16.7875 12.7667 15.8625 12.3C14.9375 11.8333 14.15 11.2333 13.5 10.5L12.9 12L15 14V18H13V14.95L11.05 13.15L10 18H7.9ZM13.5 5.5C12.95 5.5 12.4792 5.30417 12.0875 4.9125C11.6958 4.52083 11.5 4.05 11.5 3.5C11.5 2.95 11.6958 2.47917 12.0875 2.0875C12.4792 1.69583 12.95 1.5 13.5 1.5C14.05 1.5 14.5208 1.69583 14.9125 2.0875C15.3042 2.47917 15.5 2.95 15.5 3.5C15.5 4.05 15.3042 4.52083 14.9125 4.9125C14.5208 5.30417 14.05 5.5 13.5 5.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.0167 2.5125 8.23333 3.5375 6.65C4.5625 5.06667 5.9 3.86667 7.55 3.05L8.45 4.825C7.13333 5.475 6.0625 6.4375 5.2375 7.7125C4.4125 8.9875 4 10.4167 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12H22C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z'

export const SettingsIconPath =
    'M22.6593 15.98C22.6993 15.66 22.7293 15.34 22.7293 15C22.7293 14.66 22.6993 14.34 22.6593 14.02L24.7693 12.37C24.9593 12.22 25.0093 11.95 24.8893 11.73L22.8893 8.27C22.7693 8.05 22.4993 7.97 22.2793 8.05L19.7893 9.05C19.2693 8.65 18.7093 8.32 18.0993 8.07L17.7193 5.42C17.6893 5.18 17.4793 5 17.2293 5H13.2293C12.9793 5 12.7693 5.18 12.7393 5.42L12.3593 8.07C11.7493 8.32 11.1893 8.66 10.6693 9.05L8.17933 8.05C7.94933 7.96 7.68933 8.05 7.56933 8.27L5.56933 11.73C5.43933 11.95 5.49933 12.22 5.68933 12.37L7.79933 14.02C7.75933 14.34 7.72933 14.67 7.72933 15C7.72933 15.33 7.75933 15.66 7.79933 15.98L5.68933 17.63C5.49933 17.78 5.44933 18.05 5.56933 18.27L7.56933 21.73C7.68933 21.95 7.95933 22.03 8.17933 21.95L10.6693 20.95C11.1893 21.35 11.7493 21.68 12.3593 21.93L12.7393 24.58C12.7693 24.82 12.9793 25 13.2293 25H17.2293C17.4793 25 17.6893 24.82 17.7193 24.58L18.0993 21.93C18.7093 21.68 19.2693 21.34 19.7893 20.95L22.2793 21.95C22.5093 22.04 22.7693 21.95 22.8893 21.73L24.8893 18.27C25.0093 18.05 24.9593 17.78 24.7693 17.63L22.6593 15.98ZM15.2293 18.5C13.2993 18.5 11.7293 16.93 11.7293 15C11.7293 13.07 13.2993 11.5 15.2293 11.5C17.1593 11.5 18.7293 13.07 18.7293 15C18.7293 16.93 17.1593 18.5 15.2293 18.5Z'
export const StyleIconPath =
    'M6.73493 21.9L8.07493 22.46V13.43L5.64493 19.29C5.23493 20.31 5.72493 21.48 6.73493 21.9ZM26.2349 18.2L21.2749 6.23C20.9649 5.48 20.2349 5.02 19.4649 5C19.2049 5 18.9349 5.04 18.6749 5.15L11.3049 8.2C10.5549 8.51 10.0949 9.23 10.0749 10C10.0649 10.27 10.1149 10.54 10.2249 10.8L15.1849 22.77C15.4949 23.53 16.2349 23.99 17.0149 24C17.2749 24 17.5349 23.95 17.7849 23.85L25.1449 20.8C26.1649 20.38 26.6549 19.21 26.2349 18.2ZM12.0849 11C11.5349 11 11.0849 10.55 11.0849 10C11.0849 9.45 11.5349 9 12.0849 9C12.6349 9 13.0849 9.45 13.0849 10C13.0849 10.55 12.6349 11 12.0849 11ZM10.0849 22C10.0849 23.1 10.9849 24 12.0849 24H13.5349L10.0849 15.66V22Z'
export const ArtTrackIconPath =
    'M24.5 16H18.5C17.95 16 17.5 15.55 17.5 15C17.5 14.45 17.95 14 18.5 14H24.5C25.05 14 25.5 14.45 25.5 15C25.5 15.55 25.05 16 24.5 16ZM24.5 10H18.5C17.95 10 17.5 10.45 17.5 11C17.5 11.55 17.95 12 18.5 12H24.5C25.05 12 25.5 11.55 25.5 11C25.5 10.45 25.05 10 24.5 10ZM18.5 20H24.5C25.05 20 25.5 19.55 25.5 19C25.5 18.45 25.05 18 24.5 18H18.5C17.95 18 17.5 18.45 17.5 19C17.5 19.55 17.95 20 18.5 20ZM15.5 12V18C15.5 19.1 14.6 20 13.5 20H7.5C6.4 20 5.5 19.1 5.5 18V12C5.5 10.9 6.4 10 7.5 10H13.5C14.6 10 15.5 10.9 15.5 12ZM13.4 17.2L12.14 15.52C11.94 15.26 11.55 15.25 11.34 15.51L10 17.26L9.15 16.23C8.95 15.98 8.57 15.99 8.37 16.24L7.63 17.19C7.37 17.52 7.61 18 8.02 18H13C13.41 18 13.65 17.53 13.4 17.2Z'
export const EventNoteIconPath =
    'M19.5 14H11.5C10.95 14 10.5 14.45 10.5 15C10.5 15.55 10.95 16 11.5 16H19.5C20.05 16 20.5 15.55 20.5 15C20.5 14.45 20.05 14 19.5 14ZM22.5 7H21.5V6C21.5 5.45 21.05 5 20.5 5C19.95 5 19.5 5.45 19.5 6V7H11.5V6C11.5 5.45 11.05 5 10.5 5C9.95 5 9.5 5.45 9.5 6V7H8.5C7.39 7 6.5 7.9 6.5 9V23C6.5 24.1 7.39 25 8.5 25H22.5C23.6 25 24.5 24.1 24.5 23V9C24.5 7.9 23.6 7 22.5 7ZM21.5 23H9.5C8.95 23 8.5 22.55 8.5 22V12H22.5V22C22.5 22.55 22.05 23 21.5 23ZM16.5 18H11.5C10.95 18 10.5 18.45 10.5 19C10.5 19.55 10.95 20 11.5 20H16.5C17.05 20 17.5 19.55 17.5 19C17.5 18.45 17.05 18 16.5 18Z'
export const FolderIconPath =
    'M14.09 7.59C13.71 7.21 13.2 7 12.67 7H7.5C6.4 7 5.51 7.9 5.51 9L5.5 21C5.5 22.1 6.4 23 7.5 23H23.5C24.6 23 25.5 22.1 25.5 21V11C25.5 9.9 24.6 9 23.5 9H15.5L14.09 7.59Z'

export const UserProfileIconPath =
    'M15 5C9.48 5 5 9.48 5 15C5 20.52 9.48 25 15 25C20.52 25 25 20.52 25 15C25 9.48 20.52 5 15 5ZM15 8C16.66 8 18 9.34 18 11C18 12.66 16.66 14 15 14C13.34 14 12 12.66 12 11C12 9.34 13.34 8 15 8ZM15 22.2C12.5 22.2 10.29 20.92 9 18.98C9.03 16.99 13 15.9 15 15.9C16.99 15.9 20.97 16.99 21 18.98C19.71 20.92 17.5 22.2 15 22.2Z'
export const FileCopyIconPath =
    'M19 4H8C6.9 4 6 4.9 6 6V19C6 19.55 6.45 20 7 20C7.55 20 8 19.55 8 19V7C8 6.45 8.45 6 9 6H19C19.55 6 20 5.55 20 5C20 4.45 19.55 4 19 4ZM19.59 8.59L24.42 13.42C24.79 13.79 25 14.3 25 14.83V24C25 25.1 24.1 26 23 26H11.99C10.89 26 10 25.1 10 24L10.01 10C10.01 8.9 10.9 8 12 8H18.17C18.7 8 19.21 8.21 19.59 8.59ZM19 15H23.5L18 9.5V14C18 14.55 18.45 15 19 15Z'
export const HistoryIconPath =
    'M16.5515 6.00349C11.4615 5.86349 7.29153 9.95349 7.29153 15.0035H5.50153C5.05153 15.0035 4.83153 15.5435 5.15153 15.8535L7.94153 18.6535C8.14153 18.8535 8.45153 18.8535 8.65153 18.6535L11.4415 15.8535C11.7515 15.5435 11.5315 15.0035 11.0815 15.0035H9.29153C9.29153 11.1035 12.4715 7.95349 16.3915 8.00349C20.1115 8.05349 23.2415 11.1835 23.2915 14.9035C23.3415 18.8135 20.1915 22.0035 16.2915 22.0035C14.6815 22.0035 13.1915 21.4535 12.0115 20.5235C11.6115 20.2135 11.0515 20.2435 10.6915 20.6035C10.2715 21.0235 10.3015 21.7335 10.7715 22.0935C12.2915 23.2935 14.2015 24.0035 16.2915 24.0035C21.3415 24.0035 25.4315 19.8335 25.2915 14.7435C25.1615 10.0535 21.2415 6.13349 16.5515 6.00349ZM16.0415 11.0035C15.6315 11.0035 15.2915 11.3435 15.2915 11.7535V15.4335C15.2915 15.7835 15.4815 16.1135 15.7815 16.2935L18.9015 18.1435C19.2615 18.3535 19.7215 18.2335 19.9315 17.8835C20.1415 17.5235 20.0215 17.0635 19.6715 16.8535L16.7915 15.1435V11.7435C16.7915 11.3435 16.4515 11.0035 16.0415 11.0035Z'
export const ChatBubbleIconPath =
    'M23 5H7C5.9 5 5 5.9 5 7V25L9 21H23C24.1 21 25 20.1 25 19V7C25 5.9 24.1 5 23 5Z'
export const AccountBoxIconPath =
    'M6 8V22C6 23.1 6.89 24 8 24H22C23.1 24 24 23.1 24 22V8C24 6.9 23.1 6 22 6H8C6.89 6 6 6.9 6 8ZM18 12C18 13.66 16.66 15 15 15C13.34 15 12 13.66 12 12C12 10.34 13.34 9 15 9C16.66 9 18 10.34 18 12ZM9 20C9 18 13 16.9 15 16.9C17 16.9 21 18 21 20V21H9V20Z'
export const ArchiveIconPath =
    'M23.54 8.23L22.15 6.55C21.88 6.21 21.47 6 21 6H9C8.53 6 8.12 6.21 7.84 6.55L6.46 8.23C6.17 8.57 6 9.02 6 9.5V22C6 23.1 6.9 24 8 24H22C23.1 24 24 23.1 24 22V9.5C24 9.02 23.83 8.57 23.54 8.23ZM14.65 20.15L9.5 15H13V13H17V15H20.5L15.35 20.15C15.16 20.34 14.84 20.34 14.65 20.15ZM8.12 8L8.93 7H20.93L21.87 8H8.12Z'
export const ContactIcon =
    'M22 7H21V6C21 5.45 20.55 5 20 5C19.45 5 19 5.45 19 6V7H11V6C11 5.45 10.55 5 10 5C9.45 5 9 5.45 9 6V7H8C6.89 7 6 7.9 6 9V23C6 24.1 6.9 25 8 25H22C23.1 25 24 24.1 24 23V9C24 7.9 23.1 7 22 7ZM15 10C16.66 10 18 11.34 18 13C18 14.66 16.66 16 15 16C13.34 16 12 14.66 12 13C12 11.34 13.34 10 15 10ZM21 22H9V21C9 19 13 17.9 15 17.9C17 17.9 21 19 21 21V22Z'
export const TimeRoundIcon =
    'M16.5515 6.50349C11.4615 6.36349 7.29153 10.4535 7.29153 15.5035H5.50153C5.05153 15.5035 4.83153 16.0435 5.15153 16.3535L7.94153 19.1535C8.14153 19.3535 8.45153 19.3535 8.65153 19.1535L11.4415 16.3535C11.7515 16.0435 11.5315 15.5035 11.0815 15.5035H9.29153C9.29153 11.6035 12.4715 8.45349 16.3915 8.50349C20.1115 8.55349 23.2415 11.6835 23.2915 15.4035C23.3415 19.3135 20.1915 22.5035 16.2915 22.5035C14.6815 22.5035 13.1915 21.9535 12.0115 21.0235C11.6115 20.7135 11.0515 20.7435 10.6915 21.1035C10.2715 21.5235 10.3015 22.2335 10.7715 22.5935C12.2915 23.7935 14.2015 24.5035 16.2915 24.5035C21.3415 24.5035 25.4315 20.3335 25.2915 15.2435C25.1615 10.5535 21.2415 6.63349 16.5515 6.50349ZM16.0415 11.5035C15.6315 11.5035 15.2915 11.8435 15.2915 12.2535V15.9335C15.2915 16.2835 15.4815 16.6135 15.7815 16.7935L18.9015 18.6435C19.2615 18.8535 19.7215 18.7335 19.9315 18.3835C20.1415 18.0235 20.0215 17.5635 19.6715 17.3535L16.7915 15.6435V12.2435C16.7915 11.8435 16.4515 11.5035 16.0415 11.5035Z'

export const LocalOfferIconPath =
    'M24.41 14.58L15.41 5.58C15.05 5.22 14.55 5 14 5H7C5.9 5 5 5.9 5 7V14C5 14.55 5.22 15.05 5.59 15.42L14.59 24.42C14.95 24.78 15.45 25 16 25C16.55 25 17.05 24.78 17.41 24.41L24.41 17.41C24.78 17.05 25 16.55 25 16C25 15.45 24.77 14.94 24.41 14.58ZM8.5 10C7.67 10 7 9.33 7 8.5C7 7.67 7.67 7 8.5 7C9.33 7 10 7.67 10 8.5C10 9.33 9.33 10 8.5 10Z'

export const DisciplineIconPath =
    'M8.15 0.48L4.43 6.56C4.02 7.22 4.5 8.08 5.28 8.08H12.71C13.49 8.08 13.97 7.22 13.56 6.56L9.85 0.48C9.46 -0.16 8.54 -0.16 8.15 0.48ZM14.5 10.08C12.8923 10.08 11.4067 10.9377 10.6029 12.33C9.79904 13.7223 9.79904 15.4377 10.6029 16.83C11.4067 18.2223 12.8923 19.08 14.5 19.08C16.1077 19.08 17.5933 18.2223 18.3971 16.83C19.201 15.4377 19.201 13.7223 18.3971 12.33C17.5933 10.9377 16.1077 10.08 14.5 10.08ZM1 18.58H7C7.55 18.58 8 18.13 8 17.58V11.58C8 11.03 7.55 10.58 7 10.58H1C0.45 10.58 0 11.03 0 11.58V17.58C0 18.13 0.45 18.58 1 18.58Z'
export const CompetitionInProcessIcon =
    'M19.4325 9.85L20.8725 11.29L15.9925 16.17L12.7025 12.88C12.5157 12.6927 12.262 12.5875 11.9975 12.5875C11.733 12.5875 11.4793 12.6927 11.2925 12.88L5.2925 18.89C4.9025 19.28 4.9025 19.91 5.2925 20.3C5.6825 20.69 6.3125 20.69 6.7025 20.3L11.9925 15L15.2825 18.29C15.6725 18.68 16.3025 18.68 16.6925 18.29L22.2825 12.71L23.7225 14.15C24.0325 14.46 24.5725 14.24 24.5725 13.8V9.5C24.5825 9.22 24.3625 9 24.0825 9H19.7925C19.3425 9 19.1225 9.54 19.4325 9.85Z'

export const CompletedCompetitionsIcon =
    'M6 23.1738H16C16.55 23.1738 17 23.6238 17 24.1738C17 24.7238 16.55 25.1738 16 25.1738H6C5.45 25.1738 5 24.7238 5 24.1738C5 23.6238 5.45 23.1738 6 23.1738ZM9.24 10.2438L12.07 7.41376L24.8 20.1438C25.58 20.9238 25.58 22.1938 24.8 22.9738C24.02 23.7538 22.75 23.7538 21.97 22.9738L9.24 10.2438ZM17.73 4.58376L20.56 7.41376C21.34 8.19376 21.34 9.46376 20.56 10.2438L19.14 11.6638L13.49 6.00376L14.9 4.59376C15.68 3.80376 16.95 3.80376 17.73 4.58376ZM7.83 11.6538L13.49 17.3138L12.08 18.7238C11.3 19.5038 10.03 19.5038 9.25 18.7238L6.42 15.8938C5.64 15.1138 5.64 13.8438 6.42 13.0638L7.83 11.6538Z'

export const ApplicationIcon =
    'M23 7H7C5.9 7 5 7.9 5 9V21C5 22.1 5.9 23 7 23H23C24.1 23 25 22.1 25 21V9C25 7.9 24.1 7 23 7ZM8 15H10C10.55 15 11 15.45 11 16C11 16.55 10.55 17 10 17H8C7.45 17 7 16.55 7 16C7 15.45 7.45 15 8 15ZM16 21H8C7.45 21 7 20.55 7 20C7 19.45 7.45 19 8 19H16C16.55 19 17 19.45 17 20C17 20.55 16.55 21 16 21ZM22 21H20C19.45 21 19 20.55 19 20C19 19.45 19.45 19 20 19H22C22.55 19 23 19.45 23 20C23 20.55 22.55 21 22 21ZM22 17H14C13.45 17 13 16.55 13 16C13 15.45 13.45 15 14 15H22C22.55 15 23 15.45 23 16C23 16.55 22.55 17 22 17Z'

export const ApprovalAwaitIcon =
    'M7.78404 6.28404V13.284C7.78404 13.694 8.25404 13.934 8.58404 13.684L13.254 10.184C13.524 9.98404 13.524 9.58404 13.254 9.38404L8.58404 5.88404C8.25404 5.63404 7.78404 5.87404 7.78404 6.28404ZM8.78404 1.01404C8.78404 0.374038 8.19404 -0.115962 7.57404 0.0240375C6.45404 0.284038 5.39404 0.724038 4.45404 1.32404C3.92404 1.66404 3.84404 2.42404 4.29404 2.87404C4.61404 3.19404 5.12404 3.27404 5.50404 3.03404C6.27404 2.54404 7.12404 2.18404 8.04404 1.98404C8.48404 1.88404 8.78404 1.47404 8.78404 1.01404ZM2.88404 4.29404C2.42404 3.84404 1.67404 3.91404 1.33404 4.45404C0.734037 5.39404 0.294037 6.45404 0.0340375 7.57404C-0.105962 8.19404 0.374038 8.78404 1.01404 8.78404C1.46404 8.78404 1.88404 8.48404 1.97404 8.04404C2.17404 7.13404 2.54404 6.27404 3.02404 5.51404C3.28404 5.12404 3.20404 4.61404 2.88404 4.29404ZM1.01404 10.784C0.374038 10.784 -0.115962 11.374 0.0240375 11.994C0.284038 13.114 0.724038 14.164 1.32404 15.114C1.66404 15.654 2.42404 15.724 2.87404 15.274C3.19404 14.954 3.27404 14.444 3.02404 14.064C2.53404 13.304 2.17404 12.454 1.97404 11.534C1.88404 11.084 1.47404 10.784 1.01404 10.784ZM4.45404 18.234C5.40404 18.834 6.45404 19.274 7.57404 19.534C8.19404 19.674 8.78404 19.184 8.78404 18.554C8.78404 18.104 8.48404 17.684 8.04404 17.594C7.13404 17.394 6.27404 17.024 5.51404 16.544C5.12404 16.304 4.62404 16.374 4.30404 16.704C3.84404 17.144 3.91404 17.894 4.45404 18.234ZM19.784 9.78404C19.784 14.514 16.484 18.494 12.054 19.524C11.434 19.674 10.834 19.184 10.834 18.544C10.834 18.084 11.144 17.684 11.584 17.574C15.134 16.754 17.784 13.574 17.784 9.78404C17.784 5.99404 15.134 2.81404 11.584 1.99404C11.144 1.89404 10.834 1.48404 10.834 1.02404C10.834 0.384038 11.434 -0.105962 12.054 0.0440375C16.484 1.07404 19.784 5.05404 19.784 9.78404Z'

export const ApprovedIcon =
    'M5.1725 10.1625L1.7025 6.69249C1.51567 6.50523 1.26202 6.4 0.9975 6.4C0.732982 6.4 0.479331 6.50523 0.2925 6.69249C-0.0975 7.08249 -0.0975 7.71249 0.2925 8.10249L4.4725 12.2825C4.8625 12.6725 5.4925 12.6725 5.8825 12.2825L16.4625 1.70249C16.8525 1.31249 16.8525 0.682486 16.4625 0.292486C16.2757 0.105233 16.022 0 15.7575 0C15.493 0 15.2393 0.105233 15.0525 0.292486L5.1725 10.1625Z'

export const PersonIconPath =
    'M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V15C0 15.55 0.45 16 1 16H15C15.55 16 16 15.55 16 15V14C16 11.34 10.67 10 8 10Z'

export const TeamIndividualIconPath =
    'M14 8C16.21 8 18 6.21 18 4C18 1.79 16.21 0 14 0C11.79 0 10 1.79 10 4C10 6.21 11.79 8 14 8ZM5 6V4C5 3.45 4.55 3 4 3C3.45 3 3 3.45 3 4V6H1C0.45 6 0 6.45 0 7C0 7.55 0.45 8 1 8H3V10C3 10.55 3.45 11 4 11C4.55 11 5 10.55 5 10V8H7C7.55 8 8 7.55 8 7C8 6.45 7.55 6 7 6H5ZM14 10C11.33 10 6 11.34 6 14V15C6 15.55 6.45 16 7 16H21C21.55 16 22 15.55 22 15V14C22 11.34 16.67 10 14 10Z'

export const ApproveIconPath =
    'M1 19.1738H11C11.55 19.1738 12 19.6238 12 20.1738C12 20.7238 11.55 21.1738 11 21.1738H1C0.45 21.1738 0 20.7238 0 20.1738C0 19.6238 0.45 19.1738 1 19.1738ZM4.24 6.24376L7.07 3.41376L19.8 16.1438C20.58 16.9238 20.58 18.1938 19.8 18.9738C19.02 19.7538 17.75 19.7538 16.97 18.9738L4.24 6.24376ZM12.73 0.583756L15.56 3.41376C16.34 4.19376 16.34 5.46376 15.56 6.24376L14.14 7.66376L8.49 2.00376L9.9 0.593756C10.68 -0.196244 11.95 -0.196244 12.73 0.583756ZM2.83 7.65376L8.49 13.3138L7.08 14.7238C6.3 15.5038 5.03 15.5038 4.25 14.7238L1.42 11.8938C0.64 11.1138 0.64 9.84376 1.42 9.06376L2.83 7.65376Z'

export const DeclineIconPatch =
    'M9.99935 0.666687C4.83802 0.666687 0.666016 4.83869 0.666016 10C0.666016 15.1614 4.83802 19.3334 9.99935 19.3334C15.1607 19.3334 19.3327 15.1614 19.3327 10C19.3327 4.83869 15.1607 0.666687 9.99935 0.666687ZM14.0127 14.0134C13.6487 14.3774 13.0607 14.3774 12.6967 14.0134L9.99935 11.316L7.30202 14.0134C6.93802 14.3774 6.35002 14.3774 5.98602 14.0134C5.81125 13.839 5.71303 13.6022 5.71303 13.3554C5.71303 13.1085 5.81125 12.8717 5.98602 12.6974L8.68335 10L5.98602 7.30269C5.81125 7.12831 5.71303 6.89157 5.71303 6.64469C5.71303 6.3978 5.81125 6.16106 5.98602 5.98669C6.35002 5.62269 6.93802 5.62269 7.30202 5.98669L9.99935 8.68402L12.6967 5.98669C13.0607 5.62269 13.6487 5.62269 14.0127 5.98669C14.3767 6.35069 14.3767 6.93869 14.0127 7.30269L11.3153 10L14.0127 12.6974C14.3673 13.052 14.3673 13.6494 14.0127 14.0134Z'

export const RemoveIconPath =
    'M11.9993 29.3333C11.9993 30.8 13.1993 32 14.666 32H25.3327C26.7993 32 27.9993 30.8 27.9993 29.3333V16C27.9993 14.5333 26.7993 13.3333 25.3327 13.3333H14.666C13.1993 13.3333 11.9993 14.5333 11.9993 16V29.3333ZM27.9993 9.33333H24.666L23.7193 8.38667C23.4793 8.14667 23.1327 8 22.786 8H17.2127C16.866 8 16.5193 8.14667 16.2793 8.38667L15.3327 9.33333H11.9993C11.266 9.33333 10.666 9.93333 10.666 10.6667C10.666 11.4 11.266 12 11.9993 12H27.9993C28.7327 12 29.3327 11.4 29.3327 10.6667C29.3327 9.93333 28.7327 9.33333 27.9993 9.33333Z'

export const EditorModeIcon = () => {
    return (
        <path
            width="30"
            height="30"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 20.4625V23.5025C6 23.7825 6.22 24.0025 6.5 24.0025H9.54C9.67 24.0025 9.8 23.9525 9.89 23.8525L20.81 12.9425L17.06 9.19249L6.15 20.1025C6.05 20.2025 6 20.3225 6 20.4625ZM23.71 10.0425C24.1 9.65249 24.1 9.02249 23.71 8.63249L21.37 6.29249C21.1832 6.10523 20.9295 6 20.665 6C20.4005 6 20.1468 6.10523 19.96 6.29249L18.13 8.12249L21.88 11.8725L23.71 10.0425Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}
/** Material "translate" glyph, centred in the 30×30 group-button icon box */
export const TranslateIcon = () => {
    return (
        <path
            transform="translate(3 3)"
            d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}
export const PowerIcon = () => {
    return (
        <svg
            width="74"
            height="73"
            viewBox="0 0 74 73"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.687537 62.8118C0.492275 63.0071 0.492276 63.3237 0.687538 63.5189L9.98043 72.8118C10.1757 73.0071 10.4923 73.0071 10.6875 72.8118L26.6471 56.8522C26.8424 56.657 27.1589 56.657 27.3542 56.8522L36.2935 65.7916C36.6841 66.1821 37.3172 66.1821 37.7078 65.7916L57.0006 46.4987L63.3138 52.8118C63.509 53.0071 63.8256 53.0071 64.0209 52.8118L69.9804 46.8522C70.1757 46.657 70.1757 46.3404 69.9804 46.1451L60.334 36.4987L73.3138 23.5189C73.509 23.3237 73.509 23.0071 73.3138 22.8118L67.3542 16.8522C67.1589 16.657 66.8424 16.657 66.6471 16.8522L53.6673 29.832L43.6673 19.832L56.6471 6.85225C56.8424 6.65699 56.8424 6.34041 56.6471 6.14514L50.6875 0.185584C50.4923 -0.00967802 50.1757 -0.00967748 49.9804 0.185585L37.0006 13.1654L27.3542 3.51892C27.1589 3.32366 26.8424 3.32366 26.6471 3.51892L20.6875 9.47848C20.4923 9.67374 20.4923 9.99032 20.6875 10.1856L27.0006 16.4987L7.70776 35.7916C7.31723 36.1821 7.31723 36.8153 7.70776 37.2058L16.6471 46.1451C16.8424 46.3404 16.8424 46.657 16.6471 46.8522L0.687537 62.8118Z"
                fill="#9194AF"
            />
        </svg>
    )
}

export const CloseIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8925 8.30249C20.7057 8.11523 20.452 8.01 20.1875 8.01C19.923 8.01 19.6693 8.11523 19.4825 8.30249L14.5925 13.1825L9.7025 8.29249C9.51567 8.10523 9.26202 8 8.9975 8C8.73298 8 8.47933 8.10523 8.2925 8.29249C7.9025 8.68249 7.9025 9.31249 8.2925 9.70249L13.1825 14.5925L8.2925 19.4825C7.9025 19.8725 7.9025 20.5025 8.2925 20.8925C8.6825 21.2825 9.3125 21.2825 9.7025 20.8925L14.5925 16.0025L19.4825 20.8925C19.8725 21.2825 20.5025 21.2825 20.8925 20.8925C21.2825 20.5025 21.2825 19.8725 20.8925 19.4825L16.0025 14.5925L20.8925 9.70249C21.2725 9.32249 21.2725 8.68249 20.8925 8.30249Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const RemoveIcon = () => {
    return (
        <path
            width="30"
            height="30"
            stroke="none"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 22C9 23.1 9.9 24 11 24H19C20.1 24 21 23.1 21 22V12C21 10.9 20.1 10 19 10H11C9.9 10 9 10.9 9 12V22ZM21 7H18.5L17.79 6.29C17.61 6.11 17.35 6 17.09 6H12.91C12.65 6 12.39 6.11 12.21 6.29L11.5 7H9C8.45 7 8 7.45 8 8C8 8.55 8.45 9 9 9H21C21.55 9 22 8.55 22 8C22 7.45 21.55 7 21 7Z"
            fill="#C3CAD9"
        />
    )
}
interface RemoveIconProps {
    size?: number
    color?: string
    className?: string
}

/* eslint-disable react/prop-types */
export const CloseXIcon = ({
    size = 24,
    color = '#C3CAD9',
    className,
}: RemoveIconProps) => {
    /* eslint-enable react/prop-types */
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g id="Icon">
                <path
                    id="Icon_2"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7144 6.64043C16.5649 6.49062 16.362 6.40644 16.1504 6.40644C15.9388 6.40644 15.7359 6.49062 15.5864 6.64043L11.6744 10.5444L7.76239 6.63243C7.61293 6.48262 7.41 6.39844 7.19839 6.39844C6.98678 6.39844 6.78386 6.48262 6.63439 6.63243C6.32239 6.94443 6.32239 7.44843 6.63439 7.76043L10.5464 11.6724L6.63439 15.5844C6.32239 15.8964 6.32239 16.4004 6.63439 16.7124C6.94639 17.0244 7.45039 17.0244 7.76239 16.7124L11.6744 12.8004L15.5864 16.7124C15.8984 17.0244 16.4024 17.0244 16.7144 16.7124C17.0264 16.4004 17.0264 15.8964 16.7144 15.5844L12.8024 11.6724L16.7144 7.76043C17.0184 7.45643 17.0184 6.94443 16.7144 6.64043Z"
                    fill={color}
                />
            </g>
        </svg>
    )
}

export const ArrowDownSvgIcon = () => {
    return (
        <svg
            viewBox="-2 -4 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.35641 10.8805C5.86641 11.3705 5.86641 12.1605 6.35641 12.6505L14.6664 20.9605C15.0564 21.3505 15.6864 21.3505 16.0764 20.9605L24.3864 12.6505C24.8764 12.1605 24.8764 11.3705 24.3864 10.8805C23.8964 10.3905 23.1064 10.3905 22.6164 10.8805L15.3664 18.1205L8.11641 10.8705C7.63641 10.3905 6.83641 10.3905 6.35641 10.8805Z"
                fill="#2CAAE2"
            />
        </svg>
    )
}
export const ArrowUpSvgIcon = () => {
    return (
        <svg
            viewBox="-2 -4 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6436 19.6195C24.1336 19.1295 24.1336 18.3395 23.6436 17.8495L15.3336 9.53952C14.9436 9.14952 14.3136 9.14952 13.9236 9.53952L5.61359 17.8495C5.12359 18.3395 5.12359 19.1295 5.61359 19.6195C6.10359 20.1095 6.89359 20.1095 7.38359 19.6195L14.6336 12.3795L21.8836 19.6295C22.3636 20.1095 23.1636 20.1095 23.6436 19.6195Z"
                fill="#2CAAE2"
            />
        </svg>
    )
}

export const ContentAddIcon = () => {
    return (
        <g id="Icon">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 16H16V21C16 21.55 15.55 22 15 22C14.45 22 14 21.55 14 21V16H9C8.45 16 8 15.55 8 15C8 14.45 8.45 14 9 14H14V9C14 8.45 14.45 8 15 8C15.55 8 16 8.45 16 9V14H21C21.55 14 22 14.45 22 15C22 15.55 21.55 16 21 16Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </g>
    )
}

export const RemoveIconSvg = () => {
    return (
        <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9993 29.3333C11.9993 30.8 13.1993 32 14.666 32H25.3327C26.7993 32 27.9993 30.8 27.9993 29.3333V16C27.9993 14.5333 26.7993 13.3333 25.3327 13.3333H14.666C13.1993 13.3333 11.9993 14.5333 11.9993 16V29.3333ZM27.9993 9.33333H24.666L23.7193 8.38667C23.4793 8.14667 23.1327 8 22.786 8H17.2127C16.866 8 16.5193 8.14667 16.2793 8.38667L15.3327 9.33333H11.9993C11.266 9.33333 10.666 9.93333 10.666 10.6667C10.666 11.4 11.266 12 11.9993 12H27.9993C28.7327 12 29.3327 11.4 29.3327 10.6667C29.3327 9.93333 28.7327 9.33333 27.9993 9.33333Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const FastEventIcon = () => {
    return (
        <path
            stroke="none"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.83398 6.5349V14.9349C9.83398 15.4482 10.254 15.8682 10.7673 15.8682H12.634V22.5416C12.634 23.0176 13.2593 23.1856 13.502 22.7749L18.346 14.4682C18.71 13.8429 18.262 13.0682 17.5433 13.0682H15.434L17.758 6.86156C17.9913 6.2549 17.5433 5.60156 16.89 5.60156H10.7673C10.254 5.60156 9.83398 6.02156 9.83398 6.5349Z"
            fill="#C3CAD9"
        />
    )
}

export const FormationGroupIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 14C20.66 14 21.99 12.66 21.99 11C21.99 9.34 20.66 8 19 8C17.34 8 16 9.34 16 11C16 12.66 17.34 14 19 14ZM11 14C12.66 14 13.99 12.66 13.99 11C13.99 9.34 12.66 8 11 8C9.34 8 8 9.34 8 11C8 12.66 9.34 14 11 14ZM11 16C8.67 16 4 17.17 4 19.5V21C4 21.55 4.45 22 5 22H17C17.55 22 18 21.55 18 21V19.5C18 17.17 13.33 16 11 16ZM19 16C18.71 16 18.38 16.02 18.03 16.05C18.05 16.06 18.06 16.08 18.07 16.09C19.21 16.92 20 18.03 20 19.5V21C20 21.35 19.93 21.69 19.82 22H25C25.55 22 26 21.55 26 21V19.5C26 17.17 21.33 16 19 16Z"
            fill="currentColor"
        />
    )
}

export const FormationStatsIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 6H8C6.9 6 6 6.9 6 8V22C6 23.1 6.9 24 8 24H22C23.1 24 24 23.1 24 22V8C24 6.9 23.1 6 22 6ZM11 20C10.45 20 10 19.55 10 19V14C10 13.45 10.45 13 11 13C11.55 13 12 13.45 12 14V19C12 19.55 11.55 20 11 20ZM15 20C14.45 20 14 19.55 14 19V11C14 10.45 14.45 10 15 10C15.55 10 16 10.45 16 11V19C16 19.55 15.55 20 15 20ZM19 20C18.45 20 18 19.55 18 19V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20Z"
            fill="currentColor"
        />
    )
}

export const SportEventIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 14.53C18.71 14.24 18.23 14.24 17.94 14.53L13.59 18.88L12 17.29C11.71 17 11.23 17 10.94 17.29C10.65 17.58 10.65 18.06 10.94 18.35L12.88 20.29C13.27 20.68 13.9 20.68 14.29 20.29L18.99 15.59C19.29 15.3 19.29 14.82 19 14.53ZM22 7H21V6C21 5.45 20.55 5 20 5C19.45 5 19 5.45 19 6V7H11V6C11 5.45 10.55 5 10 5C9.45 5 9 5.45 9 6V7H8C6.89 7 6.01 7.9 6.01 9L6 23C6 24.1 6.89 25 8 25H22C23.1 25 24 24.1 24 23V9C24 7.9 23.1 7 22 7ZM21 23H9C8.45 23 8 22.55 8 22V12H22V22C22 22.55 21.55 23 21 23Z"
            fill="currentColor"
        />
    )
}

export const SportPositionIcon = () => {
    return (
        <path
            d="M11.8831 22C10.9013 22 10.0714 21.6548 9.39351 20.9643C8.71558 20.2738 8.37662 19.4286 8.37662 18.4286C8.37662 17.6032 8.61818 16.877 9.1013 16.25C9.58442 15.623 10.2 15.1984 10.9481 14.9762V12.9524H5.33766V9.14286H3V2.47619H9.54545V9.14286H7.20779V11.0476H16.5584V9.02381C15.8104 8.80159 15.1948 8.37698 14.7117 7.75C14.2286 7.12302 13.987 6.39683 13.987 5.57143C13.987 4.57143 14.326 3.72619 15.0039 3.03571C15.6818 2.34524 16.5117 2 17.4935 2C18.4753 2 19.3052 2.34524 19.9831 3.03571C20.661 3.72619 21 4.57143 21 5.57143C21 6.39683 20.7584 7.12302 20.2753 7.75C19.7922 8.37698 19.1766 8.80159 18.4286 9.02381V12.9524H12.8182V14.9762C13.5662 15.1984 14.1818 15.623 14.6649 16.25C15.1481 16.877 15.3896 17.6032 15.3896 18.4286C15.3896 19.4286 15.0506 20.2738 14.3727 20.9643C13.6948 21.6548 12.8649 22 11.8831 22ZM17.4935 7.2381C17.9455 7.2381 18.3312 7.0754 18.6506 6.75C18.9701 6.4246 19.1299 6.03175 19.1299 5.57143C19.1299 5.11111 18.9701 4.71825 18.6506 4.39286C18.3312 4.06746 17.9455 3.90476 17.4935 3.90476C17.0416 3.90476 16.6558 4.06746 16.3364 4.39286C16.0169 4.71825 15.8571 5.11111 15.8571 5.57143C15.8571 6.03175 16.0169 6.4246 16.3364 6.75C16.6558 7.0754 17.0416 7.2381 17.4935 7.2381ZM4.87013 7.2381H7.67532V4.38095H4.87013V7.2381ZM11.8831 20.0952C12.3351 20.0952 12.7208 19.9325 13.0403 19.6071C13.3597 19.2817 13.5195 18.8889 13.5195 18.4286C13.5195 17.9683 13.3597 17.5754 13.0403 17.25C12.7208 16.9246 12.3351 16.7619 11.8831 16.7619C11.4312 16.7619 11.0455 16.9246 10.726 17.25C10.4065 17.5754 10.2468 17.9683 10.2468 18.4286C10.2468 18.8889 10.4065 19.2817 10.726 19.6071C11.0455 19.9325 11.4312 20.0952 11.8831 20.0952Z"
            fill="currentColor"
        />
    )
}

export const FlagIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.4 9L17.16 7.8C17.07 7.34 16.66 7 16.18 7H9C8.45 7 8 7.45 8 8V23C8 23.55 8.45 24 9 24C9.55 24 10 23.55 10 23V17H15.6L15.84 18.2C15.93 18.67 16.34 19 16.82 19H22C22.55 19 23 18.55 23 18V10C23 9.45 22.55 9 22 9H17.4Z"
            fill="currentColor"
        />
    )
}

export const BasicInformationIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 17H10C10.55 17 11 16.55 11 16V14C11 13.45 10.55 13 10 13H8C7.45 13 7 13.45 7 14V16C7 16.55 7.45 17 8 17ZM8 22H10C10.55 22 11 21.55 11 21V19C11 18.45 10.55 18 10 18H8C7.45 18 7 18.45 7 19V21C7 21.55 7.45 22 8 22ZM8 12H10C10.55 12 11 11.55 11 11V9C11 8.45 10.55 8 10 8H8C7.45 8 7 8.45 7 9V11C7 11.55 7.45 12 8 12ZM13 17H23C23.55 17 24 16.55 24 16V14C24 13.45 23.55 13 23 13H13C12.45 13 12 13.45 12 14V16C12 16.55 12.45 17 13 17ZM13 22H23C23.55 22 24 21.55 24 21V19C24 18.45 23.55 18 23 18H13C12.45 18 12 18.45 12 19V21C12 21.55 12.45 22 13 22ZM12 9V11C12 11.55 12.45 12 13 12H23C23.55 12 24 11.55 24 11V9C24 8.45 23.55 8 23 8H13C12.45 8 12 8.45 12 9Z"
            fill="currentColor"
        />
    )
}

export const FastRemoveEventIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.3222 14.4682C19.6862 13.8429 19.2382 13.0682 18.5195 13.0682H16.7742L18.9022 15.1962L19.3222 14.4682ZM19.4715 6.9549C19.7795 6.32956 19.3315 5.60156 18.6315 5.60156H11.7435C11.2302 5.60156 10.8102 6.02156 10.8102 6.5349V7.10423L16.5315 12.8256L19.4715 6.9549ZM21.4875 20.4229L8.1222 7.05756C7.94783 6.88279 7.71109 6.78458 7.4642 6.78458C7.21732 6.78458 6.98058 6.88279 6.8062 7.05756C6.4422 7.42156 6.4422 8.00956 6.8062 8.37356L10.8102 12.3869V14.9349C10.8102 15.4482 11.2302 15.8682 11.7435 15.8682H13.6102V22.5416C13.6102 23.0176 14.2355 23.1856 14.4782 22.7749L16.9515 18.5282L20.1622 21.7389C20.5262 22.1029 21.1142 22.1029 21.4782 21.7389C21.8515 21.3749 21.8515 20.7869 21.4875 20.4229Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}
export const DisciplineIcon = () => {
    return (
        <path
            d="M11.8831 22C10.9013 22 10.0714 21.6548 9.39351 20.9643C8.71558 20.2738 8.37662 19.4286 8.37662 18.4286C8.37662 17.6032 8.61818 16.877 9.1013 16.25C9.58442 15.623 10.2 15.1984 10.9481 14.9762V12.9524H5.33766V9.14286H3V2.47619H9.54545V9.14286H7.20779V11.0476H16.5584V9.02381C15.8104 8.80159 15.1948 8.37698 14.7117 7.75C14.2286 7.12302 13.987 6.39683 13.987 5.57143C13.987 4.57143 14.326 3.72619 15.0039 3.03571C15.6818 2.34524 16.5117 2 17.4935 2C18.4753 2 19.3052 2.34524 19.9831 3.03571C20.661 3.72619 21 4.57143 21 5.57143C21 6.39683 20.7584 7.12302 20.2753 7.75C19.7922 8.37698 19.1766 8.80159 18.4286 9.02381V12.9524H12.8182V14.9762C13.5662 15.1984 14.1818 15.623 14.6649 16.25C15.1481 16.877 15.3896 17.6032 15.3896 18.4286C15.3896 19.4286 15.0506 20.2738 14.3727 20.9643C13.6948 21.6548 12.8649 22 11.8831 22ZM17.4935 7.2381C17.9455 7.2381 18.3312 7.0754 18.6506 6.75C18.9701 6.4246 19.1299 6.03175 19.1299 5.57143C19.1299 5.11111 18.9701 4.71825 18.6506 4.39286C18.3312 4.06746 17.9455 3.90476 17.4935 3.90476C17.0416 3.90476 16.6558 4.06746 16.3364 4.39286C16.0169 4.71825 15.8571 5.11111 15.8571 5.57143C15.8571 6.03175 16.0169 6.4246 16.3364 6.75C16.6558 7.0754 17.0416 7.2381 17.4935 7.2381ZM4.87013 7.2381H7.67532V4.38095H4.87013V7.2381ZM11.8831 20.0952C12.3351 20.0952 12.7208 19.9325 13.0403 19.6071C13.3597 19.2817 13.5195 18.8889 13.5195 18.4286C13.5195 17.9683 13.3597 17.5754 13.0403 17.25C12.7208 16.9246 12.3351 16.7619 11.8831 16.7619C11.4312 16.7619 11.0455 16.9246 10.726 17.25C10.4065 17.5754 10.2468 17.9683 10.2468 18.4286C10.2468 18.8889 10.4065 19.2817 10.726 19.6071C11.0455 19.9325 11.4312 20.0952 11.8831 20.0952Z"
            fill="currentColor"
        />
    )
}

export const ClosedLockIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 17C13.9 17 13 17.9 13 19C13 20.1 13.9 21 15 21C16.1 21 17 20.1 17 19C17 17.9 16.1 17 15 17ZM21 12H20V10C20 7.24 17.76 5 15 5C12.72 5 10.73 6.54 10.16 8.75C10.02 9.29 10.34 9.83 10.88 9.97C11.41 10.11 11.96 9.79 12.1 9.25C12.44 7.93 13.63 7 15 7C16.65 7 18 8.35 18 10V12H9C7.9 12 7 12.9 7 14V24C7 25.1 7.9 26 9 26H21C22.1 26 23 25.1 23 24V14C23 12.9 22.1 12 21 12ZM21 23C21 23.55 20.55 24 20 24H10C9.45 24 9 23.55 9 23V15C9 14.45 9.45 14 10 14H20C20.55 14 21 14.45 21 15V23Z"
            fill="#2CAAE2"
        />
    )
}

export const OpenLockIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 12H20V10C20 7.24 17.76 5 15 5C12.24 5 10 7.24 10 10V12H9C7.9 12 7 12.9 7 14V24C7 25.1 7.9 26 9 26H21C22.1 26 23 25.1 23 24V14C23 12.9 22.1 12 21 12ZM15 21C13.9 21 13 20.1 13 19C13 17.9 13.9 17 15 17C16.1 17 17 17.9 17 19C17 20.1 16.1 21 15 21ZM12 12V10C12 8.34 13.34 7 15 7C16.66 7 18 8.34 18 10V12H12Z"
            fill="#2CAAE2"
        />
    )
}

export const StandingsIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6996 9.33516H22.8996C23.4129 9.33516 23.8329 8.91516 23.8329 8.40182C23.8329 7.88849 23.4129 7.46849 22.8996 7.46849H11.6996C11.1863 7.46849 10.7663 7.88849 10.7663 8.40182C10.7663 8.91516 11.1863 9.33516 11.6996 9.33516ZM22.8996 18.6685H11.6996C11.1863 18.6685 10.7663 19.0885 10.7663 19.6018C10.7663 20.1152 11.1863 20.5352 11.6996 20.5352H22.8996C23.4129 20.5352 23.8329 20.1152 23.8329 19.6018C23.8329 19.0885 23.4129 18.6685 22.8996 18.6685ZM22.8996 13.0685H11.6996C11.1863 13.0685 10.7663 13.4885 10.7663 14.0018C10.7663 14.5152 11.1863 14.9352 11.6996 14.9352H22.8996C23.4129 14.9352 23.8329 14.5152 23.8329 14.0018C23.8329 13.4885 23.4129 13.0685 22.8996 13.0685ZM8.43294 17.7352H6.56628C6.30494 17.7352 6.09961 17.9405 6.09961 18.2018C6.09961 18.4632 6.30494 18.6685 6.56628 18.6685H7.96628V19.1352H7.49961C7.23828 19.1352 7.03294 19.3405 7.03294 19.6018C7.03294 19.8632 7.23828 20.0685 7.49961 20.0685H7.96628V20.5352H6.56628C6.30494 20.5352 6.09961 20.7405 6.09961 21.0018C6.09961 21.2632 6.30494 21.4685 6.56628 21.4685H8.43294C8.69428 21.4685 8.89961 21.2632 8.89961 21.0018V18.2018C8.89961 17.9405 8.69428 17.7352 8.43294 17.7352ZM6.56628 7.46849H7.03294V9.80182C7.03294 10.0632 7.23828 10.2685 7.49961 10.2685C7.76094 10.2685 7.96628 10.0632 7.96628 9.80182V7.00182C7.96628 6.74049 7.76094 6.53516 7.49961 6.53516H6.56628C6.30494 6.53516 6.09961 6.74049 6.09961 7.00182C6.09961 7.26316 6.30494 7.46849 6.56628 7.46849ZM8.43294 12.1352H6.56628C6.30494 12.1352 6.09961 12.3405 6.09961 12.6018C6.09961 12.8632 6.30494 13.0685 6.56628 13.0685H7.77961L6.21161 14.8978C6.13694 14.9818 6.09961 15.0938 6.09961 15.1965V15.4018C6.09961 15.6632 6.30494 15.8685 6.56628 15.8685H8.43294C8.69428 15.8685 8.89961 15.6632 8.89961 15.4018C8.89961 15.1405 8.69428 14.9352 8.43294 14.9352H7.21961L8.78761 13.1058C8.86228 13.0218 8.89961 12.9098 8.89961 12.8072V12.6018C8.89961 12.3405 8.69428 12.1352 8.43294 12.1352Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const ExportIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.7841 12.1352H17.3001V7.46849C17.3001 6.95516 16.8801 6.53516 16.3668 6.53516H12.6335C12.1201 6.53516 11.7001 6.95516 11.7001 7.46849V12.1352H10.2161C9.38546 12.1352 8.96546 13.1432 9.55346 13.7312L13.8375 18.0152C14.2015 18.3792 14.7895 18.3792 15.1535 18.0152L19.4375 13.7312C20.0255 13.1432 19.6148 12.1352 18.7841 12.1352ZM7.9668 21.4685C7.9668 21.9818 8.3868 22.4018 8.90013 22.4018H20.1001C20.6135 22.4018 21.0335 21.9818 21.0335 21.4685C21.0335 20.9552 20.6135 20.5352 20.1001 20.5352H8.90013C8.3868 20.5352 7.9668 20.9552 7.9668 21.4685Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const ApplicationButtonIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.466 7.03516H6.53268C5.50602 7.03516 4.66602 7.87516 4.66602 8.90182V20.1018C4.66602 21.1285 5.50602 21.9685 6.53268 21.9685H21.466C22.4927 21.9685 23.3327 21.1285 23.3327 20.1018V8.90182C23.3327 7.87516 22.4927 7.03516 21.466 7.03516ZM7.46602 14.5018H9.33268C9.84602 14.5018 10.266 14.9218 10.266 15.4352C10.266 15.9485 9.84602 16.3685 9.33268 16.3685H7.46602C6.95268 16.3685 6.53268 15.9485 6.53268 15.4352C6.53268 14.9218 6.95268 14.5018 7.46602 14.5018ZM14.9327 20.1018H7.46602C6.95268 20.1018 6.53268 19.6818 6.53268 19.1685C6.53268 18.6552 6.95268 18.2352 7.46602 18.2352H14.9327C15.446 18.2352 15.866 18.6552 15.866 19.1685C15.866 19.6818 15.446 20.1018 14.9327 20.1018ZM20.5327 20.1018H18.666C18.1527 20.1018 17.7327 19.6818 17.7327 19.1685C17.7327 18.6552 18.1527 18.2352 18.666 18.2352H20.5327C21.046 18.2352 21.466 18.6552 21.466 19.1685C21.466 19.6818 21.046 20.1018 20.5327 20.1018ZM20.5327 16.3685H13.066C12.5527 16.3685 12.1327 15.9485 12.1327 15.4352C12.1327 14.9218 12.5527 14.5018 13.066 14.5018H20.5327C21.046 14.5018 21.466 14.9218 21.466 15.4352C21.466 15.9485 21.046 16.3685 20.5327 16.3685Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const TeamApprovalIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.7324 13.5648C19.2818 13.5648 20.5231 12.3142 20.5231 10.7648C20.5231 9.21551 19.2818 7.96484 17.7324 7.96484C16.1831 7.96484 14.9324 9.21551 14.9324 10.7648C14.9324 12.3142 16.1831 13.5648 17.7324 13.5648ZM10.2658 13.5648C11.8151 13.5648 13.0564 12.3142 13.0564 10.7648C13.0564 9.21551 11.8151 7.96484 10.2658 7.96484C8.71642 7.96484 7.46576 9.21551 7.46576 10.7648C7.46576 12.3142 8.71642 13.5648 10.2658 13.5648ZM10.2658 15.4315C8.09109 15.4315 3.73242 16.5235 3.73242 18.6982V20.0982C3.73242 20.6115 4.15242 21.0315 4.66576 21.0315H15.8658C16.3791 21.0315 16.7991 20.6115 16.7991 20.0982V18.6982C16.7991 16.5235 12.4404 15.4315 10.2658 15.4315ZM17.7324 15.4315C17.4618 15.4315 17.1538 15.4502 16.8271 15.4782C16.8458 15.4875 16.8551 15.5062 16.8644 15.5155C17.9284 16.2902 18.6658 17.3262 18.6658 18.6982V20.0982C18.6658 20.4248 18.6004 20.7422 18.4978 21.0315H23.3324C23.8458 21.0315 24.2658 20.6115 24.2658 20.0982V18.6982C24.2658 16.5235 19.9071 15.4315 17.7324 15.4315Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const FileIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 5C7.9 5 7.01 5.9 7.01 7L7 23C7 24.1 7.89 25 8.99 25H21C22.1 25 23 24.1 23 23V11.83C23 11.3 22.79 10.79 22.41 10.42L17.58 5.59C17.21 5.21 16.7 5 16.17 5H9ZM16 11V6.5L21.5 12H17C16.45 12 16 11.55 16 11Z"
            fill="#D3D4DF"
        />
    )
}

export const DeclineCallIcon = () => {
    return (
        <svg
            viewBox="0 -5 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.87028 12.5036C8.23428 12.8676 8.82228 12.8676 9.18628 12.5036L12.5369 9.15294C12.9009 8.78894 12.9009 8.20094 12.5369 7.83694L9.18628 4.48628C9.0119 4.31151 8.77516 4.21329 8.52828 4.21329C8.28139 4.21329 8.04465 4.31151 7.87028 4.48628C7.50628 4.85028 7.50628 5.43828 7.87028 5.80228L9.62494 7.56628H1.53294C1.01961 7.56628 0.599609 7.98628 0.599609 8.49961C0.599609 9.01294 1.01961 9.43294 1.53294 9.43294H9.62494L7.87028 11.1876C7.50628 11.5516 7.51561 12.1489 7.87028 12.5036ZM15.5329 0.0996094H2.46628C1.43028 0.0996094 0.599609 0.939609 0.599609 1.96628V4.76628C0.599609 5.27961 1.01961 5.69961 1.53294 5.69961C2.04628 5.69961 2.46628 5.27961 2.46628 4.76628V2.89961C2.46628 2.38628 2.88628 1.96628 3.39961 1.96628H14.5996C15.1129 1.96628 15.5329 2.38628 15.5329 2.89961V14.0996C15.5329 14.6129 15.1129 15.0329 14.5996 15.0329H3.39961C2.88628 15.0329 2.46628 14.6129 2.46628 14.0996V12.2329C2.46628 11.7196 2.04628 11.2996 1.53294 11.2996C1.01961 11.2996 0.599609 11.7196 0.599609 12.2329V15.0329C0.599609 16.0596 1.43961 16.8996 2.46628 16.8996H15.5329C16.5596 16.8996 17.3996 16.0596 17.3996 15.0329V1.96628C17.3996 0.939609 16.5596 0.0996094 15.5329 0.0996094Z"
                fill="#D3D4DF"
                stroke="#D3D4DF"
            />
        </svg>
    )
}

export const WaitingApprovalIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.78404 6.28404V13.284C7.78404 13.694 8.25404 13.934 8.58404 13.684L13.254 10.184C13.524 9.98404 13.524 9.58404 13.254 9.38404L8.58404 5.88404C8.25404 5.63404 7.78404 5.87404 7.78404 6.28404ZM8.78404 1.01404C8.78404 0.374038 8.19404 -0.115962 7.57404 0.0240375C6.45404 0.284038 5.39404 0.724038 4.45404 1.32404C3.92404 1.66404 3.84404 2.42404 4.29404 2.87404C4.61404 3.19404 5.12404 3.27404 5.50404 3.03404C6.27404 2.54404 7.12404 2.18404 8.04404 1.98404C8.48404 1.88404 8.78404 1.47404 8.78404 1.01404ZM2.88404 4.29404C2.42404 3.84404 1.67404 3.91404 1.33404 4.45404C0.734037 5.39404 0.294037 6.45404 0.0340375 7.57404C-0.105962 8.19404 0.374038 8.78404 1.01404 8.78404C1.46404 8.78404 1.88404 8.48404 1.97404 8.04404C2.17404 7.13404 2.54404 6.27404 3.02404 5.51404C3.28404 5.12404 3.20404 4.61404 2.88404 4.29404ZM1.01404 10.784C0.374038 10.784 -0.115962 11.374 0.0240375 11.994C0.284038 13.114 0.724038 14.164 1.32404 15.114C1.66404 15.654 2.42404 15.724 2.87404 15.274C3.19404 14.954 3.27404 14.444 3.02404 14.064C2.53404 13.304 2.17404 12.454 1.97404 11.534C1.88404 11.084 1.47404 10.784 1.01404 10.784ZM4.45404 18.234C5.40404 18.834 6.45404 19.274 7.57404 19.534C8.19404 19.674 8.78404 19.184 8.78404 18.554C8.78404 18.104 8.48404 17.684 8.04404 17.594C7.13404 17.394 6.27404 17.024 5.51404 16.544C5.12404 16.304 4.62404 16.374 4.30404 16.704C3.84404 17.144 3.91404 17.894 4.45404 18.234ZM19.784 9.78404C19.784 14.514 16.484 18.494 12.054 19.524C11.434 19.674 10.834 19.184 10.834 18.544C10.834 18.084 11.144 17.684 11.584 17.574C15.134 16.754 17.784 13.574 17.784 9.78404C17.784 5.99404 15.134 2.81404 11.584 1.99404C11.144 1.89404 10.834 1.48404 10.834 1.02404C10.834 0.384038 11.434 -0.105962 12.054 0.0440375C16.484 1.07404 19.784 5.05404 19.784 9.78404Z"
            fill="currentColor"
        />
    )
}

export const ApproveCallIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.1725 10.1625L1.7025 6.69249C1.51567 6.50523 1.26202 6.4 0.9975 6.4C0.732982 6.4 0.479331 6.50523 0.2925 6.69249C-0.0975 7.08249 -0.0975 7.71249 0.2925 8.10249L4.4725 12.2825C4.8625 12.6725 5.4925 12.6725 5.8825 12.2825L16.4625 1.70249C16.8525 1.31249 16.8525 0.682486 16.4625 0.292486C16.2757 0.105233 16.022 0 15.7575 0C15.493 0 15.2393 0.105233 15.0525 0.292486L5.1725 10.1625Z"
            fill="currentColor"
        />
    )
}

export const DraggableIndicatorIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 14C4 15.1 3.1 16 2 16C0.9 16 0 15.1 0 14C0 12.9 0.9 12 2 12C3.1 12 4 12.9 4 14ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 0 8 0C6.9 0 6 0.9 6 2C6 3.1 6.9 4 8 4ZM8 6C6.9 6 6 6.9 6 8C6 9.1 6.9 10 8 10C9.1 10 10 9.1 10 8C10 6.9 9.1 6 8 6ZM8 12C6.9 12 6 12.9 6 14C6 15.1 6.9 16 8 16C9.1 16 10 15.1 10 14C10 12.9 9.1 12 8 12Z"
            fill="#C3CAD9"
        />
    )
}

export const ClockIconPath = () => {
    return (
        <path
            d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM9.78 5H9.72C9.32 5 9 5.32 9 5.72V10.44C9 10.79 9.18 11.12 9.49 11.3L13.64 13.79C13.98 13.99 14.42 13.89 14.62 13.55C14.83 13.21 14.72 12.76 14.37 12.56L10.5 10.26V5.72C10.5 5.32 10.18 5 9.78 5Z"
            fill="currenColor"
        />
    )
}

export const LocationIconPath = () => {
    return (
        <path
            d="M13 6C13 2.69 10.31 0 7 0C3.69 0 1 2.69 1 6C1 9.49 4.62 14.19 6.23 16.12C6.63 16.6 7.36 16.6 7.76 16.12C9.38 14.19 13 9.49 13 6ZM5 6C5 4.9 5.9 4 7 4C8.1 4 9 4.9 9 6C9 7.1 8.11 8 7 8C5.9 8 5 7.1 5 6ZM0 19C0 19.55 0.45 20 1 20H13C13.55 20 14 19.55 14 19C14 18.45 13.55 18 13 18H1C0.45 18 0 18.45 0 19Z"
            fill="currenColor"
        />
    )
}

export const DeclinedIconPath =
    'M16.89 11.7L15 13.59L13.11 11.7C12.9232 11.5127 12.6695 11.4075 12.405 11.4075C12.1405 11.4075 11.8868 11.5127 11.7 11.7C11.31 12.09 11.31 12.72 11.7 13.11L13.59 15L11.7 16.89C11.31 17.28 11.31 17.91 11.7 18.3C12.09 18.69 12.72 18.69 13.11 18.3L15 16.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L16.41 15L18.3 13.11C18.69 12.72 18.69 12.09 18.3 11.7C17.91 11.32 17.27 11.32 16.89 11.7ZM15 5C9.47 5 5 9.47 5 15C5 20.53 9.47 25 15 25C20.53 25 25 20.53 25 15C25 9.47 20.53 5 15 5ZM15 23C10.59 23 7 19.41 7 15C7 10.59 10.59 7 15 7C19.41 7 23 10.59 23 15C23 19.41 19.41 23 15 23Z'
export const TeamIconPath =
    'M19 14C20.66 14 21.99 12.66 21.99 11C21.99 9.34 20.66 8 19 8C17.34 8 16 9.34 16 11C16 12.66 17.34 14 19 14ZM11 14C12.66 14 13.99 12.66 13.99 11C13.99 9.34 12.66 8 11 8C9.34 8 8 9.34 8 11C8 12.66 9.34 14 11 14ZM11 16C8.67 16 4 17.17 4 19.5V21C4 21.55 4.45 22 5 22H17C17.55 22 18 21.55 18 21V19.5C18 17.17 13.33 16 11 16ZM19 16C18.71 16 18.38 16.02 18.03 16.05C18.05 16.06 18.06 16.08 18.07 16.09C19.21 16.92 20 18.03 20 19.5V21C20 21.35 19.93 21.69 19.82 22H25C25.55 22 26 21.55 26 21V19.5C26 17.17 21.33 16 19 16Z'
export const IndividualIconPath =
    'M15 15C17.21 15 19 13.21 19 11C19 8.79 17.21 7 15 7C12.79 7 11 8.79 11 11C11 13.21 12.79 15 15 15ZM15 17C12.33 17 7 18.34 7 21V22C7 22.55 7.45 23 8 23H22C22.55 23 23 22.55 23 22V21C23 18.34 17.67 17 15 17Z'
export const MixedIconPath =
    'M18 15C20.21 15 22 13.21 22 11C22 8.79 20.21 7 18 7C15.79 7 14 8.79 14 11C14 13.21 15.79 15 18 15ZM9 13V11C9 10.45 8.55 10 8 10C7.45 10 7 10.45 7 11V13H5C4.45 13 4 13.45 4 14C4 14.55 4.45 15 5 15H7V17C7 17.55 7.45 18 8 18C8.55 18 9 17.55 9 17V15H11C11.55 15 12 14.55 12 14C12 13.45 11.55 13 11 13H9ZM18 17C15.33 17 10 18.34 10 21V22C10 22.55 10.45 23 11 23H25C25.55 23 26 22.55 26 22V21C26 18.34 20.67 17 18 17Z'

export const TeamsIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.7324 13.0668C19.2818 13.0668 20.5231 11.8161 20.5231 10.2668C20.5231 8.71746 19.2818 7.4668 17.7324 7.4668C16.1831 7.4668 14.9324 8.71746 14.9324 10.2668C14.9324 11.8161 16.1831 13.0668 17.7324 13.0668ZM10.2658 13.0668C11.8151 13.0668 13.0564 11.8161 13.0564 10.2668C13.0564 8.71746 11.8151 7.4668 10.2658 7.4668C8.71642 7.4668 7.46576 8.71746 7.46576 10.2668C7.46576 11.8161 8.71642 13.0668 10.2658 13.0668ZM10.2658 14.9335C8.09109 14.9335 3.73242 16.0255 3.73242 18.2001V19.6001C3.73242 20.1135 4.15242 20.5335 4.66576 20.5335H15.8658C16.3791 20.5335 16.7991 20.1135 16.7991 19.6001V18.2001C16.7991 16.0255 12.4404 14.9335 10.2658 14.9335ZM17.7324 14.9335C17.4618 14.9335 17.1538 14.9521 16.8271 14.9801C16.8458 14.9895 16.8551 15.0081 16.8644 15.0175C17.9284 15.7921 18.6658 16.8281 18.6658 18.2001V19.6001C18.6658 19.9268 18.6004 20.2441 18.4978 20.5335H23.3324C23.8458 20.5335 24.2658 20.1135 24.2658 19.6001V18.2001C24.2658 16.0255 19.9071 14.9335 17.7324 14.9335Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const CheckOutIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.47268 22.2924L22.7593 15.3111C23.5154 14.9844 23.5154 13.9204 22.7593 13.5938L6.47268 6.61242C5.85668 6.34176 5.17535 6.79909 5.17535 7.46176L5.16602 11.7644C5.16602 12.2311 5.51135 12.6324 5.97802 12.6884L19.166 14.4524L5.97802 16.2071C5.51135 16.2724 5.16602 16.6738 5.16602 17.1404L5.17535 21.4431C5.17535 22.1058 5.85668 22.5631 6.47268 22.2924Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const ActionCheckCircleFilled = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9993 5.16797C8.84735 5.16797 4.66602 9.3493 4.66602 14.5013C4.66602 19.6533 8.84735 23.8346 13.9993 23.8346C19.1514 23.8346 23.3327 19.6533 23.3327 14.5013C23.3327 9.3493 19.1514 5.16797 13.9993 5.16797ZM11.47 18.5053L8.11935 15.1546C7.94458 14.9803 7.84636 14.7435 7.84636 14.4966C7.84636 14.2498 7.94458 14.013 8.11935 13.8386C8.48335 13.4746 9.07135 13.4746 9.43535 13.8386L12.1327 16.5266L18.554 10.1053C18.918 9.7413 19.506 9.7413 19.87 10.1053C20.234 10.4693 20.234 11.0573 19.87 11.4213L12.786 18.5053C12.4313 18.8693 11.834 18.8693 11.47 18.5053Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

/** Filled circle with a cross, sized to match `ActionCheckCircleFilled`. */
export const ActionCancelCircleFilled = () => {
    return (
        <path
            transform="translate(14 14.5) scale(0.9333) translate(-12 -12)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM16.3 16.3C15.91 16.69 15.28 16.69 14.89 16.3L12 13.41L9.11 16.3C8.72 16.69 8.09 16.69 7.7 16.3C7.31 15.91 7.31 15.28 7.7 14.89L10.59 12L7.7 9.11C7.31 8.72 7.31 8.09 7.7 7.7C8.09 7.31 8.72 7.31 9.11 7.7L12 10.59L14.89 7.7C15.28 7.31 15.91 7.31 16.3 7.7C16.69 8.09 16.69 8.72 16.3 9.11L13.41 12L16.3 14.89C16.68 15.27 16.68 15.91 16.3 16.3Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const PencilDarkIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.59961 19.0999V21.9372C5.59961 22.1985 5.80494 22.4039 6.06628 22.4039H8.90361C9.02494 22.4039 9.14628 22.3572 9.23028 22.2639L19.4223 12.0812L15.9223 8.58122L5.73961 18.7639C5.64628 18.8572 5.59961 18.9692 5.59961 19.0999ZM22.1289 9.37455C22.4929 9.01055 22.4929 8.42255 22.1289 8.05855L19.9449 5.87455C19.7706 5.69978 19.5338 5.60156 19.2869 5.60156C19.0401 5.60156 18.8033 5.69978 18.6289 5.87455L16.9209 7.58255L20.4209 11.0825L22.1289 9.37455Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const TeamSportIcon = () => {
    return (
        <svg
            width="24"
            height="32"
            viewBox="0 0 22 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 6C16.66 6 17.99 4.66 17.99 3C17.99 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 4.66 13.34 6 15 6ZM7 6C8.66 6 9.99 4.66 9.99 3C9.99 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3C4 4.66 5.34 6 7 6ZM7 8C4.67 8 0 9.17 0 11.5V13C0 13.55 0.45 14 1 14H13C13.55 14 14 13.55 14 13V11.5C14 9.17 9.33 8 7 8ZM15 8C14.71 8 14.38 8.02 14.03 8.05C14.05 8.06 14.06 8.08 14.07 8.09C15.21 8.92 16 10.03 16 11.5V13C16 13.35 15.93 13.69 15.82 14H21C21.55 14 22 13.55 22 13V11.5C22 9.17 17.33 8 15 8Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const PendingTeamMemberIcon = () => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.4325 9.85L20.8725 11.29L15.9925 16.17L12.7025 12.88C12.5157 12.6927 12.262 12.5875 11.9975 12.5875C11.733 12.5875 11.4793 12.6927 11.2925 12.88L5.2925 18.89C4.9025 19.28 4.9025 19.91 5.2925 20.3C5.6825 20.69 6.3125 20.69 6.7025 20.3L11.9925 15L15.2825 18.29C15.6725 18.68 16.3025 18.68 16.6925 18.29L22.2825 12.71L23.7225 14.15C24.0325 14.46 24.5725 14.24 24.5725 13.8V9.5C24.5825 9.22 24.3625 9 24.0825 9H19.7925C19.3425 9 19.1225 9.54 19.4325 9.85Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const DeclinedTeamMemberIcon = () => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.89 11.7L15 13.59L13.11 11.7C12.9232 11.5127 12.6695 11.4075 12.405 11.4075C12.1405 11.4075 11.8868 11.5127 11.7 11.7C11.31 12.09 11.31 12.72 11.7 13.11L13.59 15L11.7 16.89C11.31 17.28 11.31 17.91 11.7 18.3C12.09 18.69 12.72 18.69 13.11 18.3L15 16.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L16.41 15L18.3 13.11C18.69 12.72 18.69 12.09 18.3 11.7C17.91 11.32 17.27 11.32 16.89 11.7ZM15 5C9.47 5 5 9.47 5 15C5 20.53 9.47 25 15 25C20.53 25 25 20.53 25 15C25 9.47 20.53 5 15 5ZM15 23C10.59 23 7 19.41 7 15C7 10.59 10.59 7 15 7C19.41 7 23 10.59 23 15C23 19.41 19.41 23 15 23Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const ApprovedTeamMemberIcon = () => {
    return (
        <svg
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 19.1738H11C11.55 19.1738 12 19.6238 12 20.1738C12 20.7238 11.55 21.1738 11 21.1738H1C0.45 21.1738 0 20.7238 0 20.1738C0 19.6238 0.45 19.1738 1 19.1738ZM4.24 6.24376L7.07 3.41376L19.8 16.1438C20.58 16.9238 20.58 18.1938 19.8 18.9738C19.02 19.7538 17.75 19.7538 16.97 18.9738L4.24 6.24376ZM12.73 0.583756L15.56 3.41376C16.34 4.19376 16.34 5.46376 15.56 6.24376L14.14 7.66376L8.49 2.00376L9.9 0.593756C10.68 -0.196244 11.95 -0.196244 12.73 0.583756ZM2.83 7.65376L8.49 13.3138L7.08 14.7238C6.3 15.5038 5.03 15.5038 4.25 14.7238L1.42 11.8938C0.64 11.1138 0.64 9.84376 1.42 9.06376L2.83 7.65376Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const GenerateMatchIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.4303 9.98732L13.9996 16.418L8.78228 11.2007H12.1329C12.6463 11.2007 13.0663 10.7807 13.0663 10.2673C13.0663 9.75398 12.6463 9.33398 12.1329 9.33398H6.53294C6.01961 9.33398 5.59961 9.75398 5.59961 10.2673V15.8673C5.59961 16.3807 6.01961 16.8007 6.53294 16.8007C7.04628 16.8007 7.46628 16.3807 7.46628 15.8673V12.5167L13.3369 18.3873C13.7009 18.7513 14.2889 18.7513 14.6529 18.3873L21.7369 11.3033C22.1009 10.9393 22.1009 10.3513 21.7369 9.98732C21.3823 9.63265 20.7849 9.63265 20.4303 9.98732Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const MatchLocationIcon = () => {
    return (
        <svg
            className="shrink-0"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 11C21 7.69 18.31 5 15 5C11.69 5 9 7.69 9 11C9 14.49 12.62 19.19 14.23 21.12C14.63 21.6 15.36 21.6 15.76 21.12C17.38 19.19 21 14.49 21 11ZM13 11C13 9.9 13.9 9 15 9C16.1 9 17 9.9 17 11C17 12.1 16.11 13 15 13C13.9 13 13 12.1 13 11ZM8 24C8 24.55 8.45 25 9 25H21C21.55 25 22 24.55 22 24C22 23.45 21.55 23 21 23H9C8.45 23 8 23.45 8 24Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const MatchTimeIcon = () => {
    return (
        <svg
            className="shrink-0"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.99 5C9.47 5 5 9.48 5 15C5 20.52 9.47 25 14.99 25C20.52 25 25 20.52 25 15C25 9.48 20.52 5 14.99 5ZM15 23C10.58 23 7 19.42 7 15C7 10.58 10.58 7 15 7C19.42 7 23 10.58 23 15C23 19.42 19.42 23 15 23ZM14.78 10H14.72C14.32 10 14 10.32 14 10.72V15.44C14 15.79 14.18 16.12 14.49 16.3L18.64 18.79C18.98 18.99 19.42 18.89 19.62 18.55C19.83 18.21 19.72 17.76 19.37 17.56L15.5 15.26V10.72C15.5 10.32 15.18 10 14.78 10Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const RatingIcon =
    'M0 4H4V0H0V4ZM6 16H10V12H6V16ZM0 16H4V12H0V16ZM0 10H4V6H0V10ZM6 10H10V6H6V10ZM12 0V4H16V0H12ZM6 4H10V0H6V4ZM12 10H16V6H12V10ZM12 16H16V12H12V16Z'

export const MatchesIcon =
    'M6 3H18C18.55 3 19 2.55 19 2C19 1.45 18.55 1 18 1H6C5.45 1 5 1.45 5 2C5 2.55 5.45 3 6 3ZM18 13H6C5.45 13 5 13.45 5 14C5 14.55 5.45 15 6 15H18C18.55 15 19 14.55 19 14C19 13.45 18.55 13 18 13ZM18 7H6C5.45 7 5 7.45 5 8C5 8.55 5.45 9 6 9H18C18.55 9 19 8.55 19 8C19 7.45 18.55 7 18 7ZM2.5 12H0.5C0.22 12 0 12.22 0 12.5C0 12.78 0.22 13 0.5 13H2V13.5H1.5C1.22 13.5 1 13.72 1 14C1 14.28 1.22 14.5 1.5 14.5H2V15H0.5C0.22 15 0 15.22 0 15.5C0 15.78 0.22 16 0.5 16H2.5C2.78 16 3 15.78 3 15.5V12.5C3 12.22 2.78 12 2.5 12ZM0.5 1H1V3.5C1 3.78 1.22 4 1.5 4C1.78 4 2 3.78 2 3.5V0.5C2 0.22 1.78 0 1.5 0H0.5C0.22 0 0 0.22 0 0.5C0 0.78 0.22 1 0.5 1ZM2.5 6H0.5C0.22 6 0 6.22 0 6.5C0 6.78 0.22 7 0.5 7H1.8L0.12 8.96C0.04 9.05 0 9.17 0 9.28V9.5C0 9.78 0.22 10 0.5 10H2.5C2.78 10 3 9.78 3 9.5C3 9.22 2.78 9 2.5 9H1.2L2.88 7.04C2.96 6.95 3 6.83 3 6.72V6.5C3 6.22 2.78 6 2.5 6Z    '

export const PhasesIcon = () => {
    return (
        <svg
            viewBox="-1 -4 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.91687 14.6036C8.58087 14.8649 8.10487 14.8649 7.76887 14.6036L2.02887 10.1423C1.69429 9.88096 1.22478 9.88096 0.890203 10.1423C0.414203 10.5156 0.414203 11.2343 0.890203 11.6076L7.19954 16.5169C7.87154 17.0396 8.8142 17.0396 9.49554 16.5169L15.8049 11.6076C16.2809 11.2343 16.2809 10.5156 15.8049 10.1423L15.7955 10.1329C15.461 9.87162 14.9914 9.87162 14.6569 10.1329L8.91687 14.6036ZM9.50487 11.7849L15.8142 6.87561C16.2902 6.50228 16.2902 5.77428 15.8142 5.40094L9.50487 0.491609C8.83287 -0.0310573 7.8902 -0.0310573 7.20887 0.491609L0.899536 5.41028C0.423536 5.78361 0.423536 6.51161 0.899536 6.88494L7.20887 11.7943C7.88087 12.3169 8.83287 12.3169 9.50487 11.7849Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const CurrencyIcon = ({
    viewBox = '0 0 18 18',
    width = 18,
    height = 18,
}: {
    viewBox?: string
    width?: number
    height?: number
}) => {
    return (
        <svg
            viewBox={viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 15.5C9.49 15.5 7.32 14.08 6.24 12H11C11.55 12 12 11.55 12 11C12 10.45 11.55 10 11 10H5.58C5.53 9.67 5.5 9.34 5.5 9C5.5 8.66 5.53 8.33 5.58 8H11C11.55 8 12 7.55 12 7C12 6.45 11.55 6 11 6H6.24C7.32 3.92 9.5 2.5 12 2.5C13.25 2.5 14.42 2.86 15.42 3.47C15.92 3.78 16.57 3.73 16.99 3.31C17.57 2.73 17.44 1.78 16.74 1.35C15.36 0.5 13.73 0 12 0C8.08 0 4.76 2.51 3.52 6H1C0.45 6 0 6.45 0 7C0 7.55 0.45 8 1 8H3.06C3.02 8.33 3 8.66 3 9C3 9.34 3.02 9.67 3.06 10H1C0.45 10 0 10.45 0 11C0 11.55 0.45 12 1 12H3.52C4.76 15.49 8.08 18 12 18C13.74 18 15.36 17.51 16.74 16.65C17.43 16.22 17.56 15.26 16.98 14.68C16.56 14.26 15.91 14.21 15.41 14.53C14.42 15.15 13.26 15.5 12 15.5Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const TimeClockIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM9.78 5H9.72C9.32 5 9 5.32 9 5.72V10.44C9 10.79 9.18 11.12 9.49 11.3L13.64 13.79C13.98 13.99 14.42 13.89 14.62 13.55C14.83 13.21 14.72 12.76 14.37 12.56L10.5 10.26V5.72C10.5 5.32 10.18 5 9.78 5Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const BadgeIcon = ({ size = 'md' }: { size?: string }) => {
    const dimensions = {
        sm: { width: 12, height: 14 },
        md: { width: 16, height: 19 },
        lg: { width: 20, height: 24 },
        xl: { width: 24, height: 28 },
    }

    // Get dimensions based on size or default to md
    const { width, height } =
        dimensions[size as keyof typeof dimensions] || dimensions.md
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.99935 18.1665V11.3123L0.291016 6.9165L4.14518 0.666504H11.8535L15.7077 6.9165L12.9994 11.3123V18.1665L7.99935 16.4998L2.99935 18.1665ZM4.66602 15.854L7.99935 14.7498L11.3327 15.854V13.1665H4.66602V15.854ZM5.08268 2.33317L2.24935 6.9165L5.08268 11.4998H10.916L13.7494 6.9165L10.916 2.33317H5.08268ZM7.12435 10.3123L4.16602 7.37484L5.35352 6.18734L7.12435 7.95817L10.6452 4.4165L11.8327 5.58317L7.12435 10.3123Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const BadgeActionButtonIcon = () => {
    return (
        <svg
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.0007 23.8335C15.459 23.8335 16.6986 23.3231 17.7194 22.3022C18.7402 21.2814 19.2507 20.0418 19.2507 18.5835C19.2507 17.1252 18.7402 15.8856 17.7194 14.8647C16.6986 13.8439 15.459 13.3335 14.0007 13.3335C12.5423 13.3335 11.3027 13.8439 10.2819 14.8647C9.26107 15.8856 8.75065 17.1252 8.75065 18.5835C8.75065 20.0418 9.26107 21.2814 10.2819 22.3022C11.3027 23.3231 12.5423 23.8335 14.0007 23.8335ZM10.5882 11.8168C10.977 11.6029 11.3902 11.4328 11.8277 11.3064C12.2652 11.18 12.7076 11.0974 13.1548 11.0585L10.209 5.16683H7.29232L10.5882 11.8168ZM17.4131 11.8168L20.7381 5.16683H17.7923L15.3132 10.1252L15.8673 11.2335C16.1395 11.3113 16.402 11.3939 16.6548 11.4814C16.9076 11.5689 17.1604 11.6807 17.4131 11.8168ZM7.46732 22.4335C7.13676 21.8696 6.87912 21.262 6.6944 20.6106C6.50968 19.9592 6.41732 19.2835 6.41732 18.5835C6.41732 17.8835 6.50968 17.2078 6.6944 16.5564C6.87912 15.905 7.13676 15.2974 7.46732 14.7335C6.65065 15.0057 5.97982 15.487 5.45482 16.1772C4.92982 16.8675 4.66732 17.6696 4.66732 18.5835C4.66732 19.4974 4.92982 20.2995 5.45482 20.9897C5.97982 21.68 6.65065 22.1613 7.46732 22.4335ZM20.534 22.4335C21.3507 22.1613 22.0215 21.68 22.5465 20.9897C23.0715 20.2995 23.334 19.4974 23.334 18.5835C23.334 17.6696 23.0715 16.8675 22.5465 16.1772C22.0215 15.487 21.3507 15.0057 20.534 14.7335C20.8645 15.2974 21.1222 15.905 21.3069 16.5564C21.4916 17.2078 21.584 17.8835 21.584 18.5835C21.584 19.2835 21.4916 19.9592 21.3069 20.6106C21.1222 21.262 20.8645 21.8696 20.534 22.4335ZM14.0007 26.1668C13.2229 26.1668 12.4791 26.055 11.7694 25.8314C11.0597 25.6078 10.4034 25.3015 9.80065 24.9127C9.62565 24.9515 9.45065 24.9759 9.27565 24.9856C9.10065 24.9953 8.91593 25.0002 8.72148 25.0002C6.95204 25.0002 5.4451 24.3779 4.20065 23.1335C2.95621 21.889 2.33398 20.3821 2.33398 18.6127C2.33398 16.921 2.89787 15.4724 4.02565 14.2668C5.15343 13.0613 6.54371 12.3904 8.19648 12.2543L3.50065 2.8335H11.6673L14.0007 7.50016L16.334 2.8335H24.5007L19.834 12.196C21.4868 12.3516 22.8722 13.0321 23.9902 14.2377C25.1083 15.4432 25.6673 16.8918 25.6673 18.5835C25.6673 20.3724 25.0451 21.889 23.8006 23.1335C22.5562 24.3779 21.0395 25.0002 19.2507 25.0002C19.0756 25.0002 18.8958 24.9953 18.7111 24.9856C18.5263 24.9759 18.3465 24.9515 18.1715 24.9127C17.5687 25.3015 16.9173 25.6078 16.2173 25.8314C15.5173 26.055 14.7784 26.1668 14.0007 26.1668ZM11.8423 21.7918L12.659 19.1377L10.5007 17.5918H13.1548L14.0007 14.7918L14.8465 17.5918H17.5007L15.3423 19.1377L16.159 21.7918L14.0007 20.1585L11.8423 21.7918Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const AttendingSessionButtonIcon = () => {
    return (
        <svg
            width="30"
            height="32"
            viewBox="0 -2 24 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.7329 8.5665H5.26628C4.75294 8.5665 4.33294 8.9865 4.33294 9.49984C4.33294 10.0132 4.75294 10.4332 5.26628 10.4332H12.7329C13.2463 10.4332 13.6663 10.0132 13.6663 9.49984C13.6663 8.9865 13.2463 8.5665 12.7329 8.5665ZM15.5329 2.03317H14.5996V1.09984C14.5996 0.586504 14.1796 0.166504 13.6663 0.166504C13.1529 0.166504 12.7329 0.586504 12.7329 1.09984V2.03317H5.26628V1.09984C5.26628 0.586504 4.84628 0.166504 4.33294 0.166504C3.81961 0.166504 3.39961 0.586504 3.39961 1.09984V2.03317H2.46628C1.43028 2.03317 0.599609 2.87317 0.599609 3.89984V16.9665C0.599609 17.9932 1.43028 18.8332 2.46628 18.8332H15.5329C16.5596 18.8332 17.3996 17.9932 17.3996 16.9665V3.89984C17.3996 2.87317 16.5596 2.03317 15.5329 2.03317ZM14.5996 16.9665H3.39961C2.88628 16.9665 2.46628 16.5465 2.46628 16.0332V6.69984H15.5329V16.0332C15.5329 16.5465 15.1129 16.9665 14.5996 16.9665ZM9.93294 12.2998H5.26628C4.75294 12.2998 4.33294 12.7198 4.33294 13.2332C4.33294 13.7465 4.75294 14.1665 5.26628 14.1665H9.93294C10.4463 14.1665 10.8663 13.7465 10.8663 13.2332C10.8663 12.7198 10.4463 12.2998 9.93294 12.2998Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const DeclineSessionButtonIcon = () => {
    return (
        <svg
            width="30"
            height="32"
            viewBox="-2 -4 24 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.87028 12.5041C8.23428 12.8681 8.82228 12.8681 9.18628 12.5041L12.5369 9.15343C12.9009 8.78943 12.9009 8.20143 12.5369 7.83743L9.18628 4.48676C9.0119 4.312 8.77516 4.21378 8.52828 4.21378C8.28139 4.21378 8.04465 4.312 7.87028 4.48676C7.50628 4.85076 7.50628 5.43876 7.87028 5.80276L9.62494 7.56676H1.53294C1.01961 7.56676 0.599609 7.98676 0.599609 8.5001C0.599609 9.01343 1.01961 9.43343 1.53294 9.43343H9.62494L7.87028 11.1881C7.50628 11.5521 7.51561 12.1494 7.87028 12.5041ZM15.5329 0.100098H2.46628C1.43028 0.100098 0.599609 0.940098 0.599609 1.96676V4.76676C0.599609 5.2801 1.01961 5.7001 1.53294 5.7001C2.04628 5.7001 2.46628 5.2801 2.46628 4.76676V2.9001C2.46628 2.38676 2.88628 1.96676 3.39961 1.96676H14.5996C15.1129 1.96676 15.5329 2.38676 15.5329 2.9001V14.1001C15.5329 14.6134 15.1129 15.0334 14.5996 15.0334H3.39961C2.88628 15.0334 2.46628 14.6134 2.46628 14.1001V12.2334C2.46628 11.7201 2.04628 11.3001 1.53294 11.3001C1.01961 11.3001 0.599609 11.7201 0.599609 12.2334V15.0334C0.599609 16.0601 1.43961 16.9001 2.46628 16.9001H15.5329C16.5596 16.9001 17.3996 16.0601 17.3996 15.0334V1.96676C17.3996 0.940098 16.5596 0.100098 15.5329 0.100098Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const FilterCalendarIcon = () => {
    return (
        <svg
            viewBox="-1 0 22 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.466 2.6H16.5327V1.66667C16.5327 1.15334 16.1127 0.733337 15.5993 0.733337C15.086 0.733337 14.666 1.15334 14.666 1.66667V2.6H5.33268V1.66667C5.33268 1.15334 4.91268 0.733337 4.39935 0.733337C3.88602 0.733337 3.46602 1.15334 3.46602 1.66667V2.6H2.53268C1.50602 2.6 0.666016 3.44 0.666016 4.46667V19.4C0.666016 20.4267 1.50602 21.2667 2.53268 21.2667H17.466C18.4927 21.2667 19.3327 20.4267 19.3327 19.4V4.46667C19.3327 3.44 18.4927 2.6 17.466 2.6ZM16.5327 19.4H3.46602C2.95268 19.4 2.53268 18.98 2.53268 18.4667V7.26667H17.466V18.4667C17.466 18.98 17.046 19.4 16.5327 19.4Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const BookSessionIcon = () => {
    return (
        <svg
            viewBox="0 -1 20 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0329 2.53341H11.1316C10.7396 1.45075 9.71294 0.666748 8.49961 0.666748C7.28628 0.666748 6.25961 1.45075 5.86761 2.53341H1.96628C0.939609 2.53341 0.0996094 3.37341 0.0996094 4.40008V17.4667C0.0996094 18.4934 0.939609 19.3334 1.96628 19.3334H15.0329C16.0596 19.3334 16.8996 18.4934 16.8996 17.4667V4.40008C16.8996 3.37341 16.0596 2.53341 15.0329 2.53341ZM8.49961 2.53341C9.01294 2.53341 9.43294 2.95341 9.43294 3.46675C9.43294 3.98008 9.01294 4.40008 8.49961 4.40008C7.98628 4.40008 7.56628 3.98008 7.56628 3.46675C7.56628 2.95341 7.98628 2.53341 8.49961 2.53341ZM12.2329 13.7334H8.49961V16.5334L4.15961 12.1934C3.97294 12.0067 3.97294 11.7174 4.15961 11.5307L8.49961 7.20008V10.0001H12.2329V13.7334Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}

export const CancelSessionIcon = () => {
    return (
        <svg
            viewBox="0 -1 24 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.8991 0.599976H2.09909C1.07242 0.599976 0.232422 1.43998 0.232422 2.46664V15.5333C0.232422 16.56 1.07242 17.4 2.09909 17.4H18.8991C19.9258 17.4 20.7658 16.56 20.7658 15.5333V2.46664C20.7658 1.43998 19.9258 0.599976 18.8991 0.599976ZM18.8991 14.6C18.8991 15.1133 18.4791 15.5333 17.9658 15.5333H3.03242C2.51909 15.5333 2.09909 15.1133 2.09909 14.6V3.39998C2.09909 2.88664 2.51909 2.46664 3.03242 2.46664H17.9658C18.4791 2.46664 18.8991 2.88664 18.8991 3.39998V14.6ZM13.5698 5.91998C13.3954 5.74521 13.1586 5.64699 12.9118 5.64699C12.6649 5.64699 12.4281 5.74521 12.2538 5.91998L10.4991 7.68398L8.73509 5.91998C8.56071 5.74521 8.32397 5.64699 8.07709 5.64699C7.8302 5.64699 7.59346 5.74521 7.41909 5.91998C7.05509 6.28398 7.05509 6.87198 7.41909 7.23598L9.18309 8.99998L7.41909 10.764C7.05509 11.128 7.05509 11.716 7.41909 12.08C7.78309 12.444 8.37109 12.444 8.73509 12.08L10.4991 10.316L12.2631 12.08C12.6271 12.444 13.2151 12.444 13.5791 12.08C13.9431 11.716 13.9431 11.128 13.5791 10.764L11.8151 8.99998L13.5791 7.23598C13.9338 6.88131 13.9338 6.28398 13.5698 5.91998Z"
                fill="#C3CAD9"
                stroke="none"
            />
        </svg>
    )
}
